<template>
  <div class="avecor-table" :style="getContainerStyle()">
    <!-- TABLE --->
    <div style="position:absolute; left:6px; ">
      <!-- <span >
        <v-icon 
          class="avecor-table-actions"
          :size="14"
          @click="settings.snackSettings.snack = false;selectedOrderId='';selectedOrderedProductIdInMargins=''"
        >
          far fa-window-close
        </v-icon>
        <v-icon 
          v-if="!isOrderDisabled"
          class="avecor-table-actions ml-2"
          :size="14"
          @click="addOrderedProduct(selectedOrderId)"
        >
          far fa-plus-square
        </v-icon>
        <v-icon 
          v-if="allAccess"
          class="avecor-table-actions ml-2"
          :size="12"
          @click="!pinnedOrdersInOrders.includes(selectedOrderId) ? pinnedOrdersInOrders.push(selectedOrderId) : ''"
        >
          fas fa-paperclip
        </v-icon>
        <v-icon :size="12" v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="ml-2" @click="copyToClipboard(selectedOrderId)" >far fa-id-badge</v-icon>
      </span> -->
      <!-- <span class="ml-2" v-if="isNormalOrder">
        <div class="" style="display:inline-block;height:26px;">
          <v-chip
            v-if="allAccess"  
            pill
            dense
            x-small
            :color="isOrderDisabledForSalesperson ? 'red' : 'green'"
            text-color="white"
          >{{isOrderDisabledForSalesperson ? 'Myyjä ei voi muokata.' : 'Myyjä voi muokata.'}}</v-chip>
          <v-chip
            v-else
            pill
            dense
            x-small
            :color="isOrderDisabledForSalesperson ? 'red' : 'green'"
            text-color="white"
          >{{isOrderDisabled ? 'Tilausta ei voi muokata. Ota yhteyttä toimistoon.' : 'Muokkaus sallittu.'}}</v-chip>
        </div>
        <div style="display:inline-block;line-height:26px;position:relative;top:2px;" class="pl-2" v-if="isNormalOrder && allAccess">
          <v-switch
            :value="selectedOrder.salespersonCanEdit"
            inset
            dense
            hide-details
            :color="selectedOrder.salespersonCanEdit ? 'success' : 'red'"
            class="mt-0 pt-0"
            style="display:inline-block;margin-top:2px;font-size:8px;"
            label="Salli muokkaukset vaikka status muu kuin uusi."
            @click="inlineSaveOrderDetails('salespersonCanEdit',selectedOrder.salespersonCanEdit ? !selectedOrder.salespersonCanEdit : true)"
          ></v-switch>
        </div>
      </span> -->
    </div>
    <!-- <div style="position:absolute; right:10px; top:10px;">
      <v-icon 
        class="avecor-table-actions"
        :size="16"
        style="padding-right:10px"
        @click="setAllProductOrderStatusesToSentToCustomer();"
      >
        fas fa-check-double
      </v-icon>
    </div> -->
      <v-row no-gutters justify-center class="pt-0 pb-0">
        <v-col sm="4" class="text-left pl-2" style="font-size:18px;">
          <span >
            <v-icon 
              v-if="displayType !== 'inline'"
              class="avecor-table-actions mr-2"
              :size="14"
              @click="settings.snackSettings.snack = false;selectedOrderId='';selectedOrderedProductIdInMargins=''"
            >
              far fa-window-close
            </v-icon>
            <v-icon 
              v-if="!searchOrders[selectedOrderId]"
              class="avecor-table-actions"
              :size="14"
              @click="addOrderedProduct(selectedOrderId)"
            >
              far fa-plus-square
            </v-icon>
            <v-icon 
              v-if="allAccess"
              class="avecor-table-actions ml-2"
              :size="12"
              @click="!pinnedOrdersInOrders.includes(selectedOrderId) ? pinnedOrdersInOrders.push(selectedOrderId) : ''"
            >
              fas fa-paperclip
            </v-icon>
          </span>
          <span class="ml-2" v-if="isNormalOrder">
            <div class="" style="display:inline-block;height:26px;">
              <v-chip
                v-if="allAccess"  
                pill
                dense
                x-small
                :color="isOrderDisabledForSalesperson ? 'red' : 'green'"
                text-color="white"
              >{{isOrderDisabledForSalesperson ? 'Myyjä ei voi muokata.' : 'Myyjä voi muokata.'}}</v-chip>
              <v-chip
                v-else
                pill
                dense
                x-small
                :color="isOrderDisabledForSalesperson ? 'red' : 'green'"
                text-color="white"
              >{{isOrderDisabled ? 'Tilausta ei voi muokata. Ota yhteyttä toimistoon.' : 'Muokkaus sallittu.'}}</v-chip>
            </div>
            <div style="display:inline-block;line-height:26px;position:relative;top:2px;" class="pl-2" v-if="isNormalOrder && allAccess">
              <v-switch
                :value="selectedOrder.salespersonCanEdit"
                inset
                dense
                hide-details
                :color="selectedOrder.salespersonCanEdit ? 'success' : 'red'"
                class="mt-0 pt-0"
                style="display:inline-block;margin-top:2px;font-size:8px;"
                label="Salli muokkaukset vaikka status muu kuin uusi."
                @click="inlineSaveOrderDetails('salespersonCanEdit',selectedOrder.salespersonCanEdit ? !selectedOrder.salespersonCanEdit : true)"
              ></v-switch>
            </div>
          </span>
          <span style="float:right;" v-if="selectedOrder.isOffer">
            <button class="avecor-button-global small-add-button"
              @click="draftsModalOpen = true"
              style="padding-bottom:10px !important;">HAE VEDOKSET</button>
          </span>
        </v-col>
        <v-col sm="3" class="text-center" style="font-size:16px;">
          {{companies[selectedOrder.companyId].companyName}}
        </v-col>
        <v-col sm="5" class="text-right pr-2" style="font-size:18px;">
          <div v-if="isOrderSalespersonMarginDisabled" style="display:inline-block;" class="text-left">
            <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100"  >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" >
                  <v-icon 
                    :size="8"
                    style="padding-left:1px;color:blue;"
                    class="mr-3"
                    @click="syncOrderToNetvisor(selectedOrderId,settings.env)"
                  >
                    fas fa-exchange-alt
                  </v-icon>
                </span>
              </template>
              <div style="font-size:11px;background:#FFF;padding:10px;">
                <div>Synkronoi Netvisoriin.</div>
              </div>
            </v-menu>
            <div class="" style="font-size:10px;line-height:18px;font-weight:600;width:90px;display:inline-block;vertical-align:middle;">
              Toim.kulut kate
              <i class="fas fa-pencil-alt pointer" :style="' font-size:8px;margin-right:2px;padding-left:2px;color:#000'" @click="setMarginDeliveryCharge = !setMarginDeliveryCharge"></i>
            </div>
            <input v-if="setMarginDeliveryCharge" :value="selectedOrder.marginDeliveryCharge ? selectedOrder.marginDeliveryCharge : ''" type="text"  class="" style="padding-left:3px;padding-top:2px;font-size:10px;line-height:16px;font-weight:400;width:30px;display:inline-block;vertical-align:middle;background:#ddd;" @change="v => inlineSaveOrderDetails('marginDeliveryCharge',v.target.value)">
            <div v-else class="" style="padding-left:3px;padding-top:2px;font-size:10px;line-height:16px;font-weight:400;width:30px;display:inline-block;vertical-align:middle;background:white;">{{getDeliveryMargin()}}€</div>
            
            <div class="" style="font-size:10px;line-height:18px;font-weight:600;width:110px;display:inline-block;vertical-align:middle;">Toimiston lask. kate</div>
            <div class="" style="padding-left:3px;padding-top:2px;font-size:10px;line-height:16px;font-weight:400;width:50px;display:inline-block;vertical-align:middle;background:white;">{{totalOfficeMarginForOrder}}€</div>
            <div class="ml-2" style="font-size:10px;line-height:18px;font-weight:600;width:90px;display:inline-block;vertical-align:middle;">Myyj. lask. kate</div>
            <div class="mr-3" style="padding-left:3px;padding-top:2px;font-size:10px;line-height:16px;font-weight:400;width:50px;display:inline-block;vertical-align:middle;background:white;">{{totalSalespersonMarginForOrder}}€</div>
          </div>
          <div v-else style="display:inline-block;" class="text-left">
            <div class="" style="font-size:11px;line-height:18px;font-weight:600;width:90px;display:inline-block;vertical-align:middle;">Toimiston kate</div>
            <v-text-field
              placeholder=""
              :disabled="!allAccess || !isNormalOrder"
              @change="v => inlineSaveOrderDetails('officeMargin',v)"
              :value="selectedOrder.officeMargin"
              hide-details
              dense
              class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
              style="width:50px;"
            ></v-text-field>
            <div class="ml-3" style="font-size:11px;line-height:18px;font-weight:600;width:70px;display:inline-block;vertical-align:middle;">Myyjän kate</div>
            <v-text-field
              placeholder=""
              :disabled="!isNormalOrder || isOrderSalespersonMarginDisabled"
              @change="v => inlineSaveOrderDetails('salespersonMargin',v)"
              :value="selectedOrder.salespersonMargin"
              hide-details
              dense
              class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
              style="width:50px;"
            ></v-text-field>
          </div>
          <span v-if="location !== 'offers'">
            <button v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="avecor-button-global small-add-button mr-1" @click="orderInvoicingModalEnv = 'development';orderInvoicingModalVisible = true;orderInvoicingModalOrderId = selectedOrderId;" style="padding-bottom:10px !important;">LASKUTA (DEV)</button>
            <button v-if="allAccess" class="avecor-button-global small-add-button mr-1" @click="orderInvoicingModalEnv = 'production';orderInvoicingModalVisible = true;orderInvoicingModalOrderId = selectedOrderId;" style="padding-bottom:10px !important;">LASKUTA</button>
          </span>
        </v-col>
          
      </v-row>
      <v-row no-gutters justify-center class="pl-1 pt-0 pb-1">
        <v-col cols="9">
          <v-row no-gutters>
            <v-col cols="5"  class="pr-1">
              <!-- TILAUKSEN TIEDOT -->
              <v-row no-gutters style="background:#fff;border:1px #ccc dotted;" class="pa-1 pt-0">
                <v-col md="12" cols="2">
                  <div style="padding-right:3px;font-size:11px;font-weight:600;display:inline-block;">TILAUKSEN TIEDOT
                    <v-icon :size="10" v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="ml-2" @click="copyToClipboard(selectedOrderId)" >far fa-id-badge</v-icon>
                  </div>
                </v-col>
                <v-col md="6" cols="2">
                  <div class="order-expand-header-field-label">Tilauspaivä</div>
                  <v-menu
                    :nudge-right="80"
                    transition="fade-transition"
                    offset-y
                    style="display:inline-block"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        :value="customFormatter(selectedOrder.created_at,true)"
                        readonly
                        class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                        hide-details
                        dense
                        :disabled="isOrderDisabled"
                      ></v-text-field>
                    </template>
                    <v-date-picker @change="v => inlineSaveOrderDetails('created_at',v)" :value="customFormatter(selectedOrder.created_at)" locale="fi-fi"></v-date-picker>
                  </v-menu>
                  <div />
                  <!-- <div class="order-expand-header-field-label">Vastaava</div>
                  <v-autocomplete
                    :value="selectedOrder.orderResponsible"
                    :items="getOfficeStaff"
                    @change="v => inlineSaveOrderDetails('orderResponsible',v)"
                    persistent-hint
                    item-text="text"
                    item-value="id"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                  />
                  <div /> -->
                  <div class="order-expand-header-field-label">Myyjä</div>
                  <v-autocomplete
                    :value="selectedOrder.salesperson"
                    :items="getSalespersons"
                    @change="v => inlineSaveOrderSalesperson(v)"
                    persistent-hint
                    item-text="text"
                    item-value="id"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  />
                  <div v-if="selectedOrder.originalSalesperson" style="font-style: italic;font-size:11px;">Alkuperäinen myyjä: {{ staff[selectedOrder.originalSalesperson].firstName }}</div>
                  <div />
                  <div class="order-expand-header-field-label">Viite</div>
                  <v-text-field
                    placeholder=" "
                    :value="selectedOrder.billingReferenceDetails"
                    @change="v => inlineSaveOrderDetails('billingReferenceDetails',v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div />
                  <div class="order-expand-header-field-label">Netv.id</div>
                  <v-text-field
                    placeholder=" "
                    :value="selectedOrder.netvisorId"
                    @change="v => inlineSaveOrderDetails('netvisorId',v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  
                  
                  
                </v-col>
                <v-col md="6" cols="2" class="pr-2">
                  <div class="order-expand-header-field-label">Toim.kulut</div>
                  <v-text-field
                    placeholder=" "
                    :value="selectedOrder.deliveryCharge"
                    @change="v => inlineSaveOrderDetails('deliveryCharge',v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div />
                  <div style="border:1px dashed #ccc;font-size:10px;color:#666;padding:5px;display:inline-block;width:80%;" class=" px-2 py-1 mt-2">
                    <div><b>Toim./lask. lisätiedot</b></div>
                    <div>
                      <input :disabled="isOrderDisabled" style="height:10px;width:10px;vertical-align: middle;" type="checkbox" :checked="selectedOrder.deliveryBySalesperson" @change="inlineSaveOrderDetails('deliveryBySalesperson',!selectedOrder.deliveryBySalesperson)"/> 
                      <span style="vertical-align: middle;padding-left:5px;">Myyjä toimittaa</span>
                    </div>
                    <div>
                      <input :disabled="isOrderDisabled" style="height:10px;width:10px;vertical-align: middle;" type="checkbox" :checked="selectedOrder.isAmendmentOrder" @change="inlineSaveOrderDetails('isAmendmentOrder',!selectedOrder.isAmendmentOrder)"/> 
                      <span style="vertical-align: middle;padding-left:5px;">Lisätilaus</span>
                    </div>
                    <div>
                      <input :disabled="isOrderDisabled" style="height:10px;width:10px;vertical-align: middle;" type="checkbox" :checked="selectedOrder.splitInvoice" @change="inlineSaveOrderDetails('splitInvoice',!selectedOrder.splitInvoice)"/> 
                      <span style="vertical-align: middle;padding-left:5px;">Useampi laskuerä</span>
                    </div>
                    
                  </div>
                  
                  
                </v-col>
                
                
              </v-row>
            </v-col>
            <!-- YRITYKSEN TIEDOT -->
            <v-col cols="7"  class="pt-0 pr-1">
              <v-row no-gutters style="background:#fff;border:1px #ccc dotted;" class="pa-1 pt-0">
                <v-col md="12" cols="2">
                  <div style="padding-right:3px;font-size:11px;font-weight:600;display:inline-block;">YRITYKSEN TIEDOT
                    <v-icon :size="10" v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="ml-2" @click="copyToClipboard(selectedOrder.companyId)" >far fa-id-badge</v-icon>
                  </div>
                </v-col>
                <!-- <v-col md="1" cols="2" class="pr-2">
                  <v-autocomplete
                    label="Yritys"
                    :value="selectedOrder.companyId"
                    :items="getCompanies"
                    @change="v => inlineSaveOrderDetails('companyId',v)"
                    persistent-hint
                    item-text="text"
                    item-value="value"
                    class="avecor-select hide-field-details"
                  />
                </v-col> -->
                <v-col md="4" cols="2" class="pr-1">
                  <div class="order-expand-header-field-label">Yritys</div>
                  <v-autocomplete
                    :value="selectedOrder.companyId"
                    :items="getCompanies"
                    @change="v => inlineSaveOrderDetails('companyId',v)"
                    persistent-hint
                    item-text="text"
                    item-value="value"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  />
                  <div/>
                  <div class="order-expand-header-field-label">Nimi</div>
                  <v-text-field
                    placeholder=" "
                    :value="companies[selectedOrder.companyId].companyName"
                    @change="v => inlineSaveCompanyDetails('companyName', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div/>
                  <div class="order-expand-header-field-label">Y-tunnus</div>
                  <v-text-field
                    placeholder=" "
                    :value="companies[selectedOrder.companyId].companyId"
                    @change="v => inlineSaveCompanyDetails('companyId', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div/>
                  <div class="order-expand-header-field-label">Maksuehto</div>
                  <!-- <v-text-field
                    placeholder=" "
                    :value="companies[selectedOrder.companyId].paymentTerm"
                    @change="v => inlineSaveCompanyDetails('paymentTerm', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field> -->
                  <v-autocomplete
                    :value="companies[selectedOrder.companyId].paymentTermNetvisor"
                    :items="settings.paymentTerms"
                    @change="v => inlineSaveCompanyDetails('paymentTermNetvisor',v)"
                    hide-details
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                    item-text="text"
                    item-value="id"
                  />
                  <div v-if="!companies[selectedOrder.companyId].paymentTermNetvisor" style="font-style:italic;font-size:10px;color:#666;">Vanha arvo: {{companies[selectedOrder.companyId].paymentTerm}}</div>
                </v-col>
                <v-col md="4" cols="4" class="pr-1">
                  <div class="order-expand-header-field-label">Osoite</div>
                  <v-text-field
                    placeholder=" "
                    :value="companies[selectedOrder.companyId].deliveryAddress"
                    @change="v => inlineSaveCompanyDetails('deliveryAddress', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div/>
                  <div class="order-expand-header-field-label">Postikoodi</div>
                  <v-text-field
                    placeholder=" "
                    :value="companies[selectedOrder.companyId].deliveryPostalCode"
                    @change="v => inlineSaveCompanyDetails('deliveryPostalCode', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div/>
                  <div class="order-expand-header-field-label">Kaupunki</div>
                  <v-text-field
                    placeholder=" "
                    :value="companies[selectedOrder.companyId].deliveryCity"
                    @change="v => inlineSaveCompanyDetails('deliveryCity', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div/>
                  <div class="order-expand-header-field-label">Maa</div>
                  <v-text-field
                    placeholder=" "
                    :value="companies[selectedOrder.companyId].deliveryCountry"
                    @change="v => inlineSaveCompanyDetails('deliveryCountry', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div/>
                  <div class="order-expand-header-field-label" style="width:100px;">Tarjoukset estetty</div>
                  <input style="vertical-align: middle;height:11px;" type="checkbox" :checked="companies[selectedOrder.companyId].offersDisabled" @change="inlineSaveCompanyDetails('offersDisabled', !companies[selectedOrder.companyId].offersDisabled)"/> 
                </v-col>
                
                <v-col md="4" cols="2" class="pr-1">
                  
                  <div class="order-expand-header-field-label">Lask.form.</div>
                  <v-autocomplete
                    :value="companies[selectedOrder.companyId].billingFormat"
                    :items="getBillingFormats"
                    item-text="fi"
                    item-value="id"
                    @change="v => inlineSaveCompanyDetails('billingFormat', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  />
                  <div/>
                  
                  <div v-if="companies[selectedOrder.companyId].billingFormat === 'email'">
                    <div class="order-expand-header-field-label">Lask.sähköposti</div>
                    <v-text-field
                      placeholder=" "
                      :value="companies[selectedOrder.companyId].billingEmail"
                      @change="v => inlineSaveCompanyDetails('billingEmail', v)"
                      hide-details
                      dense
                      class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                      :disabled="isOrderDisabled"
                    ></v-text-field>
                  </div>
                  <div style="clear:both"/>
                  <!-- PAPERI -->
                  <div>
                    <div class="order-expand-header-field-label-wide" style="float:left;line-height:25px;width:unset !important;">Eri laskutusosoite?</div>
                    <div class="order-expand-header-field-value-checkbox pl-2" style="float:left;box-sizing:border-box;padding-top:1px;">
                      <input type="checkbox" :disabled="isOrderDisabled" :checked="companies[selectedOrder.companyId].differentBillingAddress" @change="v => inlineSaveCompanyDetails('differentBillingAddress', v)">
                    </div>
                  </div>
                  <div style="clear:both"/>
                  <div v-if="companies[selectedOrder.companyId].differentBillingAddress">
                    <div class="order-expand-header-field-label">Lask.osoite</div>
                    <v-text-field
                      placeholder=" "
                      :value="companies[selectedOrder.companyId].billingAddress"
                      @change="v => inlineSaveCompanyDetails('billingAddress', v)"
                      hide-details
                      dense
                      class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                      :disabled="isOrderDisabled"
                    ></v-text-field>
                    <div/>
                    <div class="order-expand-header-field-label">Lask.postik.</div>
                    <v-text-field
                      placeholder=" "
                      :value="companies[selectedOrder.companyId].billingPostalCode"
                      @change="v => inlineSaveCompanyDetails('billingPostalCode', v)"
                      hide-details
                      dense
                      class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                      :disabled="isOrderDisabled"
                    ></v-text-field>
                    <div/>
                    <div class="order-expand-header-field-label">Lask.kaup.</div>
                    <v-text-field
                      placeholder=" "
                      :value="companies[selectedOrder.companyId].billingCity"
                      @change="v => inlineSaveCompanyDetails('billingCity', v)"
                      hide-details
                      dense
                      class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                      :disabled="isOrderDisabled"
                    ></v-text-field>
                    <div/>
                    <div class="order-expand-header-field-label">Lask.maa</div>
                    <v-text-field
                      placeholder=" "
                      :value="companies[selectedOrder.companyId].billingCountry"
                      @change="v => inlineSaveCompanyDetails('billingCountry', v)"
                      hide-details
                      dense
                      class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                      :disabled="isOrderDisabled"
                    ></v-text-field>
                  </div>
                  <!-- SÄHKÖPSOTI -->
                  <!-- <div v-if="companies[selectedOrder.companyId].billingFormat === 'email'">
                    <div class="order-expand-header-field-label-wide" style="float:left;line-height:25px;width:unset !important;width:140px;">Eri laskutus sähköposti?</div>
                    <div class="order-expand-header-field-value-checkbox pl-0" style="float:left;padding-top:1px;">
                      <input type="checkbox" :checked="companies[selectedOrder.companyId].differentBillingEmail" @change="v => inlineSaveCompanyDetails('differentBillingEmail', v)">
                    </div>
                  </div> -->
                  
                  <div style="clear:both"/>
                  <!-- VERRKOLASKU -->
                  <div v-if="companies[selectedOrder.companyId].billingFormat === 'eInvoice'">
                    <div class="order-expand-header-field-label">Verk.lask.osoite</div>
                    <v-text-field
                      placeholder=" "
                      :value="companies[selectedOrder.companyId].eBillingAddress"
                      @change="v => inlineSaveCompanyDetails('eBillingAddress', v)"
                      hide-details
                      dense
                      class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                      :disabled="isOrderDisabled"
                    ></v-text-field>
                    <div />
                    <div class="order-expand-header-field-label">Operaattori</div>
                    <v-autocomplete
                      :value="companies[selectedOrder.companyId].eBillingOperator"
                      :items="settings.eBillingOperators"
                      @change="v => inlineSaveCompanyDetails('eBillingOperator', v)"
                      persistent-hint
                      item-text="name"
                      item-value="id"
                      hide-details
                      dense
                      class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                      :disabled="isOrderDisabled"
                    />
                    <div />
                    
                    <!-- <v-text-field
                      placeholder=" "
                      :value="companies[selectedOrder.companyId].eBillingOperator"
                      @change="v => inlineSaveCompanyDetails('eBillingOperator', v)"
                      hide-details
                      dense
                      class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    ></v-text-field> -->
                  </div>
                  <div class="order-expand-header-field-label" style="width:90px;">Tunnettu toimija</div>
                  <input style="vertical-align: middle;height:11px;" type="checkbox" :checked="companies[selectedOrder.companyId].knownOperator" @change="inlineSaveCompanyDetails('knownOperator', !companies[selectedOrder.companyId].knownOperator)"/> 
                  <div/>
                  


                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        
        <v-col cols="3">
          <v-row no-gutters>
            <!-- KONTAKTIN TIEDOT -->
            <v-col cols="12" class="pr-1">
              <v-row no-gutters style="background:#fff;border:1px #ccc dotted;" class="pa-1 pt-0">
                <v-col md="12" cols="2">
                  <div style="padding-right:3px;font-size:11px;font-weight:600;display:inline-block;">KONTAKTIN TIEDOT
                    <v-icon :size="10" v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="ml-2" @click="copyToClipboard(selectedOrder.contactId)" >far fa-id-badge</v-icon>
                  </div>
                </v-col>
                <!-- <v-col md="1" cols="2" class="pr-2">
                  <v-autocomplete
                    label="Yritys"
                    :value="selectedOrder.companyId"
                    :items="getCompanies"
                    @change="v => inlineSaveOrderDetails('companyId',v)"
                    persistent-hint
                    item-text="text"
                    item-value="value"
                    class="avecor-select hide-field-details"
                  />
                </v-col> -->
                <v-col md="6" cols="2" class="pr-2">
                  <div class="order-expand-header-field-label">Kontakti</div>
                  <v-autocomplete
                    spellcheck="false"
                    :value="selectedOrder.contactId"
                    :items="getContacts"
                    @change="v => inlineSaveOrderDetails('contactId',v)"
                    persistent-hint
                    item-text="text"
                    item-value="value"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                    
                  />
                  <div/>
                  <div class="order-expand-header-field-label">Nimi</div>
                  <v-text-field
                    spellcheck="false"
                    placeholder=" "
                    :value="contacts[selectedOrder.contactId].firstName"
                    @change="v => inlineSaveContactDetails('firstName', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    style="width:52px !important"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <v-text-field
                    spellcheck="false"
                    placeholder=" "
                    :value="contacts[selectedOrder.contactId].lastName"
                    @change="v => inlineSaveContactDetails('lastName', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    style="width:53px !important"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div/>
                  
                  <div class="order-expand-header-field-label">Sähköposti</div>
                  <v-text-field
                    spellcheck="false"
                    placeholder=" "
                    :value="contacts[selectedOrder.contactId].email"
                    @change="v => inlineSaveContactDetails('email', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div />
                  <div class="order-expand-header-field-label">Puh.numero</div>
                  <v-text-field
                    spellcheck="false"
                    placeholder=" "
                    :value="contacts[selectedOrder.contactId].phone"
                    @change="v => inlineSaveContactDetails('phone', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="2" class="pr-2">
                  <div class="order-expand-header-field-label">Vedos.sposti</div>
                  <v-text-field
                    placeholder=""
                    :value="getClientPrintDetailsEmail"
                    @change="v => inlineSaveContactDetails('clientPrintDetailsEmail', v)"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    :disabled="isOrderDisabled"
                  ></v-text-field>
                  <div />
                  <div class="order-expand-header-field-label" style="width:155px;">Lähetä vedos vain myyjälle</div>
                  <input style="vertical-align: middle;height:11px;margin-top:3px" type="checkbox" :checked="contacts[selectedOrder.contactId].sendDraftsToSalesperson" @change="inlineSaveContactDetails('sendDraftsToSalesperson', !contacts[selectedOrder.contactId].sendDraftsToSalesperson)"/> 
                </v-col>
              </v-row>
            </v-col>
            <!-- <v-col cols="4" style="background:#fff;border:1px #ccc dotted;" class="pa-1 pt-0">
              <v-row no-gutters class="">
                <v-col md="12" cols="2">
                  <div style="padding-right:3px;font-size:11px;font-weight:600;display:inline-block;">KATE TIEDOT</div>
                </v-col>
                <v-col md="12" cols="2" class="pr-2">
                  <div v-if="!isOrderSalespersonMarginDisabled" class="order-expand-header-field-label-wide" style="width:90px;">Toimiston kate</div>
                  <div v-else class="order-expand-header-field-label-wide" style="width:140px;">Toimiston lask. kate</div>
                  <v-text-field
                    v-if="!isOrderSalespersonMarginDisabled"
                    placeholder=""
                    :disabled="!allAccess || !isNormalOrder"
                    @change="v => inlineSaveOrderDetails('officeMargin',v)"
                    :value="selectedOrder.officeMargin"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    style="width:50px;"
                  ></v-text-field>
                  <div v-else class="avecor-select hide-field-details minimize-height mt-1 mt-0 order-expand-header-field-value" style="width:50px;font-size:11px;background:#FFF;">
                    {{totalOfficeMarginForOrder}}€
                  </div>
                  <div />
                  <div v-if="!isOrderSalespersonMarginDisabled" class="order-expand-header-field-label-wide" style="width:90px;">Myyjän kate</div>
                  <div v-else class="order-expand-header-field-label-wide" style="width:140px;">Myyj. lask. kate</div>
                  <v-text-field
                    v-if="!isOrderSalespersonMarginDisabled"
                    placeholder=""
                    :disabled="!isNormalOrder || isOrderSalespersonMarginDisabled"
                    @change="v => inlineSaveOrderDetails('salespersonMargin',v)"
                    :value="selectedOrder.salespersonMargin"
                    hide-details
                    dense
                    class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                    style="width:50px;"
                  ></v-text-field>
                  <div v-else class="avecor-select hide-field-details minimize-height mt-1 mt-0 order-expand-header-field-value" style="width:50px;font-size:11px;background:#FFF;">
                    {{totalSalespersonMarginForOrder}}€
                  </div>
                </v-col>
              </v-row>
            </v-col> -->
          </v-row>
        </v-col>
            
      </v-row>
      
      
    <MediaViewer :selectedFile="selectedFileForMediaViewer" />
    <div style="overflow-y:auto; max-height:400px; border-top: 2px solid #ddd;">
      <!-- MOBILE VIEW CODE CAN BE ADDED HERE IF NEEDED FROM UNUSED FOLDER-->
      
      <!-- DESKTOP -->
      <div v-if="device === 'desktop'">
        <v-data-table
          v-model="selected"
          :headers="getHeaders"
          :items="getOrderedProductsWithRefOps"
          :expanded.sync="expanded"
          :single-expand="singleExpand"
          item-key="id"
          :items-per-page="100"
          hide-default-footer
          hide-default-header
          class="avecor-ordered-products-table remove-overflow-y"
          dense
        >
          <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th :key="h.value+'-'+index" v-for="(h, index) in headers" :style="h.value === 'packageType' || h.value === 'select' ? 'font-size:8px;font-weight:300;vertical-align:top;color:#000;' : 'font-size:8px;font-weight:300;color:#000;'" class="px-1">
                    <div v-if="h.value !== 'batchStatusChange'"><span>{{h.text}}</span></div>
                    <div v-else><span></span></div>
                    <!-- <div >
                      {{h.value}}
                    </div> -->
                    
                    <div v-if="h.value === 'orderStatus'" style="max-height:35px;max-width:67px;z-index:1000">
                      <v-autocomplete
                        autocomplete="off"
                        v-model="batchOrderStatus"
                        :disabled="isOrderDisabled"
                        :items="batchStatuses"
                        @change="batchOrderUpdate('orderStatus')"
                        hide-details
                        dense
                        spellcheck="false"
                        item-text="text"
                        item-value="id"
                        class="avecor-select avecor-header-input mt-0 pt-0"
                        style="z-index:1000;background:#ddd"
                      />
                    </div>
                    <div v-if="h.value === 'shippedDate'" style="max-height:20px;z-index:1000" class="">
                      <v-menu
                        style="display:inline-block;"
                        :nudge-right="40"
                        transition="fade-transition"
                        offset-y
                        hide-details
                        min-width="30px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            :disabled="isOrderDisabled"
                            hide-details
                            class="avecor-date-picker  pa-0 ma-0"  
                            v-model="batchShippedDate"
                            placeholder="Valitse pvm"
                            style="max-height:30px;background:#DDD;"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="batchShippedDate" @change="batchOrderUpdate('shippedDate')" ></v-date-picker>
                      </v-menu>
                    </div>
                    <div v-if="h.value === 'orderInvoiceStatus'" style="max-height:35px;max-width:67px;z-index:1000">
                      <v-autocomplete
                        autocomplete="off"
                        :disabled="isOrderDisabled"
                        v-model="batchOrderInvoiceStatus"
                        :items="settings.orderedProductInvoiceStatusArray"
                        @change="batchOrderUpdate('orderInvoiceStatus')"
                        hide-details
                        dense
                        spellcheck="false"
                        item-text="text"
                        item-value="id"
                        class="avecor-select avecor-header-input mt-0 pt-0"
                        style="z-index:1000;background:#ddd"
                      />
                    </div>
                  
                    <div v-if="h.value === 'select'" style="line-height:30px;z-index:1000">
                      <v-icon v-if="allProductsSelected" style="padding-left:5px;margin-top:16px;" color="#555" size="12" @click="deselectAllProducts()">far fa-check-square</v-icon>
                      <v-icon v-else style="padding-left:5px;margin-top:16px;" color="#555" size="12" @click="selectAllProducts()">far fa-square</v-icon>
                    </div>

                    <div v-if="h.value === 'whenToInvoice'" style="max-height:20px;z-index:1000">
                      <v-menu
                        style="display:inline-block;"
                        :nudge-right="40"
                        transition="fade-transition"
                        offset-y
                        hide-details
                        min-width="30px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            :disabled="isOrderDisabled"
                            hide-details
                            class="avecor-date-picker pa-0 ma-0"  
                            v-model="batchInvoiceDate"
                            placeholder="Valitse pvm"
                            style="max-height:30px;background:#DDD"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="batchInvoiceDate" @change="batchOrderUpdate('whenToInvoice')" ></v-date-picker>
                      </v-menu>
                    </div>
                  </th>
                </tr>
              </thead>
          </template>
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr style="height:25px;" :class="getClassesForOpRow(item)">
              <td class="justify-center text-center pa-0" style="min-width:55px;max-width:75px !important;padding-right:2px;padding-left:3px;" >
                <div class="px-1">
                  <v-icon v-if="!item.isRefOp" class="avecor-table-actions" :size="8" @click="deleteItem(item)">far fa-trash-alt</v-icon>
                  <v-icon v-if="!item.isRefOp" :color="item.archived ? 'green' : '#777'" :size="8" @click="toggleArchive(item)" class="ml-1">fas fa-archive</v-icon>
                  <v-icon :size="8" @click="expandOption(isExpanded,expand,'media')" style="padding-left:3px;">far fa-images</v-icon>
                  <v-icon v-if="item.selectedDraftId" :size="8" @click="selectFileForMediaViewer(item.selectedDraftId)">fab fa-firstdraft</v-icon>
                  <v-icon v-if="item.selectedLogoId" :size="8" @click="selectFileForMediaViewer(item.selectedLogoId)" style="padding-left:3px;">fas fa-sign</v-icon>
                  <v-icon v-if="!item.isRefOp" :size="8" :color="getPartialDeliveriesColor(item)" @click="expandOption(isExpanded,expand,'partialDeliveries')" style="padding-left:3px;">fas fa-truck</v-icon>
                  <v-icon v-if="!item.isRefOp" :size="8" @click="copy(createVariationName(productVariations[item.productVariationId] ,true) !== '' ? products[productVariations[item.productVariationId].productId].name.fi  + ' - ' + createVariationName(productVariations[item.productVariationId] ,true) : products[productVariations[item.productVariationId].productId].name.fi  )" style="padding-left:3px;">fas fa-copy</v-icon>
                  <v-menu v-if="!item.isRefOp" open-on-hover bottom  nudge-right="10" close-delay="100">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" >
                        <v-icon 
                            :size="8"
                            style="padding-left:3px;"
                            color="blue"
                          >
                            fas fa-envelope-open-text
                        </v-icon>
                      </span>
                    </template>
                    <div style="font-size:11px;background:#FFF;padding:10px;">
                      <div class="pb-2">
                        <v-btn @click="copyEmailText('fi','avecor',item)"  x-small>FI - Toimitus avecorille</v-btn>
                        <v-btn @click="copyEmailText('fi','customer',item)"  x-small>FI - Toimitus asiakkaalle</v-btn>
                        <span v-if="products[item.productId].printShops && products[item.productId].printShops.length > 0">
                          <v-btn v-if="psId !== 'PnveNKH73jpkdLkYXEIa' && printShops[psId]" v-for="psId in products[item.productId].printShops" :key="item.id+psId+'fi'" @click="copyEmailText('fi','printShop',item,psId)"  x-small>FI - Toimitus {{printShops[psId].name}}</v-btn>
                        </span>
                      </div>
                      <div>
                        <v-btn @click="copyEmailText('en','avecor',item)"  x-small>EN- Toimitus avecorille</v-btn>
                        <v-btn @click="copyEmailText('en','customer',item)"  x-small>EN - Toimitus asiakkaalle</v-btn>
                        <span v-if="products[item.productId].printShops && products[item.productId].printShops.length > 0">
                          <v-btn v-if="psId !== 'PnveNKH73jpkdLkYXEIa' && printShops[psId]" v-for="psId in products[item.productId].printShops" :key="item.id+psId+'en'" @click="copyEmailText('en','printShop',item,psId)"  x-small>EN - Toimitus {{printShops[psId].name}}</v-btn>
                        </span>
                      </div>
                    </div>
                  </v-menu>
                  <v-icon v-if="!item.isRefOp" :size="8" @click="expandOption(isExpanded,expand,'dates')" style="padding-left:3px;">fas fa-calendar-alt</v-icon>
                  <v-icon :size="8" v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" @click="copyToClipboard(item.id)" >far fa-id-badge</v-icon>
                  
                  <span v-if="productVariations[item.productVariationId] && productVariations[item.productVariationId].warehoused 
                    && reserved['avecor'] && reserved['avecor'][item.productId] && reserved['avecor'][item.productId].variations 
                    && reserved['avecor'][item.productId].variations[item.productVariationId] 
                    && reserved['avecor'][item.productId].variations[item.productVariationId].details
                    && reserved['avecor'][item.productId].variations[item.productVariationId].details.length > 0">
                    <span v-for="r in reserved['avecor'][item.productId].variations[item.productVariationId].details.filter(r => r.opId === item.id)" :key="r.opId + '_reservation'">
                      <v-menu open-on-hover bottom  nudge-right="10" close-delay="200">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                            <i class="fas fa-circle" :style="' font-size:8px;margin-right:2px;padding-left:2px;color:'+settings.orderedProductStockStatusObject[r.stockStatus].color"></i>
                            
                           <!--  <v-icon 
                                :size="8"
                                style="padding-left:3px;"
                                :color="settings.orderedProductStockStatusObject[r.stockStatus] ? settings.orderedProductStockStatusObject[r.stockStatus].color : '#ccc' "
                              >
                                fas fa-warehouse
                            </v-icon> -->
                          </span>
                        </template>
                        <div style="font-size:11px;background:#FFF;padding:10px;width:650px;">
                          <h3>Tiedot</h3>
                          <div><b>Tuotevariaation saldon status:</b>
                           <i class="fas fa-circle" :style="' font-size:10px;margin-right:5px;color:'+settings.orderedProductStockStatusObject[r.stockStatus].color"></i>
                           {{settings.orderedProductStockStatusObject[r.stockStatus].text }}
                          </div>
                          <div><b>Tuotevariaation saldon määrä:</b> {{r.stockAvailable }}</div>
                          <div class="mt-4"></div>
                          <span>
                            <!-- {{productVariations[item.productVariationId].batches}}
                            .filter(r => r.opId === item.id) -->
                            <h4>Erät, jotka eivät eivät vielä saapuneet tai ole hyllytetty</h4>
                            <div class="mt-2"></div>
                            <div v-if="productVariations[item.productVariationId] && productVariations[item.productVariationId].batches 
                              && Object.keys(productVariations[item.productVariationId].batches).filter(bId => productVariations[item.productVariationId].batches[bId].status !== 'batchShelfed' && bId !== 'unallocatedPrintShop').length > 0">
                              <div >
                                <!-- <span style="display:inline-block;width:100px;"><b>Tilattu pvm</b></span> -->
                                <span style="display:inline-block;width:150px;"><b>Tilauspäivä</b></span>
                                <span style="display:inline-block;width:150px;"><b>Arvioitu saapumispäivä</b></span>
                                <span style="display:inline-block;width:75px;"><b>Määrä</b></span>
                                <span style="display:inline-block;width:150px;"><b>Status</b></span>
                              </div>

                              <span v-for="bKey in Object.keys(productVariations[item.productVariationId].batches).filter(bId => productVariations[item.productVariationId].batches[bId].status !== 'batchShelfed' && bId !== 'unallocatedPrintShop')" :key="bKey + '_batch'">
                                <div no-gutters >
                                  <!-- <span style="display:inline-block;width:100px;">{{productVariations[item.productVariationId].batches[bKey].created_at}}</span> -->
                                  <!-- <span style="display:inline-block;width:100px;">{{bKey}}</span> -->
                                  <span style="display:inline-block;width:150px;">{{productVariations[item.productVariationId].batches[bKey].orderDate}}</span>
                                  <span style="display:inline-block;width:150px;">{{productVariations[item.productVariationId].batches[bKey].estimatedArrivalDate}}</span>
                                  <span style="display:inline-block;width:75px;">{{productVariations[item.productVariationId].batches[bKey].quantity}}</span>
                                  <span style="display:inline-block;width:150px;">{{settings.batchStatusArray.filter(s => s.id === productVariations[item.productVariationId].batches[bKey].status).length > 0 ? 
                                    settings.batchStatusArray.filter(s => s.id === productVariations[item.productVariationId].batches[bKey].status)[0].text : '' }}</span>
                                  
                                <!-- {{bKey}} -->
                                </div>
                              </span>
                            </div>
                            <div v-else>
                              Ei saapuvia tai hyllytettäviä eriä.
                            </div>


                          </span>

                        </div>
                      </v-menu>
                    </span>
                  </span>
                </div>
              </td>
              <!-- PRODUCT VARIATION -->
              <td class="maxw-175 minw-175">
                <!-- <v-autocomplete
                  v-model="item.productVariationId"
                  :items="getCatalogProductsAndVariations"
                  @change="value => productVariationUpdate(item.id,'productVariationId',value)"
                  persistent-hint
                  item-text="text"
                  item-value="value"
                  rows=2
                  class="avecor-select avecor-ordered-producet-select pt-0 mt-0 minimize-height"
                  :disabled="isOrderDisabled"
                /> -->
                <div style="color:rgba(0,0,0,1)" class="pb-1">
                  <span @click="copy(getProductName(item.productVariationId))" >{{getProductName(item.productVariationId)}}</span>
                  <i v-if="!isOrderDisabled && !item.isRefOp" class="fas fa-edit pl-2" @click="expandOption(isExpanded,expand,'productChange')"></i>
                </div>
                <div
                  class="customer-product-name"
                  :key="'customer_name_'+print_info_key"
                  :contenteditable="!isOrderDisabled && !item.isRefOp"
                  :style="isOrderDisabled || item.isRefOp ? 'padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;color:#999;' : 'padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;'" 
                  @blur="e => inlineSavePrintInfo(item.id,'customerProductName',e)">
                  <pre data-placeholder="Asiakkaalle näkyvä tuotenimi..." style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.customerProductName}}</pre>
                </div>
                <div style="cursor:pointer;" v-if="allAccess && productVariations[item.productVariationId] && products[productVariations[item.productVariationId].productId] && products[productVariations[item.productVariationId].productId].name.wholesale" @click="copy(products[productVariations[item.productVariationId].productId].name.wholesale)"  >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" >
                        <span style="background:orange;padding:0 3px;"><i>{{products[productVariations[item.productVariationId].productId].name.wholesale}}</i></span>
                      </span>
                    </template>
                    <span style="font-size:11px;">Tukkurin tuotenimi. Kopioi leikepöydälle klikkaamalla.</span>
                  </v-tooltip>
                </div>
              </td>

              <td class="px-0 mx-0" style="min-width:80px;">
                <div style="font-size:9px;">
                  <div>
                    <span>Malli tilaus</span>
                    <span style="color:rgba(0,0,0,.38);"  v-if="item.sample" >
                      <i v-if="!isNormalOrder" class="fas fa-check-square" ></i>
                      <i v-else @click="inlineSaveSample(item.id,'sample',false)" class="fas fa-check-square" style="cursor:pointer;"></i>
                    </span>
                    <span style="color:rgba(0,0,0,.38);" v-else>
                      <i v-if="!isNormalOrder" class="far fa-square"></i>
                      <i v-else @click="inlineSaveSample(item.id,'sample',true)" class="far fa-square" style="cursor:pointer;"></i>
                    </span>
                  </div>
                  <div>
                    <span>Varasto tuote</span>
                    <span style="color:rgba(0,0,0,.38)" v-if="productVariations[item.productVariationId] !== undefined && productVariations[item.productVariationId].warehoused !== undefined && productVariations[item.productVariationId].warehoused">
                      <i class="fas fa-check-square"></i>
                    </span>
                    <span style="color:rgba(0,0,0,.38)" v-else>
                      <i class="far fa-square"></i>
                    </span>
                  </div>
                  <div>
                    <span>Hinnastossa</span>
                    <!-- {{item.productId}} -->
                    <span style="color:rgba(0,0,0,.38)" v-if="products[item.productId] && products[item.productId].listed">
                      <i class="fas fa-check-square"></i>
                    </span>
                    <span style="color:rgba(0,0,0,.38)" v-else>
                      <i class="far fa-square"></i>
                    </span>
                  </div>
                  <div>
                    <span>Miten tilaus </span>
                    <span style="color:rgba(0,0,0,.6)" v-if="products[item.productId] && products[item.productId].wholesaleCompany && wholesaleCompanies[products[item.productId].wholesaleCompany] && wholesaleCompanies[products[item.productId].wholesaleCompany].orderStyle">
                      {{settings.wholesalesOrderStylesObject[wholesaleCompanies[products[item.productId].wholesaleCompany].orderStyle] ? settings.wholesalesOrderStylesObject[wholesaleCompanies[products[item.productId].wholesaleCompany].orderStyle].fi : ''}}
                    </span>
                  </div>
                </div>
              </td>
              
              <td class="px-0 mx-0" style="min-width:165px;">
                <div style="font-size:9px;">
                  <div v-if="allAccess && item.productId && products[item.productId] && products[item.productId].officeComments">
                    <div style="display:inline-block;width:50px;">Tuotekomm.</div>
                    <div style="display:inline-block;width:100px;">
                      <span @click="copy(item.productId ? products[item.productId].officeComments : '')" style="color:rgba(0,0,0,.38)">
                          <v-menu open-on-hover top  nudge-right="10" nudge-top="20" close-delay="100">
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on" >
                                {{item.productId && products[item.productId] && products[item.productId].officeComments ? products[item.productId].officeComments.slice(0,17)+'...' : ''}}
                              </span>
                            </template>
                            <div style="font-size:11px;background:#FFF;padding:10px;width:300px;">
                            {{item.productId && products[item.productId] ? products[item.productId].officeComments : ''}}
                            </div>
                        </v-menu>
                      </span>
                    </div>
                  </div>
                  <div v-if="allAccess">
                    <div style="display:inline-block;width:50px;float:left;">Merkkaamo</div>
                    <div style="display:inline-block;width:100px;" v-if="products[item.productId]">
                      <div v-for="(ps,i) in products[item.productId].printShops" :key="item.productId+'_printShop_' +i">
                        <span v-if="printShops[ps]" style="cursor:pointer;color:rgba(0,0,0,.38)" @click="copy(printShops[ps].orderEmail)"><v-icon size=8>fas fa-at</v-icon></span>
                        <span v-if="printShops[ps] && printShops[ps].name" style="color:rgba(0,0,0,.38)" >{{printShops[ps].name.slice(0,17)+'...'}}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="allAccess">
                    <div style="display:inline-block;width:50px;float:left;">Tukkuri</div>
                    <div style="display:inline-block;width:100px;">
                      <span v-if="products[item.productId] && products[item.productId].wholesaleCompany && wholesaleCompanies[products[item.productId].wholesaleCompany]">
                        <a v-if="wholesaleCompanies[products[item.productId].wholesaleCompany].webAddress" :href="wholesaleCompanies[products[item.productId].wholesaleCompany].webAddress" target="_blank"><v-icon class="mr-1" size=8>fas fa-external-link-alt</v-icon></a>
                        <a v-if="wholesaleCompanies[products[item.productId].wholesaleCompany].webAddress2" :href="wholesaleCompanies[products[item.productId].wholesaleCompany].webAddress2" target="_blank"><v-icon class="mr-1" size=8>fas fa-external-link-alt</v-icon></a>
                        <span v-if="wholesaleCompanies[products[item.productId].wholesaleCompany].orderEmail" @click="copy(wholesaleCompanies[products[item.productId].wholesaleCompany].orderEmail)" style="cursor:pointer;" ><v-icon size=8>fas fa-at</v-icon></span>
                        <span style="color:rgba(0,0,0,.38);overflow:hidden;">{{products[item.productId] && products[item.productId].wholesaleCompany && wholesaleCompanies[products[item.productId].wholesaleCompany] ? wholesaleCompanies[products[item.productId].wholesaleCompany].name : ''}}</span>
                      </span>
                    </div>
                  </div>
                  <div v-if="allAccess">
                    <div style="display:inline-block;width:50px;float:left;">Tuk. tuotek.</div>
                    <div style="display:inline-block;width:100px;">
                      <div>
                        <span @click="copy(productVariations[item.productVariationId] ? productVariations[item.productVariationId].wholesaleSku : '')" style="cursor:pointer;color:rgba(0,0,0,.38);text-overflow: ellipsis;overflow:hidden;">{{productVariations[item.productVariationId] ? productVariations[item.productVariationId].wholesaleSku : ''}}</span>
                        <span v-if="productVariations[item.productVariationId] && productVariations[item.productVariationId].color" style="color:rgba(0,0,0,.38)">Väri {{ productVariations[item.productVariationId].color }}</span>
                      </div>
                    </div>

                  </div>
                  <div>
                    <div style="display:inline-block;width:50px;float:left;">Ave. tuotek.</div>
                    <div style="display:inline-block;width:100px;">
                      <span @click="copy(createVariationAvecorSku(item.productVariationId))" style="color:rgba(0,0,0,.38)">{{createVariationAvecorSku(item.productVariationId)}}</span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- NUMBER OF SAMPLES -->
              <td class="maxw-50 minw-50" >
                <v-autocomplete
                  :disabled="isOrderDisabled || item.isRefOp"
                  autocomplete="off"
                  v-model="item.numberOfSamples"
                  :items="samplesArray"
                  @change="inlineSave(item)"
                  persistent-hint
                  style="background:#ddd;padding:5px 3px;"
                  class="avecor-select avecor-multi-select-slim"
                  hide-details
                />
              </td>
              <td v-if="!isSampleOrder" style="max-width:2px">
                <v-divider vertical></v-divider>
              </td>
              <td v-if="!isSampleOrder" :class="'text-xs-left'" style="min-width:60px;">
                <div style="color:#000;border-bottom:1px #999 solid;" >Tuote</div>
                <div v-if="item.print" style="color:#000;border-bottom:1px #999 solid;" >Merkkaus</div>
                <div v-if="item.print" style="color:#000;border-bottom:1px #999 solid;" >Asemointi</div>
                <div style="color:#000;border-bottom:1px #999 solid;" >Lisäkulut</div>
                <div style="padding:0 3px;height:14px;"></div>
              </td>
              <!-- QUANTITY -->
              <td v-if="!isSampleOrder" :class="'maxw-50 minw-50 text-xs-left'">
                <v-text-field
                  :disabled="isOrderDisabled || item.isRefOp"
                  v-model="item.quantity"
                  @change="v => inlineSaveQuantity(item.id,'quantity',v)"
                  class="avecor-select  avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="isOrderDisabled || item.isRefOp"
                  v-model="item.printQuantity"
                  @change="v=> inlineSaveQuantity(item.id,'printQuantity',v)"
                  class="avecor-select  avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="isOrderDisabled || item.isRefOp"
                  v-model="item.numberOfPositionings"
                  @change="inlineSave(item)"
                  class="avecor-select  avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <div style="padding:0 3px;height:14px;color:#666;background:#ddd;padding:0 3px;border-bottom:1px #999 solid;">{{item.quantity}}</div>
                <div style="padding:0 3px;height:14px;"></div>
              </td>
              <!-- UNIT PRICE OUT -->
              <td v-if="!isSampleOrder" :class="'maxw-50 minw-50 text-xs-left'">
                <v-text-field
                  :disabled="isOrderDisabled || item.isRefOp"
                  v-model="item.unitPrice"
                  @change="v => inlineSavePrice(item.id,'unitPrice',v)"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="isOrderDisabled || item.isRefOp"
                  v-model="item.unitPrintPrice"
                  @change="v => inlineSavePrice(item.id,'unitPrintPrice',v)"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="isOrderDisabled || item.isRefOp"
                  v-model="item.pricePerPositioning"
                  @change="v => inlineSavePrice(item.id,'pricePerPositioning',v)"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <div style="padding:0 3px;height:14px;"></div>
                <div style="padding:0 3px;height:14px;"></div>
              </td>
              <!-- UNIT PRICE IN -->
              <td v-if="!isSampleOrder" :class="'maxw-50 minw-50 text-xs-left'">
                <v-text-field
                  :disabled="isOrderDisabled || !allAccess || item.isRefOp"
                  v-model="item.p_houseUnitPrice"
                  @change="v => inlineSavePriceNoSyncToNetvisor(item.id,'p_houseUnitPrice',v)"
                  class="avecor-select avecor-input-no-padding"
                  style="background:orange;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="isOrderDisabled || !allAccess || item.isRefOp"
                  v-model="item.p_houseUnitPrintPrice"
                  @change="v => inlineSavePriceNoSyncToNetvisor(item.id,'p_houseUnitPrintPrice',v)"
                  class="avecor-select avecor-input-no-padding"
                  style="background:orange;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="isOrderDisabled || !allAccess || item.isRefOp"
                  v-model="item.p_houseUnitStartCosts"
                  @change="v => inlineSavePriceNoSyncToNetvisor(item.id,'p_houseUnitStartCosts',v)"
                  class="avecor-select avecor-input-no-padding"
                  style="background:orange;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  :disabled="isOrderDisabled || !allAccess || item.isRefOp"
                  v-model="item.p_houseUnitAllOtherCosts"
                  @change="v => inlineSavePriceNoSyncToNetvisor(item.id,'p_houseUnitAllOtherCosts',v)"
                  class="avecor-select avecor-input-no-padding"
                  style="background:orange;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <div style="height:12px;">
                  <div 
                    v-if="products[item.productId].listed && products[item.productId].isMarginCalculationActivated && !isOrderDisabled && allAccess && !item.isRefOp"    
                    @click="refetchOrderedProductPrices(item.id)" 
                    style="cursor:pointer;margin-top:2px;padding:1 3px;height:12px;font-size:7px;line-height:11px;font-weight:600;background:#4DB6AC;color:#FFF;text-align:center;border:1px solid #00695C;"
                  >
                    <span><i class="fas fa-sync" style="font-size:6px;color:#FFF;padding-right:2px;" ></i></span>
                    <span>AUTO</span>
                  </div>
                </div>
              </td>
              
              <td v-if="!isSampleOrder" :class="'maxw-50 minw-50 text-xs-left'">
                <v-text-field
                  :disabled="true"
                  :value="calculateTotal(item,'product_total_out')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="true"
                  :value="calculateTotal(item,'print_total_out')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="true"
                  :value="calculateTotal(item,'positionings_total_out')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <div style="background:#ddd;color:#999;padding:0 3px;border-bottom:1px #999 solid;">0</div>
                <div style="background:#ccc;padding:0 3px;">{{ calculateTotal(item,'all_total_out')  }}€</div>
              </td>
              <td v-if="!isSampleOrder" :class="'maxw-50 minw-50 text-xs-left'">
                <v-text-field
                  :disabled="true"
                  :value="calculateTotal(item,'product_total_in')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="true"
                  :value="calculateTotal(item,'print_total_in')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="true"
                  :value="calculateTotal(item,'positionings_total_in')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  :disabled="true"
                  :value="calculateTotal(item,'allOtherCosts_total_in')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <div style="background:#ccc;padding:0 3px;">{{ calculateTotal(item,'all_total_in')  }}€</div>
              </td>
              <td v-if="!isSampleOrder" :class="'maxw-50 minw-50 text-xs-left'">
                <v-text-field
                  :disabled="true"
                  :value="calculateTotal(item,'product_margin')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="true"
                  :value="calculateTotal(item,'print_margin')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  v-if="item.print"
                  :disabled="true"
                  :value="calculateTotal(item,'positionings_margin')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <v-text-field
                  :disabled="true"
                  :value="calculateTotal(item,'allOtherCosts_margin')"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;border-bottom:1px #999 solid;"
                ></v-text-field>
                <div :style="calculateTotal(item,'all_total_margin') > 0 ? 'background:lightgreen;padding:0 3px;height:14px;' : 'background:#FFCDD2;padding:0 3px;height:14px;'">{{ calculateTotal(item,'all_total_margin') }}€</div>
              </td>

               
              
              <!-- MARGINS/ORDERS COMMON FIELDS -->
              <!-- <td v-if="!isSampleOrder" :class="'text-xs-left'" >
                <div class="pt-1">
                  <span>
                    <div/>
                    <span v-if="!isOrderDisabled && allAccess">
                      <div v-if="products[item.productId].listed && products[item.productId].isMarginCalculationActivated">
                        <div><i v-if="item.pricing" class="fas fa-money-check-alt" style="padding-left:5px;padding-bottom:3px;cursor:pointer;font-size:10px;color:#555;" @click="expandOption(isExpanded,expand,'priceDetails')"></i></div>
                      </div>
                    </span>
                  </span>
                </div>
              </td> -->
              <td :class="'text-xs-left maxw-50 minw-75 mx-0 px-0'" v-if="!isSampleOrder" >
                <div style="padding:0 3px;height:13px;" class="mb-1" v-if="products[item.productId].listed && products[item.productId].isMarginCalculationActivated && item.priceDateFetchedDate">Lask. kate</div>
                <div style="padding:0 3px;height:13px;" class="mb-1">
                  Myyj. kate
                  <i v-if="item.salespersonMarginSetManually" :style="'color:green;font-size:8px;'" class="pl-0 fab fa-medium"></i>
                </div>
                <div style="padding:0 3px;height:13px;">Toim. kate</div>
                <div style="height:15px;">
                  <div v-if="!isOrderDisabled && allAccess && products[item.productId].listed && products[item.productId].isMarginCalculationActivated && item.pricing"><i class="fas fa-money-check-alt" style="padding-left:5px;padding-bottom:3px;cursor:pointer;font-size:10px;color:#555;" @click="expandOption(isExpanded,expand,'priceDetails')"></i></div>
                </div>
                
              </td>
              <td :class="'text-xs-left minw-50 maxw-50 mx-0 px-0'" v-if="!isSampleOrder" >
                <v-text-field
                  v-if="products[item.productId].listed && products[item.productId].isMarginCalculationActivated && item.priceDateFetchedDate"
                  :disabled="true"
                  :value="calculateTotal(item,'all_total_margin')"
                  class="avecor-select avecor-input-no-padding mb-1"
                  style="background:#ddd;padding:0 3px;"
                ></v-text-field>
                <v-text-field
                  :disabled="!isNormalOrder || item.isRefOp"
                  v-model="item.salespersonMargin"
                  @change="v => inlineSavePriceNoSyncToNetvisor(item.id,'salespersonMargin',v)"
                  class="avecor-select avecor-input-no-padding mb-1"
                  style="background:#ddd;padding:0 3px;"
                ></v-text-field>
                <v-text-field
                  :disabled="isOrderDisabled || !allAccess || item.isRefOp"
                  v-model="item.confirmedMargin"
                  @change="v => inlineSavePriceNoSyncToNetvisor(item.id,'confirmedMargin',v)"
                  class="avecor-select avecor-input-no-padding"
                  style="background:#ddd;padding:0 3px;"
                ></v-text-field>
                <div style="height:15px"/>
              </td>
              <!-- <td v-if="!isSampleOrder" style="max-width:2px;padding-right:0px !important;">
                <v-divider vertical></v-divider>
              </td> -->
              <!-- IS PRINT -->
              <td class="text-left" v-if="!isSampleOrder" style="min-width:390px;border-left:1px solid #ccc;border-right:1px solid #ccc;padding-left:0px !important;padding-right:0px !important;">
                <div>
                  <div class="pt-1 pl-1" style="min-width:25px;max-width:25px;display:inline-block;vertical-align:middle;">
                    <div v-if="!isOrderDisabled && !item.isRefOp">
                      <div>1
                        <v-icon v-if="item.print" style="" color="#555" size="11" @click="inlineSaveOrderedProduct(item.id,'print',false)">far fa-check-square</v-icon>
                        <v-icon v-else style="" color="#555" size="11" @click="inlineSaveOrderedProduct(item.id,'print',true)">far fa-square</v-icon>
                      </div>
                    </div>
                    <div v-else>
                      <div>1
                        <v-icon v-if="item.print" color="#555" size="11" >far fa-check-square</v-icon>
                        <v-icon v-else color="#555" size="11" >far fa-square</v-icon>
                      </div>
                    </div>
                  </div>
                  <div style="min-width:165px;max-width:165px;display:inline-block;vertical-align:middle;" class="px-2">
                    <div v-if="item.print && !item.newPrintOptionsInUse">
                      <v-autocomplete
                        :disabled="isOrderDisabled || item.isRefOp"
                        v-if="products[item.productId].printFormats && products[item.productId].printFormats.length > 0"
                        v-model="item.printFormats"
                        :items="settings.printFormats"
                        @change="inlineSave(item)"
                        item-text="fi"
                        item-value="id"
                        multiple
                        class="avecor-select avecor-multi-select-slim"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        dense
                      />
                      <v-text-field
                        :disabled="isOrderDisabled || item.isRefOp"
                        v-else
                        v-model="item.printFormatsText"
                        @change="inlineSave(item)"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        class="avecor-select avecor-multi-select-slim"
                      ></v-text-field>
                      <div>
                        <v-autocomplete
                          :disabled="isOrderDisabled || item.isRefOp"
                          autocomplete="off"
                          v-model="item.numberOfPrintColors"
                          :items="settings.numberOfPrintColors"
                          @change="inlineSave(item)"
                          persistent-hint
                          style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                          class="avecor-select avecor-multi-select-slim"
                          dense>
                          <template v-slot:selection="data">
                              <div style="line-height:15px;">
                                <span style="font-size:8px;padding-right:5px;"><b>Värien määrä: </b></span>
                                <span>{{ data.item }} </span>
                              </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </div>
                    <!-- NEW PRINT OPTIONS FOR LISTED PRODUCTS -->
                    
                    <div v-if="item.print && item.printOptions && item.printOptionsSettings && products[item.productId] && products[item.productId].prices"><!-- products[item.productId].isMarginCalculationActivated -->
                      <div style="font-size:8px;padding-top:2px;" v-if="!item.newPrintOptionsInUse">Hinnaston merkkausvalinnat</div>
                      <v-autocomplete
                        :disabled="isOrderDisabled || item.isRefOp"
                        :value="item.printOptions"
                        :items="printFormatsFromPricingForProduct(item.productId)"
                        multiple
                        item-text="text"
                        item-value="id"
                        class="avecor-select avecor-multi-select-slim avecor-multi-select-input-0-height"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        dense>
                        <template v-slot:selection="data">
                          <div
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            style="border-radius:5px;background:#bbb;padding:5px;margin-top:2px;"
                          >
                            <div>{{ data.item.text}} </div>
                            <div v-if="item.printOptionsSettings[data.item.id] && item.printOptionsSettings[data.item.id].renewal">
                              <span class="">Uusinta-aloitus</span>
                              <i v-if="item.printOptionsSettings[data.item.id] && item.printOptionsSettings[data.item.id].renewal" :style="'color:#555;font-size:10px;cursor:pointer;'" class="far fa-check-square "></i>
                              <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-square"></i>
                            </div>
                            <span v-if="item.printOptionsSettings[data.item.id] && item.printOptionsSettings[data.item.id].colors" class="">Värien määrä {{item.printOptionsSettings[data.item.id].colors }}</span>
                            
                          </div>
                        </template>
                        <template v-slot:item="pfItemProps" ><!-- {active, item, attrs, on } -->
                          <v-list-item v-on="pfItemProps.on" v-bind="pfItemProps.attrs" #default="{ active }" style="min-width:350px;color:#000;" class="custom-print-format-list-item px-0" dense>
                            <v-list-item-content @click.stop="()=>{}"> 
                              <v-list-item-title @click.stop="()=>{}" >
                                <v-row no-gutters align="center" style="color:#000 !important;" @click.stop="()=>{}" class="px-4">
                                  <span @click.stop="()=>{}" class="mr-5">
                                    <i v-if="active" :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(1,item,'remove',pfItemProps.item.id)" class="far fa-check-square pl-1 pr-2"></i>
                                    <i v-else :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(1,item,'add',pfItemProps.item.id)" class="far fa-square pl-1 pr-2"></i>
                                    <span>{{pfItemProps.item.text}}</span>
                                  </span>
                                  <v-spacer></v-spacer>
                                  <!-- <div style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:175px;"> -->
                                  <div v-if="item.printOptionsSettings[pfItemProps.item.id] && ((pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0) || pfItemProps.item.renewAvailable || (pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'))" style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:400px;">
                                    <div v-if="pfItemProps.item.renewAvailable">
                                      <i v-if="item.printOptionsSettings[pfItemProps.item.id] && item.printOptionsSettings[pfItemProps.item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'renewal', item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                      <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'renewal', item, pfItemProps.item.id, true) " class="far fa-square pl-1 pr-2"></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Uusinta-aloitus</div>
                                    </div>
                                    <!-- <div class="pt-1"> -->
                                    <div class="pt-1" v-if="pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'" >
                                      <i v-if="item.printOptionsSettings[pfItemProps.item.id] && item.printOptionsSettings[pfItemProps.item.id].colors && item.printOptionsSettings[pfItemProps.item.id].colors > 1" class="fas fa-minus-circle ml-1" @click="printOptionSettingUpdate(1,'colors', item, pfItemProps.item.id, 'subtract')" ></i>
                                      <i v-else class="fas fa-minus-circle ml-1" style="color:#ccc" ></i>
                                      <span class="px-1 mx-1" style="border:1px solid #ccc;background:#FFF;">{{item.printOptionsSettings[pfItemProps.item.id].colors ? item.printOptionsSettings[pfItemProps.item.id].colors : '-'}}</span>
                                      <i class="fas fa-plus-circle" @click="printOptionSettingUpdate(1,'colors', item, pfItemProps.item.id, 'add');" ></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Värien määrä</div>
                                    </div>
                                    <div v-if="pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0" class="pt-2">
                                      <div v-for="(ec, i) in pfItemProps.item.extraCosts" :key="ec.id+'_ec_'+i">
                                        <i v-if="item.printOptionsSettings[pfItemProps.item.id] && item.printOptionsSettings[pfItemProps.item.id]['ec_'+ec.id]" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'ec_'+ec.id, item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                        <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'ec_'+ec.id, item, pfItemProps.item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                        <div style="display:inline-block;" class="pr-2">{{ec.name + ' ('+ec.price+'€)'}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </v-row>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                  <div style="min-width:190px;max-width:190px;display:inline-block;vertical-align:middle;" :key="print_info_key+1">
                    <div style="font-size:9px;" v-if="item.print">
                      <div style="margin-bottom:2px;margin-top:2px;">
                        <div style="display:inline-block;width:55px;float:left;">
                          Merk. väri
                        </div>
                        <div style="display:inline-block;width:130px;">
                          <div
                            v-if="isOrderDisabled || item.isRefOp"
                            style="padding:0px 3px 1px 3px;line-height:10px;min-height:12px;color:#999;">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printColor}}</pre>
                          </div>
                          <div
                            v-else
                            :contenteditable="true"
                            style="padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                            @blur="e => inlineSavePrintInfo(item.id,'printColor',e)">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printColor}}</pre>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:2px;">
                        <div style="display:inline-block;width:55px;float:left;">
                          Merk. kohta
                        </div>
                        <div style="display:inline-block;width:130px;">
                          <div
                            v-if="isOrderDisabled || item.isRefOp"
                            style="padding:0px 3px 1px 3px;line-height:10px;min-height:12px;color:#999;">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printLocation}}</pre>
                          </div>
                          <div v-else :contenteditable="true" style="padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" @blur="e => inlineSavePrintInfo(item.id,'printLocation',e)">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printLocation}}</pre>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:2px;">
                        <div style="display:inline-block;width:55px;float:left;">
                          Mitä merk.
                        </div>
                        <div style="display:inline-block;width:130px;">
                          <div v-if="isOrderDisabled || item.isRefOp" style="padding:0px 3px 1px 3px;line-height:10px;min-height:12px;color:#999;">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printContent}}</pre>
                          </div>
                          <div v-else :contenteditable="true" style="padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" @blur="e => inlineSavePrintInfo(item.id,'printContent',e)">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printContent}}</pre>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:2px;">
                        <div style="display:inline-block;width:55px;float:left;">
                          Merk. lisät.
                        </div>
                        <div style="display:inline-block;width:130px;">
                          <div v-if="isOrderDisabled || item.isRefOp" style="padding:0px 3px 1px 3px;line-height:10px;min-height:12px;min-height:12px;color:#999;">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printComments}}</pre>
                          </div>
                          <div v-else :contenteditable="true" style="padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;"  @blur="e => inlineSavePrintInfo(item.id,'printComments',e)">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printComments}}</pre>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- SECOND PRINT -->
                <div style="border-top:1px solid #ccc;">
                  <div class="pl-1 pt-2 pb-2" style="min-width:25px;max-width:25px;display:inline-block;vertical-align:middle;">
                    <div v-if="!isOrderDisabled && !item.isRefOp">
                      <div>2
                        <v-icon v-if="item.secondPrint" style="" color="#555" size="11" @click="inlineSaveOrderedProduct(item.id,'secondPrint',false)">far fa-check-square</v-icon>
                        <v-icon v-else style="" color="#555" size="11" @click="inlineSaveOrderedProduct(item.id,'secondPrint',true)">far fa-square</v-icon>
                      </div>
                    </div>
                    <div v-else>
                      <div>2
                        <v-icon v-if="item.secondPrint" color="#555" size="11" >far fa-check-square</v-icon>
                        <v-icon v-else color="#555" size="11" >far fa-square</v-icon>
                      </div>
                    </div>
                  </div>
                  <div style="min-width:165px;max-width:165px;display:inline-block;vertical-align:middle;" class="px-2">
                    <div v-if="item.secondPrint && !item.newPrintOptionsInUse">
                      <v-autocomplete
                        :disabled="isOrderDisabled || item.isRefOp"
                        v-if="products[item.productId].printFormats && products[item.productId].printFormats.length > 0"
                        v-model="item.printFormats2"
                        :items="settings.printFormats"
                        @change="inlineSave(item)"
                        item-text="fi"
                        item-value="id"
                        multiple
                        class="avecor-select avecor-multi-select-slim"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        dense
                      />
                      <v-text-field
                        :disabled="isOrderDisabled || item.isRefOp"
                        v-else
                        v-model="item.printFormatsText2"
                        @change="inlineSave(item)"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        class="avecor-select avecor-multi-select-slim"
                      ></v-text-field>
                      <div>
                        <v-autocomplete
                          :disabled="isOrderDisabled || item.isRefOp"
                          autocomplete="off"
                          v-model="item.numberOfPrintColors2"
                          :items="settings.numberOfPrintColors"
                          @change="inlineSave(item)"
                          persistent-hint
                          style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                          class="avecor-select avecor-multi-select-slim"
                          dense>
                          <template v-slot:selection="data">
                              <div style="line-height:15px;">
                                <span style="font-size:8px;padding-right:5px;"><b>Värien määrä: </b></span>
                                <span>{{ data.item }} </span>
                              </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </div>
                    

                    <!-- SECOND PRINT -->
                    <div class="" style="" v-if="item.secondPrint && item.printOptions && item.printOptionsSettings && products[item.productId] && products[item.productId].prices">
                      <v-autocomplete
                        :disabled="isOrderDisabled || item.isRefOp"
                        :value="item.printOptions2"
                        :items="printFormatsFromPricingForProduct(item.productId)"
                        multiple
                        item-text="text"
                        item-value="id"
                        class="avecor-select avecor-multi-select-slim avecor-multi-select-input-0-height"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;margin-top:3px;" 
                        dense>
                        <template v-slot:selection="data">
                          <div
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            style="border-radius:5px;background:#bbb;padding:5px;margin-top:2px;"
                          >
                            <div>{{ data.item.text}} </div>
                            <div v-if="item.printOptionsSettings2[data.item.id] && item.printOptionsSettings2[data.item.id].renewal">
                              <span class="">Uusinta-aloitus</span>
                              <i v-if="item.printOptionsSettings2[data.item.id] && item.printOptionsSettings2[data.item.id].renewal" :style="'color:#555;font-size:10px;cursor:pointer;'" class="far fa-check-square "></i>
                              <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-square"></i>
                            </div>
                            <span v-if="item.printOptionsSettings2[data.item.id] && item.printOptionsSettings2[data.item.id].colors" class="">Värien määrä {{item.printOptionsSettings2[data.item.id].colors }}</span>
                            
                          </div>
                        </template>
                        <template v-slot:item="pfItemProps" >
                          <v-list-item v-on="pfItemProps.on" v-bind="pfItemProps.attrs" #default="{ active }" style="min-width:350px;color:#000;" class="custom-print-format-list-item px-0" dense>
                            <v-list-item-content @click.stop="()=>{}"> 
                              <v-list-item-title @click.stop="()=>{}" >
                                <v-row no-gutters align="center" style="color:#000 !important;" @click.stop="()=>{}" class="px-4">
                                  <span @click.stop="()=>{}" class="mr-5">
                                    <i v-if="active" :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(2,item,'remove',pfItemProps.item.id)" class="far fa-check-square pl-1 pr-2"></i>
                                    <i v-else :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(2,item,'add',pfItemProps.item.id)" class="far fa-square pl-1 pr-2"></i>
                                    <span>{{pfItemProps.item.text}}</span>
                                  </span>
                                  <v-spacer></v-spacer>
                                  <div v-if="item.printOptionsSettings2[pfItemProps.item.id] && ((pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0) || pfItemProps.item.renewAvailable || (pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'))" style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:400px;">
                                    <div v-if="pfItemProps.item.renewAvailable">
                                      <i v-if="item.printOptionsSettings2[pfItemProps.item.id] && item.printOptionsSettings2[pfItemProps.item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'renewal', item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                      <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'renewal', item, pfItemProps.item.id, true) " class="far fa-square pl-1 pr-2"></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Uusinta-aloitus</div>
                                    </div>
                                    <div class="pt-1" v-if="pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'" >
                                      <i v-if="item.printOptionsSettings2[pfItemProps.item.id] && item.printOptionsSettings2[pfItemProps.item.id].colors && item.printOptionsSettings2[pfItemProps.item.id].colors > 1" class="fas fa-minus-circle ml-1" @click="printOptionSettingUpdate(2,'colors', item, pfItemProps.item.id, 'subtract')" ></i>
                                      <i v-else class="fas fa-minus-circle ml-1" style="color:#ccc" ></i>
                                      <span class="px-1 mx-1" style="border:1px solid #ccc;background:#FFF;">{{item.printOptionsSettings2[pfItemProps.item.id].colors ? item.printOptionsSettings2[pfItemProps.item.id].colors : '-'}}</span>
                                      <i class="fas fa-plus-circle" @click="printOptionSettingUpdate(2,'colors', item, pfItemProps.item.id, 'add');" ></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Värien määrä</div>
                                    </div>
                                    <div v-if="pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0" class="pt-2">
                                      <div v-for="(ec, i) in pfItemProps.item.extraCosts" :key="ec.id+'_ec_'+i">
                                        <i v-if="item.printOptionsSettings2[pfItemProps.item.id] && item.printOptionsSettings2[pfItemProps.item.id]['ec_'+ec.id]" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'ec_'+ec.id, item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                        <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'ec_'+ec.id, item, pfItemProps.item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                        <div style="display:inline-block;" class="pr-2">{{ec.name + ' ('+ec.price+'€)'}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </v-row>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                  <div style="min-width:190px;max-width:190px;display:inline-block;vertical-align:middle;" :key="print_info_key+1">
                    <div style="font-size:9px;" v-if="item.secondPrint">
                      <div style="margin-bottom:2px;margin-top:2px;">
                        <div style="display:inline-block;width:55px;float:left;">
                          Merk. väri
                        </div>
                        <div style="display:inline-block;width:130px;">
                          <div v-if="isOrderDisabled || item.isRefOp" style="padding:0px 3px 1px 3px;line-height:10px;min-height:12px;color:#999;">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printColor2}}</pre>
                          </div>
                          <div v-else :contenteditable="true" style="padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" @blur="e => inlineSavePrintInfo(item.id,'printColor2',e)">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printColor2}}</pre>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:2px;">
                        <div style="display:inline-block;width:55px;float:left;">
                          Merk. kohta
                        </div>
                        <div style="display:inline-block;width:130px;">
                          <div v-if="isOrderDisabled || item.isRefOp" style="padding:0px 3px 1px 3px;line-height:10px;min-height:12px;color:#999;">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printLocation2}}</pre>
                          </div>
                          <div v-else :contenteditable="true" style="padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" @blur="e => inlineSavePrintInfo(item.id,'printLocation2',e)">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printLocation2}}</pre>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:2px;">
                        <div style="display:inline-block;width:55px;float:left;">
                          Mitä merk.
                        </div>
                        <div style="display:inline-block;width:130px;">
                          <div v-if="isOrderDisabled || item.isRefOp" style="padding:0px 3px 1px 3px;line-height:10px;min-height:12px;color:#999;">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printContent2}}</pre>
                          </div>
                          <div v-else :contenteditable="true" style="padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" @blur="e => inlineSavePrintInfo(item.id,'printContent2',e)">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printContent2}}</pre>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:2px;">
                        <div style="display:inline-block;width:55px;float:left;">
                          Merk. lisät.
                        </div>
                        <div style="display:inline-block;width:130px;">
                          <div v-if="isOrderDisabled || item.isRefOp" style="padding:0px 3px 1px 3px;line-height:10px;min-height:12px;min-height:12px;color:#999;">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printComments2}}</pre>
                          </div>
                          <div v-else :contenteditable="true" style="padding:2px 3px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;"  @blur="e => inlineSavePrintInfo(item.id,'printComments2',e)">
                            <pre style="font-family:Roboto, sans-serif;white-space:pre-wrap">{{item.printComments2}}</pre>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </td>
              
              <!-- LATEST TO CUSTOMERS -->
              <td style="min-width:55px;max-width:80px" v-if="!isSampleOrder ">
                <v-menu
                  :nudge-right="0"
                  transition="fade-transition"
                  offset-y
                  min-width="35px"
                >
                  <template v-slot:activator="{ on }">
                    <span>
                      <v-text-field
                        :disabled="isOrderDisabled || item.isRefOp"
                        v-on="on"
                        class="avecor-date-picker font-8px" 
                        style="font-size:6px !important;background:#ddd;" 
                        v-model="item.latestToCustomer"
                        readonly
                      ></v-text-field>
                      <span v-if="isNormalOrder && item.latestToCustomer !== '' && !item.isRefOp" @click="resetDate(item,'latestToCustomer')" style="cursor:pointer;color:#6495ED;text-decoration:underline; font-size:7px">TYHJENNÄ</span>
                    </span>
                  </template>
                  <v-date-picker v-model="item.latestToCustomer" @change="v => inlineSaveLatestToCustomer(item.id, v)" ></v-date-picker>
                </v-menu>
              </td>
              <!-- BACK ORDER AMOUNT -->
              <td class="minw-50 maxw-50 text-xs-left" v-if="!isSampleOrder">
                <div v-if="(item.partialDeliveries &&  Object.keys(item.partialDeliveries).length > 0)  || item.backOrderAmount" style="font-size:7px">
                  <div style="color:rgba(0,0,0,.38)"><b>Laskettu:</b> {{getRemainingDelivery(item)}}</div>
                  <div style="color:rgba(0,0,0,.38)"><b>Vanha arvo:</b> {{item.backOrderAmount}}</div>
                </div>
                <!-- <v-textarea
                  v-model="item.backOrderAmount"
                  @change="v => inlineSaveBackOrderAmount(item.id, v)"
                  class="avecor-select mt-3"
                  rows=1
                  :auto-grow="autogrow"
                ></v-textarea> -->
              </td>
              <!-- BATCH STATUS CHANGE -->
              <td class="text-left" style="max-width:30px;">
                <div class="pt-1" v-if="!item.isRefOp">
                  <v-icon v-if="batchStatusUpdateItems[item.id]" style="padding-left:5px;" color="#555" size="12" @click="updateBatchStatusForItem(item.id)">far fa-check-square</v-icon>
                  <v-icon v-else style="padding-left:5px;" color="#555" size="12" @click="updateBatchStatusForItem(item.id)">far fa-square</v-icon>
                  <div style="height:12px;"/>
                </div>
                <!-- <v-checkbox 
                  style="margin-top:0px;"
                  :value="batchStatusUpdateItems[item.id]" 
                  @change="v => updateBatchStatusForItem(item.id)"
                  class="avecor-table-checkbox">
                </v-checkbox> -->
              </td>
              <!-- <td class="text-left">
                <v-checkbox 
                  style="margin-top:0px;"
                  v-model="item.batchStatusChange" 
                  class="avecor-table-checkbox">
                </v-checkbox>
              </td> -->
              <!-- ORDER STATUS -->
              <td class="minw-100 maxw-100">
                <!-- <select :value="item.orderStatus" :disabled="isOrderDisabled" style="background:#ddd;padding-left:1px;height:20px;-webkit-appearance:auto;min-width:100%;max-width:100%;margin-top:6px;"  @click.stop @change="v => inlineSaveStatus(item, 'orderStatus',v.target.value)">
                  <option v-for="s in getStatuses(item,false)" :value="s.id"   >{{s.text}}</option>
                </select>   -->
                <v-autocomplete
                  :disabled="isOrderDisabled || item.isRefOp"
                  autocomplete="off"
                  :value="item.orderStatus"
                  :items="getStatuses(item,false)"
                  @change="v => inlineSaveStatus(item, 'orderStatus',v)"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  class="avecor-select avecor-multi-select-slim"
                  style="background:#ddd;padding-left:3px;height:20px;padding-top:2px;padding-right:2px;"  
                />
                <div style="height:15px;"/>
              </td>
              <!-- SHIPPED DATE -->
              <td class="minw-75 maxw-75" v-if="!isSampleOrder">
                <v-menu
                  :nudge-right="40"
                  transition="fade-transition"
                  offset-y
                  top
                  min-width="30px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :disabled="isOrderDisabled || item.isRefOp"
                      v-on="on"
                      class="avecor-date-picker pl-1"  
                      :value="customFormatter(item.shippedDate)"
                      style="background:#ddd"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker :value="customFormatter(item.shippedDate)" @change="v => inlineSaveDate(item.id,'shippedDate',v)" ></v-date-picker>
                </v-menu>
                <div style="height:15px;">
                  <span v-if="isNormalOrder && item.shippedDate && item.shippedDate !== '' && !item.isRefOp" @click="resetDate(item,'shippedDate')" style="cursor:pointer;color:#6495ED;text-decoration:underline; font-size:7px">TYHJENNÄ</span>
                </div>
              </td>
              <!-- ORDER INVOICE STATUS -->
              <td class="minw-100 maxw-100" v-if="!isSampleOrder">
                <!-- <select :value="item.orderInvoiceStatus" :disabled="isOrderDisabled" style="background:#ddd;padding-left:1px;height:20px;-webkit-appearance:auto;min-width:100%;max-width:100%;margin-top:6px;"  @click.stop @change="v => inlineSaveStatus(item, 'orderInvoiceStatus',v.target.value)">
                  <option v-for="s in settings.orderedProductInvoiceStatusArray" :value="s.id"   >{{s.text}}</option>
                </select>   -->
                <!-- <div style="height:15px;"/> -->
                <v-autocomplete
                  :disabled="isOrderDisabled || item.isRefOp"
                  autocomplete="off"
                  :value="item.orderInvoiceStatus"
                  :items="settings.orderedProductInvoiceStatusArray"
                  @change="v => inlineSaveStatus(item, 'orderInvoiceStatus', v)"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  class="avecor-select avecor-multi-select-slim"
                  style="background:#ddd;padding-left:3px;height:20px;padding-top:2px;padding-right:2px;"  
                />
                <div style="height:15px;"/>
              </td>
              <!-- WHEN TO INVOICE -->
              <td class="minw-75 maxw-75" v-if="!isSampleOrder">
                <v-menu
                  :nudge-right="40"
                  transition="fade-transition"
                  offset-y
                  top
                  min-width="30px"
                >
                  <template v-slot:activator="{ on }">
                    <div>
                      <!-- <div  v-if="item.whenToInvoiceSetManually" style="background:#FF5722;color:#FFF;padding-left:2px;">Manually set</div> -->
                      <v-text-field
                        :disabled="isOrderDisabled || item.isRefOp"
                        v-on="on"
                        class="avecor-date-picker pl-1"
                        :style="item.whenToInvoiceSetManually ? 'background:#64B5F6;color:#FFF !important;' : 'background:#ddd'"  
                        :value="customFormatter(item.whenToInvoice)"
                        readonly
                      ></v-text-field>
                    </div>
                  </template>
                  <v-date-picker :value="customFormatter(item.whenToInvoice)" @change="v => inlineSaveDate(item.id,'whenToInvoice',v)" ></v-date-picker>
                </v-menu>
                <div style="height:15px;">
                  <span v-if="isNormalOrder && item.whenToInvoice !== '' && !item.isRefOp" @click="resetDate(item,'whenToInvoice')" style="cursor:pointer;color:#6495ED;text-decoration:underline; font-size:7px">TYHJENNÄ</span>
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td v-if="selectedExpandOption === 'media'" class="pa-0" :colspan="headers.length">
              <div class="avecor-table" style="border-bottom: 1px solid #ccc; margin-top:10px; ">
                <v-row no-gutters justify-center >
                  <v-col sm="3">
                    <h3  class="text-center">Valitse logo tälle tuotteelle</h3>
                    <MediaGrid 
                      :types="['logo']" 
                      :actions="['delete','copyUrl','download','select']" 
                      colsPerItem="4" 
                      :company="companies[selectedOrder.companyId]" 
                      :order="selectedOrder" 
                      :product="productVariations[item.productVariationId]" 
                      :orderedProduct="item" 
                      :productVariation="item.productVariation" 
                      ref="mediaGrid"
                    ></MediaGrid>
                  </v-col>
                  <v-col sm="3" style="border-left: 1px solid #ccc ">
                    <h3  class="text-center">Lisää logo yritykselle</h3>
                    <MediaUpload type="logo" :companyId="selectedOrder.companyId"  />
                  </v-col>
                  <v-col sm="3" style="border-left: 1px solid #ccc ">
                    <h3  class="text-center">Valitse vedos tälle tuotteelle</h3>
                    <MediaGrid :types="['draft']" :actions="['delete','copyUrl','download','select']" colsPerItem="4" :company="companies[selectedOrder.companyId]" :order="selectedOrder" :product="products[item.productId]" :orderedProduct="item" :productVariation="item.productVariation" ref="mediaGrid"></MediaGrid>
                  </v-col>
                  <v-col sm="3" style="border-left: 1px solid #ccc ">
                    <h3  class="text-center">Lisää vedos tuotteelle</h3>
                    <MediaUpload type="draft" :companyId="selectedOrder.companyId" :orderId="selectedOrderId" :orderedProductId="item.id" :productId="item.productId" :productVariationId="item.productVariationId" />
                  </v-col>
                </v-row>
              </div>
            </td>
            <!-- DATES EXPAND -->
            <td v-if="selectedExpandOption === 'dates'" class="pa-0" :colspan="headers.length">
              <div class="avecor-table pa-3" style="border-bottom: 1px solid #ccc; margin-top:0px; " v-if="item">
                <div style="width:100%;font-size:14px" class="pb-2">Statusten päivämäärät</div>
                <div style="width:100%;font-weight:600">
                  <span style="width:200px;display:inline-block">Status</span>
                  <span style="font-weight:800;width:85px;display:inline-block">Päivämäärä</span>
                  <span style="font-weight:800;width:70px;display:inline-block">Henkilö</span>
                  <span class="ml-2" style="font-weight:800;"></span>
                  
                </div>
                <v-row no-gutters v-for="(s) in getStatuses(item,true)" :key="s.id" style="width:100%;max-height:30px">
                  
                  <span style="width:200px;display:inline-block">
                    {{s.text}}
                  </span>
                  <span v-if="s.id === 'new'">
                    <span>
                      <span style="font-weight:400;width:85px;display:inline-block">
                        <v-menu
                          style="display:inline-block"
                          :nudge-right="40"
                          transition="fade-transition"
                          offset-y
                          hide-details
                          min-width="30px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-on="on"
                              style="max-height:25px;background:#DDD"     
                              :value="customFormatter(item.created_at,true)"
                              readonly
                              class="avecor-date-picker pl-1  ma-0"  
                            ></v-text-field>
                          </template>
                          <v-date-picker :value="customFormatter(item.created_at,true)" @change="v => inlineSaveDate(item.id, 'created_at',v)" locale="fi-fi"></v-date-picker>
                        </v-menu>
                      </span>
                    </span>
                    <span class="order-expand-statuses-text" >{{item.created_by && staff[item.created_by] ? staff[item.created_by].firstName + ' ' +staff[item.created_by].lastName :''}}</span>                
                  </span>
                  <span v-else-if="s.id === 'productsShipped'">
                    <span style="font-weight:400;width:85px;display:inline-block">
                      <v-menu
                        style="display:inline-block"
                        :nudge-right="40"
                        transition="fade-transition"
                        offset-y
                        hide-details
                        min-width="30px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            style="max-height:25px;background:#DDD"     
                            :value="customFormatter(item.shippedDate,true)"
                            readonly
                            class="avecor-date-picker pl-1  ma-0"  
                          ></v-text-field>
                        </template>
                        <v-date-picker :value="customFormatter(item.shippedDate)" @change="v => inlineSaveDate(item.id, 'shippedDate',v)" locale="fi-fi"></v-date-picker>
                      </v-menu>
                    </span>
                    <span class="order-expand-statuses-text">{{item.shippedUser && staff[item.shippedUser] ? staff[item.shippedUser].firstName + ' ' + staff[item.shippedUser].lastName :''}}</span>                
                    <span v-if="item.shippedDate && user.uid === 'LWUyHuLm2BUKERykOt3dOP4SO73'" @click="inlineSaveDate(item.id, 'shippedDate','');" style="cursor:pointer;color:#6495ED;text-decoration:underline; font-size:10px;line-height:18px;vertical-align:top;" class="pl-4 pb-3" >POISTA PÄIVÄMÄÄRÄ JA HENKILÖ</span>
                  </span>
                  <span v-else-if="s.id === 'invoiced'">
                    <span style="font-weight:400;width:85px;display:inline-block">
                      <v-menu
                        style="display:inline-block"
                        :nudge-right="40"
                        transition="fade-transition"
                        offset-y
                        hide-details
                        min-width="30px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            style="max-height:25px;background:#DDD"     
                            :value="customFormatter(item.whenToInvoice,true)"
                            readonly
                            class="avecor-date-picker pl-1  ma-0"  
                          ></v-text-field>
                        </template>
                        <v-date-picker :value="customFormatter(item.whenToInvoice)" @change="v => inlineSaveDate(item.id, 'whenToInvoice',v)" locale="fi-fi"></v-date-picker>
                      </v-menu>
                    </span>
                    <span class="order-expand-statuses-text">{{item.whenToInvoiceUser && staff[item.whenToInvoiceUser] ? staff[item.whenToInvoiceUser].firstName + ' ' +staff[item.whenToInvoiceUser].lastName :''}}</span>                
                    <span v-if="item.whenToInvoice && user.uid === 'LWUyHuLm2BUKERyOt3dOzP4SO73'" @click="inlineSaveDate(item.id, 'whenToInvoice','')" style="cursor:pointer;color:#6495ED;text-decoration:underline; font-size:10px;line-height:18px;vertical-align:top;" class="pl-4  pb-3" >POISTA PÄIVÄMÄÄRÄ JA HENKILÖ</span>
                  </span>
                  <span v-else>
                    <span style="font-weight:400;width:85px;display:inline-block">
                      <v-menu style="display:inline-block" :nudge-right="40" transition="fade-transition" offset-y hide-details min-width="30px">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            style="max-height:25px;background:#DDD"
                            hide-details
                            class="avecor-date-picker pl-1  ma-0"  
                            :value="customFormatter(item[s.id+'Date'],true)"
                            readonly
                          ></v-text-field>
                        </template>
                        <v-date-picker :value="customFormatter(item[s.id+'Date'])" @change="v =>  inlineSaveDate(item.id, s.id+'Date',v)"  ></v-date-picker>
                      </v-menu>
                    </span>
                    <span class="order-expand-statuses-text">{{item[s.id+'User'] && staff[item[s.id+'User']] ? staff[item[s.id+'User']].firstName + ' '+ staff[item[s.id+'User']].lastName :''}}</span>                
                    <span v-if="item[s.id+'Date'] && user.uid === 'LWUyHuLm2BUKRykOt3dOzP4SO73'" @click="inlineSaveDate(item.id, s.id+'Date','')" style="cursor:pointer;color:#6495ED;text-decoration:underline; font-size:10px;line-height:18px;vertical-align:top;" class="pl-4  pb-3" >POISTA PÄIVÄMÄÄRÄ JA HENKILÖ</span>
                  </span>
                    
                  <!-- <span v-else style="font-weight:800;width:70px;display:inline-block" class="pb-3">
                    <v-text-field
                      style="max-height:25px;background:#DDD"
                      hide-details
                      class="avecor-date-picker pl-1  ma-0"  
                      :value="customFormatter(item.created_at)"
                      readonly
                    ></v-text-field>
                    
                  </span> -->
                  

                </v-row>
              </div>
            </td>
            <!-- PARTIAL DELIVERIES EXPAND -->
            <td v-if="selectedExpandOption === 'partialDeliveries'" class="pa-0" :colspan="headers.length">
              <div class="avecor-table pa-3" style="border-bottom: 1px solid #ccc; margin-top:0px; " :key="partialDeliveriesExpandKey" >
                <div style="width:100%;font-size:14px" class="pb-2">Osatoimitukset
                  <v-icon 
                    class="avecor-table-actions ml-5"
                    :size="14"
                    @click="addPartialDelivery(item.id)"
                  >
                    far fa-plus-square
                  </v-icon>
                </div>
                <div style="width:100%">
                  <span class="mr-1" style="width:30px;display:inline-block"></span>
                  <span class="" style="font-weight:800;width:95px;display:inline-block">Lisätty pvm.</span>
                  <span class="" style="font-weight:800;width:100px;display:inline-block">Lisännyt Henkilö</span>
                  <span class="mr-4" style="font-weight:800;width:80px;display:inline-block;">Määrä</span>
                  <span class="" style="font-weight:800;width:100px;display:inline-block">Status</span>
                  <span class="" style="font-weight:800;width:100px;display:inline-block">Laskutus pvm.</span>
                  <span class="" style="font-weight:800;width:100px;display:inline-block">Laskutus Henkilö</span>
                  
                </div>
                <div v-if="item.partialDeliveries && Object.keys(item.partialDeliveries).length > 0" class="hide-field-details">
                  <v-row no-gutters v-for="(pd) in getPartialDeliveries(item.partialDeliveries)" :key="pd.id" style="width:100%;max-height:30px;">
                    <span style="width:30px;display:inline-block;" class="pt-4 mr-1">
                      <v-icon 
                        v-if="pd.invoiceStatus !== 'invoiced'"
                        class="avecor-table-actions"
                        size=10
                        @click="deletePartialDelivery(item.id,pd.id)"
                      >
                        far fa-trash-alt
                      </v-icon>
                    </span>
                    <span style="width:95px;display:inline-block;" class="pt-3 mr-1">
                      <v-menu
                        style="display:inline-block"
                        :nudge-right="40"
                        transition="fade-transition"
                        offset-y
                        hide-details
                        min-width="30px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            hide-details
                            style="max-height:25px;background:#DDD"
                            class="avecor-date-picker pl-1 mr-2 pa-0 ma-0"  
                            :value="customFormatter(pd.date,true)"
                            readonly
                          ></v-text-field>
                        </template>
                        <v-date-picker :value="customFormatter(pd.date)" @change="v => inlineSavePartialDelivery(item.id,pd.id,'date',v)" ></v-date-picker>
                      </v-menu>
                    </span>
                    <span style="width:100px;display:inline-block;" class="pt-3 mr-1">
                      <span class="order-expand-statuses-text">{{pd.user && staff[pd.user] ? staff[pd.user].firstName + ' ' +staff[pd.user].lastName :''}}</span>
                    </span>
                    <span class="pt-1 mr-4" style="display:inline-block;width:80px;">
                      <v-text-field
                        style="display:inline-block;max-height:25px;background:#DDD"
                        v-model="pd.deliveredAmount"
                        @change="v => inlineSavePartialDelivery(item.id,pd.id,'deliveredAmount',v)"
                        class="avecor-select pl-1"
                      ></v-text-field>
                    </span>
                    <span class="pt-2 mr-2" style="display:inline-block;width:100px;">
                      <select :value="pd.invoiceStatus" style="background:#ddd;width:100%;appearance:auto;height:26px;" @click.stop @change="v => inlineSavePartialDelivery(item.id,pd.id,'invoiceStatus',v)">
                        <option value=""></option>
                        <option value="invoice">Saa laskuttaa</option>
                        <option value="invoiced">Laskutettu</option>
                      </select>  
                    </span>
                    <span style="width:95px;display:inline-block;" class="pt-3 mr-1">
                      <v-menu
                        style="display:inline-block"
                        :nudge-right="40"
                        transition="fade-transition"
                        offset-y
                        hide-details
                        min-width="30px"
                        :disabled="true"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            hide-details
                            style="max-height:25px;background:#DDD"
                            class="avecor-date-picker pl-2 mr-2 pa-0 ma-0"  
                            :value="customFormatter(pd.invoiceDate,false)"
                            readonly
                          ></v-text-field>
                        </template>
                        <v-date-picker :value="customFormatter(pd.invoiceDate)" @change="v => inlineSavePartialDelivery(item.id,pd.id,'invoiceDate',v)" ></v-date-picker>
                      </v-menu>
                    </span>
                    <span style="width:100px;display:inline-block;" class="pt-3 mr-1">
                      <span class="order-expand-statuses-text">{{pd.invoiceUser && staff[pd.invoiceUser] ? staff[pd.invoiceUser].firstName + ' ' +staff[pd.invoiceUser].lastName :''}}</span>
                    </span>
                  </v-row>
                </div>
                <div v-else class="mt-5 mb-2">
                  <div style="margin-left:35px;width:250px;font-weight:600;padding:10px 0px;text-align:center;border:1px dotted #ccc;">Ei vielä osatoimituksia lisätty</div>
                </div>
              </div>
            </td>
            <!-- PRICES -->
            <td v-if="selectedExpandOption === 'priceDetails'" class="mt-5 " :colspan="headers.length" style="background:#fafafa;">
              <div class="avecor-table mt-2 pb-3" style="border-bottom: 1px solid #ccc; margin-top:0px; " :key="partialDeliveriesExpandKey" >
                <!-- <div style="width:100%;font-size:14px" class="pb-2 ">Hinnat</div> -->
                <v-row no-gutters>
                  <v-col cols="1"  >
                    <div style="padding:5px;background:#FFF;border:1px #ccc dotted;">
                      <div><b>Tiedot noudettu </b></div>
                      <div>{{customFormatter(item.priceDateFetchedDate, true)}}</div>
                      <div style="color:#fafafa">t</div>
                    </div>
                  </v-col>
                  <v-col cols="11" class="pl-3">
                    <h3 style="background:#F26538;color:#FFF;width:1150px;" class="pl-1">TUOTE JA MERKKAUSKULUT</h3>
                    <div style="border-bottom:1px solid #000;width:1150px;" >
                      <span class="mr-1" style="font-weight:800;width:100px;display:inline-block">Valinnat</span>
                      <span class="mr-1" style="font-weight:800;width:100px;display:inline-block">Merkkaamo</span>
                      <span class="mr-1" style="font-weight:800;width:150px;display:inline-block">Merkkaushinnaston ryhmä</span>
                      <span class="mr-1" style="font-weight:800;width:100px;display:inline-block">Jako 1</span>
                      <span class="mr-1" style="font-weight:800;width:100px;display:inline-block">Jako 2</span>
                      <span class="mr-1" style="font-weight:800;width:40px;display:inline-block">Määrä</span>
                      <span class="mr-1" style="font-weight:800;width:60px;display:inline-block">Haarukka</span>

                      <span class="mr-1" style="font-weight:800;width:80px;display:inline-block">Yksikköhinta</span>
                      <span class="mr-1" style="font-weight:800;width:40px;display:inline-block">Yht.</span>
                      <span class="mr-1" style="font-weight:800;width:80px;display:inline-block">Värien määrä</span>
                      <span class="mr-1" style="font-weight:800;width:80px;display:inline-block">Uusinta-aloitus</span>
                      <span class="mr-1" style="font-weight:800;width:120px;display:inline-block">Aloituskulut</span>
                      
                      
                    </div>
                    <div v-if="item.pricing.no_print || item.pricing.print">
                      <div v-if="item.pricing.no_print">
                        <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">{{settings.printFormatsObject['no_print'].fi}}</span>
                        <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"></span>
                        <span class="mr-1" style="font-weight:400;width:150px;display:inline-block"></span>
                        <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">
                          <span v-if="item.pricing.no_print.level1IdentifierAsProductVariation && productVariations[item.pricing.no_print.level1]">{{item.pricing.no_print.level1Identifier + ' ➔ ' + createVariationName(productVariations[item.pricing.no_print.level1],true)}}</span>
                          <span v-else-if="item.pricing.no_print.level1Identifier && item.pricing.no_print.level1">{{item.pricing.no_print.level1Identifier + ' ➔ ' + item.pricing.no_print.level1}}</span>
                        </span>

                        <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"><span v-if="item.pricing.no_print.level2Identifier && item.pricing.no_print.level2">{{item.pricing.no_print.level2Identifier + ' ➔ ' + item.pricing.no_print.level2}}</span></span>
                        <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{item.quantity}}</span>
                        <span class="mr-1" style="font-weight:400;width:60px;display:inline-block"><span v-if="item.pricing.no_print.rangeStart"> {{item.pricing.no_print.rangeEnd ? item.pricing.no_print.rangeStart + '-' + item.pricing.no_print.rangeEnd : item.pricing.no_print.rangeStart }}</span></span>
                        <span class="mr-1" style="font-weight:400;width:80px;display:inline-block">{{item.pricing.no_print.houseUnitPrice}}</span>
                        <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{(item.pricing.no_print.houseUnitPrice*item.quantity).toFixed(2)}}</span>
                        <span class="mr-1" style="font-weight:400;width:80px;display:inline-block"></span>
                        <span class="mr-1" style="font-weight:400;width:80px;display:inline-block"></span>
                        <span class="mr-1" style="font-weight:400;width:120px;display:inline-block"><span v-if="item.pricing.no_print.houseStartCosts">{{item.pricing.no_print.houseStartCosts}}</span></span>
                      
                      </div>
                      
                      <div v-if="item.pricing.print" class="pb-6">
                        <div v-for="poid in Object.keys(item.pricing.print)" :key="poid+'loop'" style="border-top:1px solid #ccc;" class="py-1">
                          <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">{{settings.printFormatsObject[item.pricing.print[poid].printFormat] ? settings.printFormatsObject[item.pricing.print[poid].printFormat].fi : item.pricing.print[poid].printFormat }}</span>
                          <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"><span v-if="item.pricing.print[poid].psId && printShops[item.pricing.print[poid].psId]">{{printShops[item.pricing.print[poid].psId].name}}</span></span>
                          <span class="mr-1" style="font-weight:400;width:150px;display:inline-block;overflow-x:hidden;"><span v-if="item.pricing.print[poid].categoryName">{{item.pricing.print[poid].categoryName}}</span></span>
                          <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">
                            <span v-if="item.pricing.print[poid].level1IdentifierAsProductVariation && productVariations[item.pricing.print[poid].level1]">{{item.pricing.print[poid].level1Identifier + ' ➔ ' + createVariationName(productVariations[item.pricing.print[poid].level1],true)}}</span>
                            <span v-else-if="item.pricing.print[poid].level1Identifier && item.pricing.print[poid].level1">{{item.pricing.print[poid].level1Identifier + ' ➔ ' + item.pricing.print[poid].level1}}</span>
                          </span>
                          <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"><span v-if="item.pricing.print[poid].level2Identifier && item.pricing.print[poid].level2">{{item.pricing.print[poid].level2Identifier + ' ➔ ' + item.pricing.print[poid].level2}}</span></span>
                          <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{item.printQuantity}}</span>
                          <span class="mr-1" style="font-weight:400;width:60px;display:inline-block"><span v-if="item.pricing.print[poid].rangeStart"> {{item.pricing.print[poid].rangeEnd ? item.pricing.print[poid].rangeStart + '-' + item.pricing.print[poid].rangeEnd : item.pricing.print[poid].rangeStart}}</span></span>
                          <span class="mr-1" style="font-weight:400;width:80px;display:inline-block">
                            {{item.pricing.print[poid].houseUnitPrice}}
                            {{(item.pricing.print[poid].isColorsMultiplierForUnitPrintPriceActivated ? ' ('+item.pricing.print[poid].colors+' x '+(item.pricing.print[poid].houseUnitPrice/item.pricing.print[poid].colors).toFixed(2)+')' : '')}}</span>
                          </span>
                          <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{(item.pricing.print[poid].houseUnitPrice*item.printQuantity).toFixed(2)}}</span>
                          <span class="mr-1 pl-2" style="font-weight:400;width:80px;display:inline-block">
                            <div v-if="item.pricing.print[poid].pfId !== 'laser' && item.pricing.print[poid].pfId !== 'digital_print' && item.pricing.print[poid].pfId !== 'uv_laser'">
                              <span style="background:#ddd;padding:2px 8px;">{{item.pricing.print[poid].colors}}</span>
                              
                              <!-- <i v-if="item.pricing.print[poid] && item.pricing.print[poid].colors && item.pricing.print[poid].colors > 1" class="fas fa-minus-circle ml-1 pointer" @click="printOptionSettingUpdate('colors', item, poid, 'subtract')" ></i>
                              <i v-else class="fas fa-minus-circle ml-1 pointer" style="color:#ccc" ></i>
                              <span style="background:#ddd;padding:2px 8px;">{{item.pricing.print[poid].colors}}</span>
                              <i class="fas fa-plus-circle pointer" @click="printOptionSettingUpdate('colors', item, poid, 'add')"></i> -->
                            </div>
                          </span>
                          <span class="mr-1" style="font-weight:400;width:80px;display:inline-block">
                            <div v-if="item.pricing.print[poid].renewal">
                              <v-icon v-if="item.pricing.print[poid].renewal" style="padding-left:5px;" color="#555" size="12">far fa-check-square</v-icon>
                              <v-icon v-else style="padding-left:5px;" color="#555" size="12">far fa-square</v-icon>

                              <!-- <v-icon v-if="item.pricing.print[poid].renewal" style="padding-left:5px;" color="#555" size="12" @click="printOptionSettingUpdate('renewal', item, poid, false)">far fa-check-square</v-icon>
                              <v-icon v-else style="padding-left:5px;" color="#555" size="12" @click="printOptionSettingUpdate('renewal', item, poid, true)">far fa-square</v-icon> -->
                            </div>
                          </span>

                          <span class="mr-1" style="font-weight:400;width:120px;display:inline-block">
                            {{item.pricing.print[poid].houseStartCosts}} 
                            {{(item.pricing.print[poid].isColorsMultiplierForUnitStartCostsActivated ? ' ('+item.pricing.print[poid].colors+' x '+(item.pricing.print[poid].houseStartCosts/item.pricing.print[poid].colors).toFixed(2)+')' : '')}}</span>
                        </div>
                      </div>
                      <!-- {{item.pricing}} -->
                    </div>
                    
                    <div v-else class="mt-5 mb-2">
                      <div style="margin-left:35px;width:250px;font-weight:600;padding:10px 0px;text-align:center;border:1px dotted #ccc;">Ei hintoja </div>
                    </div>
                  </v-col>
                </v-row>
                <!-- OTHER COSTS -->
                <v-row no-gutters v-if="item.pricing.shippingCosts || (item.pricing.otherCosts && item.pricing.otherCosts.length > 0) || (item.pricing.extraCosts && item.pricing.extraCosts.length > 0)">
                  <v-col cols="1"></v-col>
                  <v-col cols="11" class="pl-3">
                    <div style="display:inline-block;" >
                      <h3 style="background:#F26538;color:#FFF;width:1150px;" class="pl-1">LISÄKULUT</h3>

                      <div style="width:1150px;border-bottom:1px solid #000;" >
                        <span class="mr-1" style="font-weight:800;width:100px;display:inline-block">Nimi</span>
                        <span class="mr-1" style="font-weight:800;width:100px;display:inline-block">Merkkaamo</span>
                        <span class="mr-1" style="font-weight:800;width:150px;display:inline-block">Merkkaushinnaston ryhmä</span>
                        <span class="mr-1" style="font-weight:800;width:100px;display:inline-block">Mistä</span>
                        
                        <span class="mr-1" style="font-weight:800;width:100px;display:inline-block">Hintatyyppi</span>
                        <span class="mr-1" style="font-weight:800;width:40px;display:inline-block">Määrä</span>
                        <span class="mr-1" style="font-weight:800;width:60px;display:inline-block">Haarukka</span>
                        <span class="mr-1" style="font-weight:800;width:80px;display:inline-block">Yksikköhinta</span>
                        <span class="mr-1" style="font-weight:800;width:40px;display:inline-block">Yht.</span>
                      </div>
                      <div >
                        <div class="pb-6">
                          <div v-if="item.pricing.otherCosts && item.pricing.otherCosts.length > 0">
                            <div v-for="oc in item.pricing.otherCosts" :key="oc.id+'loop'" style="border-top:1px solid #ccc;" class="py-1">
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"><span v-if="oc.name">{{oc.name}}</span></span>
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"><span v-if="oc.psId && printShops[oc.psId]">{{printShops[oc.psId].name}}</span></span>
                              <span class="mr-1" style="font-weight:400;width:150px;display:inline-block;overflow-x:hidden;"><span v-if="oc.categoryName">{{oc.categoryName}}</span></span>
                              
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">
                                <span v-if="oc.via === 'product'">Tuotteelta</span>
                                <span v-if="oc.via === 'printShop'">Merkkaamolta</span>
                              </span>
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">
                                <span v-if="oc.type === 'lumpSum'">Kertasumma</span>
                                <span v-if="oc.type === 'perUnit'">Yksikköhinta</span>
                                <span v-if="oc.type === 'split'">Jaettu haarukan alkumäärän mukaan</span>
                              </span>
                              <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{item.quantity}}</span>
                              <span class="mr-1" style="font-weight:400;width:60px;display:inline-block"><span v-if="oc.rangeStart"> {{oc.rangeEnd ? oc.rangeStart + '-' + oc.rangeEnd : oc.rangeStart}}</span></span>
                              <span class="mr-1" style="font-weight:400;width:80px;display:inline-block">{{oc.houseUnitPrice}}</span>
                              <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{(oc.houseUnitPrice*item.quantity).toFixed(2)}}</span>
                            </div>
                          </div>
                          <div v-if="item.pricing.extraCosts && item.pricing.extraCosts.length > 0">
                            <div v-for="ec in item.pricing.extraCosts" :key="ec.id+'loop'" style="border-top:1px solid #ccc;" class="py-1">
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"><span v-if="ec.name">{{ec.name}}</span></span>
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"><span v-if="ec.psId && printShops[ec.psId]">{{printShops[ec.psId].name}}</span></span>
                              <span class="mr-1" style="font-weight:400;width:150px;display:inline-block;overflow-x:hidden;"><span v-if="ec.categoryName">{{ec.categoryName}}</span></span>
                              
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">
                                <span v-if="ec.via === 'product'">Tuotteelta</span>
                                <span v-if="ec.via === 'printShop'">Merkkaamolta</span>
                              </span>
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">
                                <span v-if="ec.type === 'lumpSum'">Kertasumma</span>
                                <span v-if="ec.type === 'perUnit'">Yksikköhinta</span>
                              </span>
                              <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{item.quantity}}</span>
                              <span class="mr-1" style="font-weight:400;width:60px;display:inline-block"></span>
                              <span class="mr-1" style="font-weight:400;width:80px;display:inline-block">{{ec.houseUnitPrice}}</span>
                              <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{ec.houseUnitPrice*item.quantity}}</span>
                            </div>
                          </div>
                          <!-- SEPERATE SHIPPING COSTS -->
                          <div v-if="item.pricing.shippingCosts">
                            <div style="border-top:1px solid #ccc;" class="py-1">
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"><span v-if="item.pricing.shippingCosts.name">{{item.pricing.shippingCosts.name}}</span></span>
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block"><span v-if="item.pricing.shippingCosts.psId && printShops[item.pricing.shippingCosts.psId]">{{printShops[item.pricing.shippingCosts.psId].name}}</span></span>
                              <span class="mr-1" style="font-weight:400;width:150px;display:inline-block;overflow-x:hidden;"><span v-if="item.pricing.shippingCosts.categoryName">{{item.pricing.shippingCosts.categoryName}}</span></span>
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">
                                <span v-if="item.pricing.shippingCosts.via === 'product'">Tuotteelta</span>
                                <span v-if="item.pricing.shippingCosts.via === 'printShop'">Merkkaamolta</span>
                              </span>
                              <span class="mr-1" style="font-weight:400;width:100px;display:inline-block">
                                <span v-if="item.pricing.shippingCosts.type === 'lumpSum'">Kertasumma</span>
                                <span v-if="item.pricing.shippingCosts.type === 'perUnit'">Yksikköhinta</span>
                                <span v-if="item.pricing.shippingCosts.type === 'split'">Jaettu haarukan alkumäärän mukaan</span>
                              </span>
                              <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{item.quantity}}</span>
                              <span class="mr-1" style="font-weight:400;width:60px;display:inline-block"><span v-if="item.pricing.shippingCosts.rangeStart"> {{item.pricing.shippingCosts.rangeEnd ? item.pricing.shippingCosts.rangeStart + '-' + item.pricing.shippingCosts.rangeEnd : item.pricing.shippingCosts.rangeStart}}</span></span>
                              <span class="mr-1" style="font-weight:400;width:80px;display:inline-block">{{item.pricing.shippingCosts.houseUnitPrice}}</span>
                              <span class="mr-1" style="font-weight:400;width:40px;display:inline-block">{{(item.pricing.shippingCosts.houseUnitPrice*item.quantity).toFixed(2)}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </td>
            <!-- CHANGE PRODUCT -->
            <td v-if="selectedExpandOption === 'productChange'" class="pa-0" :colspan="headers.length">
              <div class="avecor-table pa-3" style="border-bottom: 1px solid #ccc; margin-top:0px;background:#FFF; " :key="partialDeliveriesExpandKey" >
                <div style="width:100%;" class="pb-2">
                  <span style="font-size:14px;font-weight:600;">Tuotteen vaihto</span>
                </div>
                <span style="border-bottom:1px solid #ccc;display:inline-block;mb-2">
                  <span class="mr-1" style="width:100px;display:inline-block;"></span>
                  <span class="" style="font-weight:800;width:400px;display:inline-block;">Tuote</span>
                  <span class="ml-10" style="font-weight:800;width:400px;display:inline-block;">Merkkaus 1</span>
                  <span class="ml-10" style="font-weight:800;width:400px;display:inline-block;">Merkkaus 2</span>
                </span>
                <div ></div>
                <span class="hide-field-details pb-3" style="border-bottom:1px solid #ccc;display:inline-block;">
                  <span class="mr-1" style="width:100px;display:inline-block;font-weight:600">Nykyinen tuote</span>
                  <span class="" style="width:400px;display:inline-block;">
                    <!-- @change="value => productVariationUpdate(item.id,'productVariationId',value)" -->
                    <v-autocomplete
                      v-model="item.productVariationId"
                      :items="getCatalogProductsAndVariations"
                      persistent-hint
                      item-text="text"
                      item-value="value"
                      rows=2
                      class="avecor-select avecor-ordered-producet-select pt-0 mt-0 minimize-height"
                      style="color:#000"
                      readonly
                    />
                  </span>
                  <span class="ml-10" style="width:400px;display:inline-block;">
                    <div v-if="item.print && !item.newPrintOptionsInUse">
                      <v-autocomplete
                        v-if="products[item.productId].printFormats && products[item.productId].printFormats.length > 0"
                        v-model="item.printFormats"
                        :items="settings.printFormats"
                        readonly
                        item-text="fi"
                        item-value="id"
                        multiple
                        class="avecor-select avecor-multi-select-slim"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        dense
                      />
                      <v-text-field
                        v-else
                        v-model="item.printFormatsText"
                        readonly
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        class="avecor-select avecor-multi-select-slim"
                      ></v-text-field>
                      <div>
                        <v-autocomplete
                          readonly
                          autocomplete="off"
                          v-model="item.numberOfPrintColors"
                          :items="settings.numberOfPrintColors"
                          persistent-hint
                          style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                          class="avecor-select avecor-multi-select-slim"
                          dense>
                          <template v-slot:selection="data">
                              <div style="line-height:15px;">
                                <span style="font-size:8px;padding-right:5px;"><b>Värien määrä: </b></span>
                                <span>{{ data.item }} </span>
                              </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </div>
                    <div v-if="item.print && item.printOptions && item.printOptionsSettings && products[item.productId] && products[item.productId].prices">
                      <!-- :disabled="isOrderDisabled" -->
                      <v-autocomplete
                        :disabled="true"
                        :value="item.printOptions"
                        :items="printFormatsFromPricingForProduct(item.productId)"
                        multiple
                        item-text="text"
                        item-value="id"
                        class="avecor-select avecor-multi-select-slim avecor-multi-select-input-0-height"
                        style="padding:0px 2px 1px 0px;line-height:10px;min-height:12px;" 
                        dense>
                        <template v-slot:selection="data">
                          <div
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            style="border-radius:5px;background:#eee;color:#000;padding:5px;margin-top:2px;"
                          >
                            <div>{{ data.item.text}} </div>
                            <div v-if="item.printOptionsSettings[data.item.id] && item.printOptionsSettings[data.item.id].renewal">
                              <span class="">Uusinta-aloitus</span>
                              <i v-if="item.printOptionsSettings[data.item.id] && item.printOptionsSettings[data.item.id].renewal" :style="'color:#555;font-size:10px;cursor:pointer;'" class="far fa-check-square "></i>
                              <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-square"></i>
                            </div>
                            <span v-if="item.printOptionsSettings[data.item.id] && item.printOptionsSettings[data.item.id].colors" class="">Värien määrä {{item.printOptionsSettings[data.item.id].colors }}</span>
                          </div>
                        </template>
                        <template v-slot:item="pfItemProps" ><!-- {active, item, attrs, on } -->
                          <v-list-item v-on="pfItemProps.on" v-bind="pfItemProps.attrs" #default="{ active }" style="min-width:350px;color:#000;" class="custom-print-format-list-item px-0" dense>
                            <v-list-item-content @click.stop="()=>{}"> 
                              <v-list-item-title @click.stop="()=>{}" >
                                <v-row no-gutters align="center" style="color:#000 !important;" @click.stop="()=>{}" class="px-4">
                                  <span @click.stop="()=>{}" class="mr-5">
                                    <i v-if="active" :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(1,item,'remove',pfItemProps.item.id)" class="far fa-check-square pl-1 pr-2"></i>
                                    <i v-else :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(1,item,'add',pfItemProps.item.id)" class="far fa-square pl-1 pr-2"></i>
                                    <span>{{pfItemProps.item.text}}</span>
                                  </span>
                                  <v-spacer></v-spacer>
                                  <!-- <div style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:175px;"> -->
                                  <div v-if="item.printOptionsSettings[pfItemProps.item.id] && ((pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0) || pfItemProps.item.renewAvailable || (pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'))" style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:400px;">
                                    <div v-if="pfItemProps.item.renewAvailable">
                                      <i v-if="item.printOptionsSettings[pfItemProps.item.id] && item.printOptionsSettings[pfItemProps.item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'renewal', item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                      <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'renewal', item, pfItemProps.item.id, true) " class="far fa-square pl-1 pr-2"></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Uusinta-aloitus</div>
                                    </div>
                                    <!-- <div class="pt-1"> -->
                                    <div class="pt-1" v-if="pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'" >
                                      <i v-if="item.printOptionsSettings[pfItemProps.item.id] && item.printOptionsSettings[pfItemProps.item.id].colors && item.printOptionsSettings[pfItemProps.item.id].colors > 1" class="fas fa-minus-circle ml-1" @click="printOptionSettingUpdate(1,'colors', item, pfItemProps.item.id, 'subtract')" ></i>
                                      <i v-else class="fas fa-minus-circle ml-1" style="color:#ccc" ></i>
                                      <span class="px-1 mx-1" style="border:1px solid #ccc;background:#FFF;">{{item.printOptionsSettings[pfItemProps.item.id].colors ? item.printOptionsSettings[pfItemProps.item.id].colors : '-'}}</span>
                                      <i class="fas fa-plus-circle" @click="printOptionSettingUpdate(1,'colors', item, pfItemProps.item.id, 'add');" ></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Värien määrä</div>
                                    </div>
                                    <div v-if="pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0" class="pt-2">
                                      <div v-for="(ec, i) in pfItemProps.item.extraCosts" :key="ec.id+'_ec_'+i">
                                        <i v-if="item.printOptionsSettings[pfItemProps.item.id] && item.printOptionsSettings[pfItemProps.item.id]['ec_'+ec.id]" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'ec_'+ec.id, item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                        <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(1,'ec_'+ec.id, item, pfItemProps.item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                        <div style="display:inline-block;" class="pr-2">{{ec.name + ' ('+ec.price+'€)'}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </v-row>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                  </span>
                  <span class="ml-10" style="width:400px;display:inline-block;">
                    <div v-if="item.secondPrint && !item.newPrintOptionsInUse">
                      <v-autocomplete
                        readonly
                        v-if="products[item.productId].printFormats && products[item.productId].printFormats.length > 0"
                        v-model="item.printFormats2"
                        :items="settings.printFormats"
                        item-text="fi"
                        item-value="id"
                        multiple
                        class="avecor-select avecor-multi-select-slim"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        dense
                      />
                      <v-text-field
                        readonly
                        v-else
                        v-model="item.printFormatsText2"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        class="avecor-select avecor-multi-select-slim"
                      ></v-text-field>
                      <div>
                        <v-autocomplete
                          readonly
                          autocomplete="off"
                          v-model="item.numberOfPrintColors2"
                          :items="settings.numberOfPrintColors"
                          persistent-hint
                          style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                          class="avecor-select avecor-multi-select-slim"
                          dense>
                          <template v-slot:selection="data">
                              <div style="line-height:15px;">
                                <span style="font-size:8px;padding-right:5px;"><b>Värien määrä: </b></span>
                                <span>{{ data.item }} </span>
                              </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </div>
                    <div class="" style="" v-if="item.secondPrint && item.printOptions && item.printOptionsSettings && products[item.productId] && products[item.productId].prices">
                      <!-- :disabled="isOrderDisabled" -->
                      <v-autocomplete
                        :disabled="true"
                        :value="item.printOptions2"
                        :items="printFormatsFromPricingForProduct(item.productId)"
                        multiple
                        item-text="text"
                        item-value="id"
                        class="avecor-select avecor-multi-select-slim avecor-multi-select-input-0-height"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;margin-top:3px;" 
                        dense>
                        <template v-slot:selection="data">
                          <div
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            style="border-radius:5px;background:#eee;color:#000;padding:5px;margin-top:2px;"
                          >
                            <div>{{ data.item.text}} </div>
                            <div v-if="item.printOptionsSettings2[data.item.id] && item.printOptionsSettings2[data.item.id].renewal">
                              <span class="">Uusinta-aloitus</span>
                              <i v-if="item.printOptionsSettings2[data.item.id] && item.printOptionsSettings2[data.item.id].renewal" :style="'color:#555;font-size:10px;cursor:pointer;'" class="far fa-check-square "></i>
                              <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-square"></i>
                            </div>
                            <span v-if="item.printOptionsSettings2[data.item.id] && item.printOptionsSettings2[data.item.id].colors" class="">Värien määrä {{item.printOptionsSettings2[data.item.id].colors }}</span>
                            
                          </div>
                        </template>
                        <template v-slot:item="pfItemProps" >
                          <v-list-item v-on="pfItemProps.on" v-bind="pfItemProps.attrs" #default="{ active }" style="min-width:350px;color:#000;" class="custom-print-format-list-item px-0" dense>
                            <v-list-item-content @click.stop="()=>{}"> 
                              <v-list-item-title @click.stop="()=>{}" >
                                <v-row no-gutters align="center" style="color:#000 !important;" @click.stop="()=>{}" class="px-4">
                                  <span @click.stop="()=>{}" class="mr-5">
                                    <i v-if="active" :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(2,item,'remove',pfItemProps.item.id)" class="far fa-check-square pl-1 pr-2"></i>
                                    <i v-else :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOption(2,item,'add',pfItemProps.item.id)" class="far fa-square pl-1 pr-2"></i>
                                    <span>{{pfItemProps.item.text}}</span>
                                  </span>
                                  <v-spacer></v-spacer>
                                  <div v-if="item.printOptionsSettings2[pfItemProps.item.id] && ((pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0) || pfItemProps.item.renewAvailable || (pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'))" style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:400px;">
                                    <div v-if="pfItemProps.item.renewAvailable">
                                      <i v-if="item.printOptionsSettings2[pfItemProps.item.id] && item.printOptionsSettings2[pfItemProps.item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'renewal', item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                      <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'renewal', item, pfItemProps.item.id, true) " class="far fa-square pl-1 pr-2"></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Uusinta-aloitus</div>
                                    </div>
                                    <div class="pt-1" v-if="pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'" >
                                      <i v-if="item.printOptionsSettings2[pfItemProps.item.id] && item.printOptionsSettings2[pfItemProps.item.id].colors && item.printOptionsSettings2[pfItemProps.item.id].colors > 1" class="fas fa-minus-circle ml-1" @click="printOptionSettingUpdate(2,'colors', item, pfItemProps.item.id, 'subtract')" ></i>
                                      <i v-else class="fas fa-minus-circle ml-1" style="color:#ccc" ></i>
                                      <span class="px-1 mx-1" style="border:1px solid #ccc;background:#FFF;">{{item.printOptionsSettings2[pfItemProps.item.id].colors ? item.printOptionsSettings2[pfItemProps.item.id].colors : '-'}}</span>
                                      <i class="fas fa-plus-circle" @click="printOptionSettingUpdate(2,'colors', item, pfItemProps.item.id, 'add');" ></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Värien määrä</div>
                                    </div>
                                    <div v-if="pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0" class="pt-2">
                                      <div v-for="(ec, i) in pfItemProps.item.extraCosts" :key="ec.id+'_ec_'+i">
                                        <i v-if="item.printOptionsSettings2[pfItemProps.item.id] && item.printOptionsSettings2[pfItemProps.item.id]['ec_'+ec.id]" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'ec_'+ec.id, item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                        <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdate(2,'ec_'+ec.id, item, pfItemProps.item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                        <div style="display:inline-block;" class="pr-2">{{ec.name + ' ('+ec.price+'€)'}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </v-row>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                  </span>

                </span>
                <div ></div>
                <!-- UUSI TUOTE -->
                <span class="hide-field-details pt-3 pb-3 mb-5" style="border-bottom:1px solid #ccc;display:inline-block;">
                  <span class="mr-1" style="width:100px;display:inline-block;font-weight:600">Uusi tuote</span>
                  <span class="" style="width:400px;display:inline-block;">
                    <v-autocomplete
                      v-model="newProductVariationId"
                      :items="getCatalogProductsAndVariations"
                      persistent-hint
                      placeholder="Valitse tuote"
                      item-text="text"
                      item-value="value"
                      rows=2
                      class="avecor-select avecor-ordered-producet-select pt-0 mt-0 minimize-height"
                      style="padding:0px 0px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                      :disabled="isOrderDisabled"
                    />
                  </span>
                  <!-- FIRST PRINT -->
                  <span class="ml-10" style="width:400px;display:inline-block;">
                    <div v-if="item.print && productVariations[newProductVariationId] && products[productVariations[newProductVariationId].productId] && products[productVariations[newProductVariationId].productId].prices">
                      <v-autocomplete
                        :disabled="isOrderDisabled"
                        :value="newPrintOptions"
                        :items="printFormatsFromPricingForProduct(productVariations[newProductVariationId].productId)"
                        multiple
                        item-text="text"
                        item-value="id"
                        class="avecor-select avecor-multi-select-slim avecor-multi-select-input-0-height"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        dense>
                        <template v-slot:selection="data">
                          <div
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            style="border-radius:5px;background:#bbb;padding:5px;margin-top:2px;"
                          >
                            <div>{{ data.item.text}} </div>
                            <div v-if="newPrintOptionsSettings[data.item.id] && newPrintOptionsSettings[data.item.id].renewal">
                              <span class="">Uusinta-aloitus</span>
                              <i v-if="newPrintOptionsSettings[data.item.id] && newPrintOptionsSettings[data.item.id].renewal" :style="'color:#555;font-size:10px;cursor:pointer;'" class="far fa-check-square "></i>
                              <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-square"></i>
                            </div>
                            <span v-if="newPrintOptionsSettings[data.item.id] && newPrintOptionsSettings[data.item.id].colors" class="">Värien määrä {{newPrintOptionsSettings[data.item.id].colors }}</span>
                          </div>
                        </template>
                        <template v-slot:item="pfItemProps" ><!-- {active, item, attrs, on } -->
                          <v-list-item v-on="pfItemProps.on" v-bind="pfItemProps.attrs" #default="{ active }" style="min-width:350px;color:#000;" class="custom-print-format-list-item px-0" dense>
                            <v-list-item-content @click.stop="()=>{}"> 
                              <v-list-item-title @click.stop="()=>{}" >
                                <v-row no-gutters align="center" style="color:#000 !important;" @click.stop="()=>{}" class="px-4">
                                  <span @click.stop="()=>{}" class="mr-5">
                                    <i v-if="active" :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOptionFromNewProduct(1,item,'remove',pfItemProps.item.id)" class="far fa-check-square pl-1 pr-2"></i>
                                    <i v-else :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOptionFromNewProduct(1,item,'add',pfItemProps.item.id)" class="far fa-square pl-1 pr-2"></i>
                                    <span>{{pfItemProps.item.text}}</span>
                                  </span>
                                  <v-spacer></v-spacer>
                                  <!-- <div style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:175px;"> -->
                                  <div v-if="newPrintOptionsSettings[pfItemProps.item.id] && ((pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0) || pfItemProps.item.renewAvailable || (pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'))" style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:400px;">
                                    <div v-if="pfItemProps.item.renewAvailable">
                                      <i v-if="newPrintOptionsSettings[pfItemProps.item.id] && newPrintOptionsSettings[pfItemProps.item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdateNewProduct(1,'renewal', item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                      <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdateNewProduct(1,'renewal', item, pfItemProps.item.id, true) " class="far fa-square pl-1 pr-2"></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Uusinta-aloitus</div>
                                    </div>
                                    <!-- <div class="pt-1"> -->
                                    <div class="pt-1" v-if="pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'" >
                                      <i v-if="newPrintOptionsSettings[pfItemProps.item.id] && newPrintOptionsSettings[pfItemProps.item.id].colors && newPrintOptionsSettings[pfItemProps.item.id].colors > 1" class="fas fa-minus-circle ml-1" @click="printOptionSettingUpdateNewProduct(1,'colors', item, pfItemProps.item.id, 'subtract')" ></i>
                                      <i v-else class="fas fa-minus-circle ml-1" style="color:#ccc" ></i>
                                      <span class="px-1 mx-1" style="border:1px solid #ccc;background:#FFF;">{{newPrintOptionsSettings[pfItemProps.item.id].colors ? newPrintOptionsSettings[pfItemProps.item.id].colors : '-'}}</span>
                                      <i class="fas fa-plus-circle" @click="printOptionSettingUpdateNewProduct(1,'colors', item, pfItemProps.item.id, 'add');" ></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Värien määrä</div>
                                    </div>
                                    <div v-if="pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0" class="pt-2">
                                      <div v-for="(ec, i) in pfItemProps.item.extraCosts" :key="ec.id+'_ec_'+i">
                                        <i v-if="newPrintOptionsSettings[pfItemProps.item.id] && newPrintOptionsSettings[pfItemProps.item.id]['ec_'+ec.id]" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdateNewProduct(1,'ec_'+ec.id, item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                        <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdateNewProduct(1,'ec_'+ec.id, item, pfItemProps.item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                        <div style="display:inline-block;" class="pr-2">{{ec.name + ' ('+ec.price+'€)'}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </v-row>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                    <!-- newPrintFormats:[],
      newPrintFormatsText:'',
      newNumberOfPrintColors:0, -->
                    <div v-else-if="item.print && newProductVariationId">
                      <v-autocomplete
                        v-if="products[productVariations[newProductVariationId].productId].printFormats && products[productVariations[newProductVariationId].productId].printFormats.length > 0"
                        v-model="newPrintFormats"
                        :items="settings.printFormats"
                        item-text="fi"
                        item-value="id"
                        multiple
                        class="avecor-select avecor-multi-select-slim"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        dense
                      />
                      <v-text-field
                        v-else
                        v-model="newPrintFormatsText"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        class="avecor-select avecor-multi-select-slim"
                      ></v-text-field>
                      <div>
                        <v-autocomplete
                          autocomplete="off"
                          v-model="newNumberOfPrintColors"
                          :items="settings.numberOfPrintColors"
                          persistent-hint
                          style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                          class="avecor-select avecor-multi-select-slim"
                          dense>
                          <template v-slot:selection="data">
                              <div style="line-height:15px;">
                                <span style="font-size:8px;padding-right:5px;"><b>Värien määrä: </b></span>
                                <span>{{ data.item }} </span>
                              </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </div>
                  </span>
                  <!-- SECOND PRINT -->
                  <span class="ml-10" style="width:400px;display:inline-block;">
                    <div class="" style="" v-if="item.secondPrint && productVariations[newProductVariationId] && products[productVariations[newProductVariationId].productId] && products[productVariations[newProductVariationId].productId].prices">
                      <v-autocomplete
                        :disabled="isOrderDisabled"
                        :value="newPrintOptions2"
                        :items="printFormatsFromPricingForProduct(productVariations[newProductVariationId].productId)"
                        multiple
                        item-text="text"
                        item-value="id"
                        class="avecor-select avecor-multi-select-slim avecor-multi-select-input-0-height"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;margin-top:3px;" 
                        dense>
                        <template v-slot:selection="data">
                          <div
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            style="border-radius:5px;background:#bbb;padding:5px;margin-top:2px;"
                          >
                            <div>{{ data.item.text}} </div>
                            <div v-if="newPrintOptionsSettings2[data.item.id] && newPrintOptionsSettings2[data.item.id].renewal">
                              <span class="">Uusinta-aloitus</span>
                              <i v-if="newPrintOptionsSettings2[data.item.id] && newPrintOptionsSettings2[data.item.id].renewal" :style="'color:#555;font-size:10px;cursor:pointer;'" class="far fa-check-square "></i>
                              <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" class="far fa-square"></i>
                            </div>
                            <span v-if="newPrintOptionsSettings2[data.item.id] && newPrintOptionsSettings2[data.item.id].colors" class="">Värien määrä {{newPrintOptionsSettings2[data.item.id].colors }}</span>
                            
                          </div>
                        </template>
                        <template v-slot:item="pfItemProps" >
                          <v-list-item v-on="pfItemProps.on" v-bind="pfItemProps.attrs" #default="{ active }" style="min-width:350px;color:#000;" class="custom-print-format-list-item px-0" dense>
                            <v-list-item-content @click.stop="()=>{}"> 
                              <v-list-item-title @click.stop="()=>{}" >
                                <v-row no-gutters align="center" style="color:#000 !important;" @click.stop="()=>{}" class="px-4">
                                  <span @click.stop="()=>{}" class="mr-5">
                                    <i v-if="active" :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOptionFromNewProduct(2,item,'remove',pfItemProps.item.id)" class="far fa-check-square pl-1 pr-2"></i>
                                    <i v-else :style="'color:#555;font-size:16px;cursor:pointer;'" @click="addOrRemovePrintOptionFromNewProduct(2,item,'add',pfItemProps.item.id)" class="far fa-square pl-1 pr-2"></i>
                                    <span>{{pfItemProps.item.text}}</span>
                                  </span>
                                  <v-spacer></v-spacer>
                                  <div v-if="newPrintOptionsSettings2[pfItemProps.item.id] && ((pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0) || pfItemProps.item.renewAvailable || (pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'))" style="background:#eee;padding:4px;border:1px dotted #ccc;display:inline-block;width:400px;">
                                    <div v-if="pfItemProps.item.renewAvailable">
                                      <i v-if="newPrintOptionsSettings2[pfItemProps.item.id] && newPrintOptionsSettings2[pfItemProps.item.id].renewal" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdateNewProduct(2,'renewal', item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                      <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdateNewProduct(2,'renewal', item, pfItemProps.item.id, true) " class="far fa-square pl-1 pr-2"></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Uusinta-aloitus</div>
                                    </div>
                                    <div class="pt-1" v-if="pfItemProps.item.pfId !== 'laser' && pfItemProps.item.pfId !== 'digital_print' && pfItemProps.item.pfId !== 'uv_laser'" >
                                      <i v-if="newPrintOptionsSettings2[pfItemProps.item.id] && newPrintOptionsSettings2[pfItemProps.item.id].colors && newPrintOptionsSettings2[pfItemProps.item.id].colors > 1" class="fas fa-minus-circle ml-1" @click="printOptionSettingUpdateNewProduct(2,'colors', item, pfItemProps.item.id, 'subtract')" ></i>
                                      <i v-else class="fas fa-minus-circle ml-1" style="color:#ccc" ></i>
                                      <span class="px-1 mx-1" style="border:1px solid #ccc;background:#FFF;">{{newPrintOptionsSettings2[pfItemProps.item.id].colors ? newPrintOptionsSettings2[pfItemProps.item.id].colors : '-'}}</span>
                                      <i class="fas fa-plus-circle" @click="printOptionSettingUpdateNewProduct(2,'colors', item, pfItemProps.item.id, 'add');" ></i>
                                      <div style="display:inline-block;width:100px;" class="pr-2">Värien määrä</div>
                                    </div>
                                    <div v-if="pfItemProps.item.extraCosts && pfItemProps.item.extraCosts.length > 0" class="pt-2">
                                      <div v-for="(ec, i) in pfItemProps.item.extraCosts" :key="ec.id+'_ec_'+i">
                                        <i v-if="newPrintOptionsSettings2[pfItemProps.item.id] && newPrintOptionsSettings2[pfItemProps.item.id]['ec_'+ec.id]" :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdateNewProduct(2,'ec_'+ec.id, item, pfItemProps.item.id, false)" class="far fa-check-square pl-1 pr-2"></i>
                                        <i v-else :style="'color:#555;font-size:12px;cursor:pointer;'" @click="printOptionSettingUpdateNewProduct(2,'ec_'+ec.id, item, pfItemProps.item.id, true)" class="far fa-square pl-1 pr-2"></i>
                                        <div style="display:inline-block;" class="pr-2">{{ec.name + ' ('+ec.price+'€)'}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </v-row>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                    <div v-else-if="item.secondPrint && newProductVariationId">
                      <v-autocomplete
                        v-if="products[productVariations[newProductVariationId].productId].printFormats && products[productVariations[newProductVariationId].productId].printFormats.length > 0"
                        v-model="newPrintFormats2"
                        :items="settings.printFormats"
                        item-text="fi"
                        item-value="id"
                        multiple
                        class="avecor-select avecor-multi-select-slim"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        dense
                      />
                      <v-text-field
                        v-else
                        v-model="newPrintFormatsText2"
                        style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                        class="avecor-select avecor-multi-select-slim"
                      ></v-text-field>
                      <div>
                        <v-autocomplete
                          autocomplete="off"
                          v-model="newNumberOfPrintColors2"
                          :items="settings.numberOfPrintColors"
                          persistent-hint
                          style="padding:0px 2px 1px 3px;line-height:10px;min-height:12px;background:#DDDDDD;" 
                          class="avecor-select avecor-multi-select-slim"
                          dense>
                          <template v-slot:selection="data">
                              <div style="line-height:15px;">
                                <span style="font-size:8px;padding-right:5px;"><b>Värien määrä: </b></span>
                                <span>{{ data.item }} </span>
                              </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </div>
                  </span>
                  
                </span>
                <div></div>
                <button v-if="allAccess" class="avecor-button-global add-button px-3 ml-0 mb-1" @click="changeProduct(item,false)" style="">MUUTA TUOTE</button>
                <button v-if="allAccess" class="avecor-button-global add-button px-3 ml-3 mb-1" @click="changeProduct(item,true)" style="">MUUTA TUOTE JA PÄIVITÄ SIS. OSTOHINNAT</button>
              </div>
            </td>


          </template>
        </v-data-table>
      </div>
      <FetchDraftsModal v-if="selectedOrder" v-model="draftsModalOpen" :order="selectedOrder" />
    </div>
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import firebase from 'firebase'
import shared from './../../shared'
import axios from 'axios'

var db = null

export default {
    props: ["location","displayType"],
    created () {
      this.createVariationName = shared.createVariationName
      this.createVariationAvecorSku = shared.createVariationAvecorSku
      this.createVariationNameDataIncluded = shared.createVariationNameDataIncluded
      this.createVariationAvecorSkuDataIncluded = shared.createVariationAvecorSkuDataIncluded
      this.syncOrderToNetvisor = shared.syncOrderToNetvisor
      this.logStockUpdateProductChange = shared.logStockUpdateProductChange
      this.calculateReserved = shared.calculateReserved
      this.logToOrderHistory = shared.logToOrderHistory
      this.getWeekString = shared.getWeekString
      this.getWeek = shared.getWeek
      this.printFormatsFromPricingForProduct = shared.printFormatsFromPricingForProduct
      this.getDeliveryMarginForOrder = shared.getDeliveryMarginForOrder
      this.getOptionDetailsById = shared.getOptionDetailsById
      this.formatToThreeDecimals = shared.formatToThreeDecimals
    },
    async mounted() {
      db = firebase.firestore();
      this.calculateReserved()
      this.refOrderedProducts = []
      this.ordersAll = {...this.orders, ...this.searchOrders}

      if(this.selectedOrder.isOffer){
        var orderedProducts = {}
        var id = this.selectedOrderId
        if(this.offerOrders[id]) orderedProducts = this.offerOrderedProducts
        else if(this.searchOrders[id]) orderedProducts = this.searchOrderedProducts
        else if(this.orders[id]) orderedProducts = this.orderedProducts
        
        var refOpIds = []
        Object.keys(orderedProducts).forEach(function(key) {
          var op = orderedProducts[key]
          if(id === op.orderId && op.refOpId) refOpIds.push(op.refOpId)
        })
        for(var i = 0; i < refOpIds.length; i++){
          var refOpId = refOpIds[i]
          var opRef = await db.collection("orderedProducts").doc(refOpId).get()

          var op = opRef.data()
          console.log("REF OP")
          console.log(op)
          if(op) this.refOrderedProducts.push({...op,isRefOp:true})
        }
      }
    },
    data: () => ({
      draftsModalOpen:false,
      setMarginDeliveryCharge:false,
      refOrderedProducts:[],
      newPrintOptions:[],
      newPrintOptionsSettings:{},
      newPrintOptions2:[],
      newPrintOptionsSettings2:{},
      newPrintFormats:[],
      newPrintFormatsText:'',
      newNumberOfPrintColors:0,
      newPrintFormats2:[],
      newPrintFormatsText2:'',
      newNumberOfPrintColors2:0,
      newProductVariationId:'',
      allProductsSelected:false,
      print_info_key:456787,
      showArchived:true,
      batchStatusAllItems:false,
      selectedExpandOption:'partialDeliveries',
      batchStatuses:[],
      batchStatusUpdateItems:{},
      batchOrderStatus:'',
      batchShippedDate:'',
      batchInvoiceDate:'',
      batchOrderInvoiceStatus:'',
      dialog: false,
      selectedFileForMediaViewer:"",
      table: null,
      autogrow: true,
      expanded: [],
      singleExpand: true,
      selected: [],
      search: '',
      desktopHeaders: [
        { text: ' ', value: 'name', align: 'center', sortable: false },
        { text: 'Tuotenimi', value: 'productName', align: 'left', sortable: false},
        { text: 'Tietoja', value: 'booleans', align: 'left', sortable: false},
        { text: '', value: 'info', align: 'left', sortable: false},
        { text: 'Mallit', value: 'numberOfSamples', align: 'left', sortable: false},
        { text: '', value: 'split', align: 'left', sortable: false},
        { text: '', value: '', align: 'left', sortable: false, class:""},
        { text: 'Määrä', value: 'quantity', align: 'left', sortable: false},
        { text: 'Myynti á hinta', value: 'unitPrice', align: 'left', sortable: false},
        { text: 'Sisään á hinta', value: 'unitPrice', align: 'left', sortable: false},
        { text: 'Yhteensä ulos', value: 'sum', align: 'left', sortable: false},
        { text: 'Yhteensä sisään', value: 'sum', align: 'left', sortable: false},
        { text: 'Laskettu kate', value: 'unitPrice', align: 'left', sortable: false},
        //{ text: 'Kate ok?', value: 'sum', align: 'left', sortable: false, class:""},
        { text: '', value: '_', align: 'left', sortable: false, class:""},
        { text: 'Katteet', value: 'margins', align: 'left', sortable: false, class:""},
        //{ text: '', value: '', align: 'left', sortable: false, class:""},
        { text: 'Merkkaustiedot', value: 'printInfo', align: 'left', sortable: false },
        //{ text: 'Merk.', value: 'print', align: 'left', sortable: false },
        //{ text: 'Merkkaustapa', value: 'printFormat', align: 'left', sortable: false },
        //{ text: 'Merkkaustiedot', value: 'printLocation', align: 'left', sortable: false },
        { text: 'Viim. asiak. ', value: 'latestToCustomer', align: 'left', sortable: false },
        { text: 'Jälkitoimitus määrä', value: 'backOrderAmount', align: 'left', sortable: false },
        { text: '', value: 'select', align: 'left', sortable: false },
        { text: 'Toim. status', value: 'orderStatus', align: 'left', sortable: false },
        { text: 'Lähet. asiak. pvm. ', value: 'shippedDate', align: 'left', sortable: false },
        { text: 'Lask. status', value: 'orderInvoiceStatus', align: 'left', sortable: false },
        { text: 'Laskutus pvm. ', value: 'whenToInvoice', align: 'left', sortable: false },
      ],
      
      mobileHeaders: [
        { text: 'Tuotenimi', value: 'productId', align: 'left', sortable: false},
        //{ text: 'Tuotekoodi', value: 'sku', align: 'left', sortable: false},
        { text: 'Määrä', value: 'quantity', align: 'left', sortable: false},
        { text: 'Myynti á hinta', value: 'unitPrice', align: 'left', sortable: false},
        { text: 'Mallit', value: 'numberOfSamples', align: 'left', sortable: false},
        { text: 'Merk. määrä', value: 'printQuantity', align: 'left', sortable: false},
        { text: 'Merk. á hinta', value: 'unitPrintPrice', align: 'left', sortable: false},
        { text: 'Asem. määrä', value: 'quantity', align: 'left', sortable: false},
        { text: 'Asem. á myyntihinta', value: 'unitPrice', align: 'left', sortable: false},
        { text: 'Yhteensä', value: 'sum', align: 'left', sortable: false},
      ],
      ordersSampleHeaders: [
        { text: ' ', value: 'name', align: 'center', sortable: false },
        { text: 'Tuotenimi', value: 'productId', align: 'left', sortable: false},
        { text: 'Tietoja', value: 'booleans', align: 'left', sortable: false},
        { text: '', value: 'info', align: 'left', sortable: false},
        
        { text: 'Mallit', value: 'numberOfSamples', align: 'left', sortable: false},
        { text: '-', value: 'batchStatusChange', align: 'left', sortable: false },
        { text: 'Toim. status', value: 'orderStatus', align: 'left', sortable: false },
        { text: 'Lähetetty asiak. pvm. ', value: 'shippedDate', align: 'left', sortable: false },
      ],
      marginsSampleHeaders: [
        { text: ' ', value: 'name', align: 'center', sortable: false },
        { text: 'Tuotenimi', value: 'productId', align: 'left', sortable: false},
        { text: 'Malli tilaus?', value: 'sample', align: 'left', sortable: false},
        { text: 'Varasto tuote?', value: 'warehouseProduct', align: 'left', sortable: false},
        { text: 'Hinnas -tossa?', value: 'listedProduct', align: 'left', sortable: false},
        { text: 'Miten tilaus?', value: 'orderStyle', align: 'left', sortable: false},
        { text: 'Tuotekommentit', value: 'officeComments', align: 'left', sortable: false},
        { text: 'Merkkaamo', value: 'printShop', align: 'left', sortable: false},
        { text: 'Tukkuri-tuotekoodi', value: 'wholesaleSku', align: 'left', sortable: false},
        { text: 'Avecor-tuotekoodi', value: 'sku', align: 'left', sortable: false},
        { text: 'Mallit', value: 'numberOfSamples', align: 'left', sortable: false},
        { text: '-', value: 'batchStatusChange', align: 'left', sortable: false },
        { text: 'Toim. status', value: 'orderStatus', align: 'left', sortable: false },
        { text: 'Lähetetty asiak. pvm. ', value: 'shippedDate', align: 'left', sortable: false },
      ],
      
      editedIndex: -1,
      latestToCustomerDatePickerMenuMaster : false,
      latestToCustomerDatePickerMenu: [false,false,false,false,false,false,false,false,false,false],
      latestToCustomerDatePickerMenu: false,
      date: new Date().toISOString().substr(0, 10),
      partialDeliveriesExpandKey: 45647895512,
      isAllNew:true,
      ordersAll:{}
    }),
    computed: {
      totalOfficeMarginForOrder(){
        var ops = this.getOrderedProducts
        var totalMargin = 0
        ops.forEach(op => {
          op.confirmedMargin ? totalMargin += op.confirmedMargin : ''
        })
        return totalMargin
      },
      totalSalespersonMarginForOrder(){
        var ops = this.getOrderedProducts
        var totalMargin = 0
        ops.forEach(op => {
          op.salespersonMargin && !isNaN(Number(op.salespersonMargin)) ? totalMargin += Number(op.salespersonMargin) : ''
        })

        return totalMargin.toFixed(2)
      },
      getHeaders(){
        
        if(this.selectedOrder.sample === undefined || !this.selectedOrder.sample){
          return this.desktopHeaders
        }
        else {
          if(this.location === 'orders' || this.location === 'stock'){
            return this.ordersSampleHeaders
          }
          if(this.location === 'margins'){
            return this.marginsSampleHeaders
          }
        }
      },
      isOrderSalespersonMarginDisabled(){
        var isOrderSalespersonMarginDisabled = true
        try {
          var o = this.orders[this.selectedOrderId]
          if(o){
            var created_at = null
            if (o.created_at !== undefined && o.created_at.seconds !== undefined){
              created_at = o.created_at
            }
            else if (o.created_at !== undefined && o.created_at.seconds === undefined) {
              var seconds = new Date(o.created_at).getTime()/1000
              created_at = {seconds}
            }
            if(created_at){
              var orderDate = new Date(created_at.seconds * 1000)
              var limitDate = new Date(2024,8,30,23,59,0)
              //console.log({orderDate,limitDate})
              if(orderDate < limitDate) {
                // ALLOW EDITING
                isOrderSalespersonMarginDisabled = false
              }
            }
          }
        }
        catch(e){
          console.log("INVALID DATE FOR ORDER ID " + this.selectedOrderId)
        }
        
        return isOrderSalespersonMarginDisabled
      },
      isOrderDisabled(){
        if(!this.isNormalOrder) {
          console.log("KAIKKI-HERE1")
          return true
        }
        if(this.allAccess) {
          console.log("KAIKKI-HERE2")
          return false
        }
        //console.log(this.selectedOrder.salespersonCanEdit)
        if(this.selectedOrder.salespersonCanEdit !== undefined && this.selectedOrder.salespersonCanEdit == false) {
          console.log("KAIKKI-HERE3")
          return true
        }
        if(this.selectedOrder.salespersonCanEdit == true) {
          console.log("KAIKKI-HERE4")
          return false
        }
        if(!this.isAllNew) {
          console.log("KAIKKI-HERE5")
          return true
        }
        
        return false
      },
      isOrderDisabledForSalesperson(){
        var salesperson = this.selectedOrder.salesperson
        if(!this.isNormalOrder) {
          console.log("MYYJÄ-HERE1")
          return true
        }
        if(this.selectedOrder.salespersonCanEdit !== undefined && this.selectedOrder.salespersonCanEdit == false) {
          console.log("MYYJÄ-HERE3")
          return true
        }
        if(this.selectedOrder.salespersonCanEdit == true) {
          console.log("MYYJÄ-HERE4")
          return false
        }
        if(!this.isAllNew) {
          console.log("MYYJÄ-HERE5")
          return true
        }
        
        return false
      },
      isNormalOrder(){
        if (this.searchOrders[this.selectedOrderId]) return false
        else if(this.offerOrders[this.selectedOrderId]) return true
        else if(this.orders[this.selectedOrderId]) return true
        return false
      },
      selectedOrder(){
        console.log({selectedOrderId:this.selectedOrderId})
        if (this.offerOrders[this.selectedOrderId]) {
          console.log("HERE")
          return this.offerOrders[this.selectedOrderId]
        }
        else if (this.searchOrders[this.selectedOrderId]) return this.searchOrders[this.selectedOrderId]
        else if(this.orders[this.selectedOrderId]) return this.orders[this.selectedOrderId]
        else return null
      },
      getClientPrintDetailsEmail(){
        if(this.companies[this.selectedOrder.companyId] && this.companies[this.selectedOrder.companyId].clientPrintDetailsEmail){
          return this.companies[this.selectedOrder.companyId].clientPrintDetailsEmail
        }
        else if (this.contacts[this.selectedOrder.contactId] && this.contacts[this.selectedOrder.contactId].clientPrintDetailsEmail){
          return this.contacts[this.selectedOrder.contactId].clientPrintDetailsEmail
        }
        else return this.contacts[this.selectedOrder.contactId].email
        
      },
      selectedOrderId:{
        get: function () {
          if(this.location === 'offers') return this.selectedOfferIdInOrders
          else if(this.location === 'orders') return this.selectedOrderIdInOrders
          else if(this.location === 'margins') return this.selectedOrderIdInMargins
          else if(this.location === 'stock') return this.selectedOrderIdInStock
        },
        set: function (newValue) {
          if(this.location === 'offers') this.selectedOfferIdInOrders = newValue
          else if(this.location === 'orders') this.selectedOrderIdInOrders = newValue
          else if(this.location === 'margins') this.selectedOrderIdInMargins = newValue
          else if(this.location === 'stock') this.selectedOrderIdInStock = newValue
        }
      },
      /* ordersAll(){
        return {...this.orders, ...this.searchOrders}
      }, */
      /* orderedProductsAll(){
        return {...this.orderedProducts, ...this.searchOrderedProducts}
      }, */
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      getOrderedProducts(){
        var id = this.selectedOrderId
        
        var productVariations = this.productVariations
        var products = this.products
        var showArchived = this.showArchived
        var missingProductsText = ""
        var firstMissingProduct = true
        var isAllNew = true
        
        var orderedProducts = {}
        if(this.offerOrders[id]) orderedProducts = this.offerOrderedProducts
        else if(this.searchOrders[id]) orderedProducts = this.searchOrderedProducts
        else if(this.orders[id]) orderedProducts = this.orderedProducts
        
        var s = []
        Object.keys(orderedProducts).forEach(function(key) {
          var op = orderedProducts[key]
          if(op.orderId === id) {
            if(op.orderStatus !== 'new') isAllNew = false
            if(productVariations[op.productVariationId] === undefined) {
              //console.log("TUOTEVARIAATIO POISTETTU")
              if(firstMissingProduct){
                missingProductsText += "---- TILAUKSESSA POISTETTUJA TUOTEVARIAATIOTA -----"
                firstMissingProduct = false
              } 
              missingProductsText += "\n\nTUOTETILAUS ID: " + op.id + "\n"
              missingProductsText += "\nTUOTEVARIAATIO POISTETTU: " + op.productVariationId + "\n"
              //console.log("TUOTETILAUKSEN TIEDOT")
              console.log(op)
              if(products[op.productId] !== undefined) {
                console.log("POISTETUN TUOTTEEN TIEDOT")
                console.log(products[op.productId])
                missingProductsText += "TUOTTEESTA: " +products[op.productId].name.fi
                missingProductsText += "   "
              } 
              else {
                //console.log("TUOTE POISTETTU")
              }
              s.push({...op});
            }
            else {
              if(op.archived){
                if(showArchived) s.push({...op});
              }
              else {
                s.push({...op});
              }
            }
          }
        });
        if(missingProductsText !== ''){
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:missingProductsText, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
        this.isAllNew = isAllNew
        console.log("HERHEHRELFLEFLERLSELRSAEL FLDSJFLSADFLKSDFLSDLKFLSDKF")
        console.log({s, length:s.length})
        return s
      },
      getOrderedProductsWithRefOps(){
        var id = this.selectedOrderId
        
        var productVariations = this.productVariations
        var products = this.products
        var showArchived = this.showArchived
        var missingProductsText = ""
        var firstMissingProduct = true
        var isAllNew = true
        
        var orderedProducts = {}
        if(this.offerOrders[id]) orderedProducts = this.offerOrderedProducts
        else if(this.searchOrders[id]) orderedProducts = this.searchOrderedProducts
        else if(this.orders[id]) orderedProducts = this.orderedProducts
        
        var refOpIds = []

        var s = []
        //return s
        Object.keys(orderedProducts).forEach(function(key) {
          var op = orderedProducts[key]
          //if(op.refOpId) refOpIds.push(op.refOpId)
          if(op.orderId === id) {
            if(op.orderStatus !== 'new') isAllNew = false
            if(productVariations[op.productVariationId] === undefined) {
              //console.log("TUOTEVARIAATIO POISTETTU")
              if(firstMissingProduct){
                missingProductsText += "---- TILAUKSESSA POISTETTUJA TUOTEVARIAATIOTA -----"
                firstMissingProduct = false
              } 
              missingProductsText += "\n\nTUOTETILAUS ID: " + op.id + "\n"
              missingProductsText += "\nTUOTEVARIAATIO POISTETTU: " + op.productVariationId + "\n"
              //console.log("TUOTETILAUKSEN TIEDOT")
              console.log(op)
              if(products[op.productId] !== undefined) {
                console.log("POISTETUN TUOTTEEN TIEDOT")
                console.log(products[op.productId])
                missingProductsText += "TUOTTEESTA: " +products[op.productId].name.fi
                missingProductsText += "   "
              } 
              else {
                //console.log("TUOTE POISTETTU")
              }
              s.push({...op});
            }
            else {
              if(op.archived){
                if(showArchived) s.push({...op});
              }
              else {
                s.push({...op});
              }
            }
          }
        });
        s = [...s, ...this.refOrderedProducts]
        
        if(missingProductsText !== ''){
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:missingProductsText, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
        this.isAllNew = isAllNew
        //console.log({s, length:s.length})
        return s
      },
      
      isSampleOrder(){
        return this.selectedOrder.sample === undefined || !this.selectedOrder.sample ? false : true
      },
      getMobileHeaders(){
        return this.mobileHeaders
      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        Object.keys(this.staff).forEach(key => {
          var s = staff[key]
          if(s.role === 'sales' || s.role === 'ceo' || s.id ==='RqjgIwdXWzXqCR2MOVr1etp2iY22'/*TIMO*/ || s.id === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'/*MIKO*/) salespersons.push({text:s.firstName, id:s.id})
          if(this.user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' && key === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1') salespersons.push({text:s.firstName, id:s.id})
        })
        return salespersons
      },
      getOfficeStaff(){
        var staff = this.staff
        var officeStaff = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if (s.role.includes('office') && !s.isExit) officeStaff.push({text:s.firstName, id:s.id})
          
          return s
        })
        return officeStaff
      },
      getCompanies(){
        var companies = this.companies
        return Object.keys(this.companies).map(function(key, index) {
          var c = companies[key]
          return {text: c.companyName, value: c.id}
        })
      },
      getContacts(){
        var contacts = this.contacts
        var arr = []
        Object.keys(this.contacts).forEach(key => {
          var c = contacts[key]
          if(c.companyId === this.selectedOrder.companyId) arr.push({text: c.firstName + ' ' + c.lastName, value: c.id})
        })
        return arr
      },
      getBillingFormats(){
        var billingFormats = this.settings.billingFormats
        return Object.keys(this.settings.billingFormats).reduce(function(result, key) {
          result.push({...billingFormats[key]});
          return result;
        }, []);
      },
      getBillingDetails(){
        var company = this.companies[this.selectedOrder.companyId]
        var details = ""
        if (company.billingFormat === "eInvoice"){
          details += "E-laskutus. Osoite: " + company.eBillingAddress +" Operaattori: "+company.eBillingOperator
        }
        else if (company.billingFormat === "email"){
          details += "Lasktus sähköpostitse. Osoite: " + company.billingEmail 
        }
        else if (company.billingFormat === "paper"){
          details += "Paperilasku. Osoite: " + company.billingAddress + " " + company.billingPostalCode + " " + company.billingCity + "," + company.billingCountry
        }
        return details
      },
      getProducts(){
        var products = this.products
        return Object.keys(this.products).map(function(key, index) {
          var p = products[key]
          return {text: p.name.fi, value: p.id} 
        })
      },
      
      getCatalogProductsAndVariations(){
        var products = this.products
        var productVariations = this.productVariations
        var orderedProducts = this.orderedProducts
        var oId = this.selectedOrderId
        var opIdsForOrder = []
        var s = Object.keys(orderedProducts).forEach(opId => {
          var op = orderedProducts[opId]
          if(op.orderId === oId) opIdsForOrder.push(op.productVariationId)
        })
        
        //console.log("------------------")
        //console.log(opIdsForOrder)
        var catalogProducts = []
        Object.keys(productVariations).forEach(key => {
          var pv = productVariations[key]
          var include = true
          if(pv.archived) include = false
          if(products[pv.productId] && products[pv.productId].archived) include = false
          if(opIdsForOrder.includes(pv.id)) include = true
          if(include){
            products[pv.productId] ? catalogProducts.push({
              text: products[pv.productId].name.fi + " - " + this.createVariationName(pv), 
              value: pv.id
            }) : ''//console.log(key)
          }
        })
        return catalogProducts
      },
      orderType(){
        if (this.searchOrders[this.selectedOrderId]) return 'searchOrder'
        else if(this.offerOrders[this.selectedOrderId]) return 'offer'
        else if(this.orders[this.selectedOrderId]) return 'order'
        return ''
      },
      ...mapFields({
        reserved:"reserved",
        pricingVariables:"pricingVariables.pricingVariables",
        isSyncOrderToNetvisorActive:"isSyncOrderToNetvisorActive",
        device:"device",
        settings:"settings",
        ordersSearch:"settings.ordersSearch",
        orderProductsSearch:"settings.orderProductsSearch",
        samplesArray:"newOrderDetails.samplesArray",
        orderedProducts:"orderedProduct.orderedProducts",
        wholesaleCompanies:'wholesaleCompany.wholesaleCompanies',
        printShops:"printShop.printShops",
        products:"product.products",
        companies:"company.companies",
        contacts:"contact.contacts",
        orders:"order.orders",
        staff:"staff.staff",
        user:"user",
        productVariations:"productVariation.productVariations",
        //selectedOrderCompanyId:"views.orders.selectedOrder.companyId",
        pinnedOrdersInOrders:"views.orders.pinnedOrders",
        selectedOrderIdInOrders:"views.orders.selectedOrder.orderId",
        selectedOfferIdInOrders:"views.orders.selectedOffer.offerId",
        selectedOrderIdInMargins:"views.margins.selectedOrder.orderId",
        selectedOrderedProductIdInMargins:"views.margins.selectedOrder.orderedProductId",
        selectedOrderIdInStock:"views.stock.selectedOrder.orderId",
        
        orderInvoicingModalVisible:"modals.orders.invoicing.visible",
        orderInvoicingModalOrderId:"modals.orders.invoicing.orderId",
        orderInvoicingModalEnv:"modals.orders.invoicing.env",
        
        newOrderedProductModalVisible:"modals.orderedProduct.new.visible",
        newOrderedProductModalOrderId:"modals.orderedProduct.new.orderId",
        editOrderedProductModalVisible:"modals.orderedProduct.edit.visible",
        editOrderedProductModalOrderedProductId:"modals.orderedProduct.edit.orderedProductId",
        searchOrders:'searchOrders',
        searchOrderedProducts:'searchOrderedProducts',
        offerOrders:'offerOrders',
        offerOrderedProducts:'offerOrderedProducts',
      }),
    },

    watch: {
      selectedOrderId:{
        handler(newId, oldId) {
          if(newId !== oldId) this.settings.snackSettings.snack = false
          this.batchOrderStatus = ""
          this.batchOrderInvoiceStatus = ''
          this.batchStatusUpdateItems = {}
          this.batchStatusAllItems = false
        }
      },
      batchStatusUpdateItems:{
        handler(newId, oldId) {
          this.formBatchStatuses()
        },
        deep: true
      }
    },
    methods: {
      timer(ms) { return new Promise(res => setTimeout(res, ms)); },

      
      async saveToOrder(order){
        if(this.orderType === 'order'){
          console.log("NORMAL OP STORE")
          console.log({order})
          this.$store.dispatch('order/set', {
            ...order
          })
        }
        else if(this.orderType ==='offer'){
          console.log("OFFER STORE")
          var { id:oId, ...y } = order
          if(!oId) return
          await db.collection('orders').doc(oId).set({
            ...y
          }, { merge: true })
          console.log('%c ORDER UPDATED:', 'background: #222; color: #bada55', order)
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
      },
      async saveToOp(op){
        if(this.orderType === 'order'){
          console.log("NORMAL OP STORE")
          console.log({op})
          this.$store.dispatch('orderedProduct/set', {
            ...op
          })
        }
        else if(this.orderType ==='offer'){
          console.log("OFFER OP STORE")
          var { id:opId, ...y } = op
          if(!opId) return
          await db.collection('orderedProducts').doc(opId).set({
            ...y
          }, { merge: true })
          console.log('%c OP UPDATED:', 'background: #222; color: #bada55', op)
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
      },
      getContainerStyle(){
        if(this.displayType === 'inline') return ''
        if (this.pinnedOrdersInOrders.length > 0 && this.location === 'orders') return 'position:fixed; bottom:20px; z-index:100; background:#eee; border:1px solid #ccc;width:100%;' 
        else return 'position:fixed; bottom:0px; z-index:100; background:#eee; border:1px solid #ccc;width:100%;'
      },
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      async changeProduct(op, refetchPrices){
        if (confirm('Haluatko varmasti vaihtaa tuotteen?')) {
          var pvId = this.newProductVariationId
          var pv = this.productVariations[pvId]
          var productId = pv.productId

          if(!pvId || !pv || !productId){
            alert("Tuotetta ei määritelty")
            return
          }

          var newPrintOptionsInUse = false
          if(this.products[productId] && this.products[productId].prices) newPrintOptionsInUse = true
          
          console.log({pvId, productId, pv,op})

          if(this.orderType === 'order'){
            this.$store.dispatch('orderedProduct/delete', `${op.id}.printOptionsSettings`)
            this.$store.dispatch('orderedProduct/delete', `${op.id}.printOptionsSettings2`)
            this.$store.dispatch('orderedProduct/delete', `${op.id}.printOptions`)
            this.$store.dispatch('orderedProduct/delete', `${op.id}.printOptions2`)
          }
          
          else if(this.orderType === 'offer'){
            var cityRef = db.collection('orderedProducts').doc(op.id);
            // Remove the 'capital' field from the document
            cityRef.update({
              printOptionsSettings: firebase.firestore.FieldValue.delete(),
              printOptionsSettings2: firebase.firestore.FieldValue.delete(),
              printOptions: firebase.firestore.FieldValue.delete(),
              printOptions2: firebase.firestore.FieldValue.delete()
            });
          }

          await this.timer(1500);

          this.saveToOp({
            id:op.id,
            productVariationId:pvId,
            productId,
            printOptions:this.newPrintOptions,
            printOptionsSettings:this.newPrintOptionsSettings,
            printOptions2:this.newPrintOptions2,
            printOptionsSettings2:this.newPrintOptionsSettings2,
            printFormats:this.newPrintFormats,
            printFormatsText:this.newPrintFormatsText,
            numberOfPrintColors:this.newNumberOfPrintColors,
            printFormats2:this.newPrintFormats2,
            printFormatsText2:this.newPrintFormatsText2,
            numberOfPrintColors2:this.newNumberOfPrintColors2,
            newPrintOptionsInUse
          })

          /* this.$store.dispatch('orderedProduct/set', {
            id:op.id,
            productVariationId:pvId,
            productId,
            printOptions:this.newPrintOptions,
            printOptionsSettings:this.newPrintOptionsSettings,
            printOptions2:this.newPrintOptions2,
            printOptionsSettings2:this.newPrintOptionsSettings2,
            printFormats:this.newPrintFormats,
            printFormatsText:this.newPrintFormatsText,
            numberOfPrintColors:this.newNumberOfPrintColors,
            printFormats2:this.newPrintFormats2,
            printFormatsText2:this.newPrintFormatsText2,
            numberOfPrintColors2:this.newNumberOfPrintColors2,
            newPrintOptionsInUse
      
          }) */

          this.newPrintOptions = []
          this.newPrintOptions2 = []
          this.newPrintOptionsSettings = {}
          this.newPrintOptionsSettings2 = {}
          this.newPrintFormats = []
          this.newPrintFormats2 = []
          this.newPrintFormatsText = ''
          this.newPrintFormatsText2 = ''
          this.newNumberOfPrintColors = null
          this.newNumberOfPrintColors2 = null
          this.newProductVariationId = ''          
          

          if(refetchPrices){
            await this.timer(1500);
            this.refetchOrderedProductPrices(op.id)
          }
        }

      },
      getProductName(pvId){
        try{
          var pv = this.productVariations[pvId]
          var pvName = this.createVariationName(pv,true)
          var pName = this.products[pv.productId] ? this.products[pv.productId].name.fi : ''
          return pName + ' - ' + pvName
        }
        catch(e){
          console.log(e)
          return "Tuotenimeä ei voitu muodostaa"
        }
      },
      getClassesForOpRow(item){
        //avecor-selected-op-row-office-margin-added
        //avecor-selected-op-row-office-margin-not-added
        var classes = 'hide-field-details'
        if(this.location === 'margins' && item.id === this.selectedOrderedProductIdInMargins){
          item.confirmedMargin ? classes += ' avecor-selected-op-row-office-margin-added' : ''
          !item.confirmedMargin ? classes += ' avecor-selected-op-row-office-margin-not-added' : ''
        }
        if(item.isRefOp){
          classes += ' avecor-selected-op-row-office-margin-not-added'
        }
        return classes
      },
      getDeliveryMargin(){
        var deliveryMargin = this.getDeliveryMarginForOrder(this.selectedOrder,this.settings.defaultDeliveryCharge)
        console.log(deliveryMargin)
        return deliveryMargin
      },
      async refetchOrderedProductPrices(opId){
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Päivitetään hintoja...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
        try{
          var url = this.settings.dev ? 'http://0.0.0.0:5000/logogear-erp/us-central1/setOrderedProductPricesFunction': 'https://us-central1-logogear-erp.cloudfunctions.net/setOrderedProductPricesFunction'
          let res = await axios.post(url,
            { opId },
          );
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
        catch(e){
          var msg = e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:msg, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
      },
      deselectAllProducts(){
        this.batchStatusUpdateItems = {}
        this.allProductsSelected = false
      },
      selectAllProducts(){
        var batchStatusUpdateItems = {}
        this.getOrderedProducts.forEach(op => batchStatusUpdateItems[op.id] = true)
        this.batchStatusUpdateItems = batchStatusUpdateItems
        this.allProductsSelected = true
      },
      inlineSavePrintInfo(id,field,e){
        //console.log(id,field,e)
        console.log(e.target.innerText)
        var value = e.target.innerText
        console.log({value})
        if(value === '\n') value = ''
        
        if(this.searchOrderedProducts[id]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        this.saveToOp({
          id,
          [field]:value
        })
        /* this.$store.dispatch('orderedProduct/set', {
          id,
          [field]:value
        })
        .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))         */
        //e.target.innerText = ''
        this.print_info_key = this.print_info_key + 1
      },
      inlineSaveLatestToCustomer(id, v){
        if(this.searchOrderedProducts[id]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        if(v){
          var oId = this.selectedOrderId
          this.saveToOrder({
            id:oId,
            deadline:true
          })
          /* this.$store.dispatch('order/set', {
            id:oId,
            deadline:true
          }) */
        }
        console.log(id, v)
        this.saveToOp({
          id,
          latestToCustomer:v
        })
        /* this.$store.dispatch('orderedProduct/set', {
          id,
          latestToCustomer:v
        }) */
      },
      async addOrRemovePrintOptionFromNewProduct(printNumber,op,action,poId){
        console.log({op,action,poId})
        var printOptionsSettings,printOptions = null
        if(printNumber === 1) {
          printOptions = JSON.parse(JSON.stringify(this.newPrintOptions))
          printOptionsSettings = JSON.parse(JSON.stringify(this.newPrintOptionsSettings))
        }
        else if(printNumber === 2) {
          printOptions = JSON.parse(JSON.stringify(this.newPrintOptions2))
          printOptionsSettings = JSON.parse(JSON.stringify(this.newPrintOptionsSettings2))
        }
          
        if(action === 'add'){
          if(!printOptionsSettings[poId]){
            printOptionsSettings[poId] = {}
          }
          if(!printOptions.includes(poId)){
            printOptions.push(poId)
          }
          if(printNumber === 1){
            this.newPrintOptions = printOptions
            this.newPrintOptionsSettings = printOptionsSettings
          }
          else if(printNumber === 2) {
            this.newPrintOptions2 = printOptions
            this.newPrintOptionsSettings2 = printOptionsSettings
          }
          console.log({printOptions,printOptionsSettings})
        }
        else if(action === 'remove'){
          if(printOptionsSettings[poId]){
            delete printOptionsSettings[poId]
            
          }
          if(printOptions.includes(poId)){
            printOptions = printOptions.filter(id => id !== poId )
          }
          console.log({printOptions,printOptionsSettings})
          if(printNumber === 1){
            this.newPrintOptions = printOptions
            this.newPrintOptionsSettings = printOptionsSettings
          }
          else if(printNumber === 2) {
            this.newPrintOptions2 = printOptions
            this.newPrintOptionsSettings2 = printOptionsSettings
          }
        }
      },
      async addOrRemovePrintOption(printNumber,op,action,poId){
        console.log({op,action,poId})
        var printOptionsSettings,printOptions = null
        if(printNumber === 1) {
          printOptions = JSON.parse(JSON.stringify(op.printOptions))
          printOptionsSettings = JSON.parse(JSON.stringify(op.printOptionsSettings))
        }
        else if(printNumber === 2) {
          printOptions = JSON.parse(JSON.stringify(op.printOptions2))
          printOptionsSettings = JSON.parse(JSON.stringify(op.printOptionsSettings2))
        }
          
        if(action === 'add'){
          if(!printOptionsSettings[poId]){
            printOptionsSettings[poId] = {}
          }
          if(!printOptions.includes(poId)){
            printOptions.push(poId)
          }
          if(printNumber === 1){
            this.saveToOp({
              id:op.id,
              printOptions,
              printOptionsSettings
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id:op.id,
              printOptions,
              printOptionsSettings
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
          }
          else if(printNumber === 2) {
            this.saveToOp({
              id:op.id,
              printOptions2:printOptions,
              printOptionsSettings2:printOptionsSettings
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id:op.id,
              printOptions2:printOptions,
              printOptionsSettings2:printOptionsSettings
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            */
          }
          console.log({printOptions,printOptionsSettings})
        }
        else if(action === 'remove'){
          if(printOptionsSettings[poId]){
            if(printNumber === 1) this.$store.dispatch('orderedProduct/delete', `${op.id}.printOptionsSettings.${poId}`)
            else if(printNumber === 2) this.$store.dispatch('orderedProduct/delete', `${op.id}.printOptionsSettings2.${poId}`)
          }
          if(printOptions.includes(poId)){
            printOptions = printOptions.filter(id => id !== poId )
          }
          console.log({printOptions,printOptionsSettings})
          if(printNumber === 1){
            this.saveToOp({
              id:op.id,
              printOptions,
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id:op.id,
              printOptions,
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) 
            */
            
          }
          else if(printNumber === 2) {
            this.saveToOp({
              id:op.id,
              printOptions2:printOptions,
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id:op.id,
              printOptions2:printOptions,
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            */
          }
        }
        await this.timer(3000);
        this.refetchOrderedProductPrices(op.id)
      },
      
      async printOptionSettingUpdate(printNumber,setting, op, poId, value){
        var product = op
        console.log(op)
        var printOptionsSettings = null
        if(printNumber === 1) printOptionsSettings = JSON.parse(JSON.stringify(product.printOptionsSettings))
        else if(printNumber === 2) printOptionsSettings = JSON.parse(JSON.stringify(product.printOptionsSettings2))

        var pricing = null
        if(product.pricing) pricing = JSON.parse(JSON.stringify(product.pricing))
        if(setting === 'renewal'){
          console.log(poId)
          if(value === false) {
            if(printOptionsSettings[poId] && printOptionsSettings[poId].renewal) {
              console.log("IN RENEWAL")
              printOptionsSettings[poId].renewal = false
              //pricing && pricing.print && pricing.print[poId] ? pricing.print[poId].renewal = false : ''
            }
          }
          else {
            if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
            printOptionsSettings[poId].renewal = true
            //pricing && pricing.print && pricing.print[poId] ? pricing.print[poId].renewal = true : ''
          }
        }
        else if(setting === 'colors'){
          
          if(value === 'add'){
            console.log("IN COLOR")
            console.log(printOptionsSettings)
            console.log(poId)
            console.log(printOptionsSettings[poId])
            if(printOptionsSettings[poId] !== undefined && printOptionsSettings[poId].colors !== undefined) {
              
              printOptionsSettings[poId].colors += 1
              //pricing && pricing.print && pricing.print[poId] ? pricing.print[poId].colors += 1 : ''
            }
            else {
              if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
              printOptionsSettings[poId].colors = 1
              //pricing && pricing.print && pricing.print[poId] ? pricing.print[poId].colors = 1 : ''
            }
          }
          else if (value === 'subtract'){
            if(printOptionsSettings[poId] !== undefined && printOptionsSettings[poId].colors !== undefined) {
              printOptionsSettings[poId].colors -= 1
              //pricing && pricing.print && pricing.print[poId] ? pricing.print[poId].colors -= 1 : ''
            }
            else {
              if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
              printOptionsSettings[poId].colors = 1
              //pricing && pricing.print && pricing.print[poId] ? pricing.print[poId].colors = 1 : ''
            }
          }
          else if (value === 'remove'){
            if(printOptionsSettings[poId] !== undefined && printOptionsSettings[poId].colors !== undefined) delete printOptionsSettings[poId].colors
          }
        }
        else if(setting.includes('ec_')){
          if(value === false) {
            if(printOptionsSettings[poId] && printOptionsSettings[poId][setting]) printOptionsSettings[poId][setting] = 0
          }
          else {
            if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
            printOptionsSettings[poId][setting] = 1
          }
        }

        if(printOptionsSettings !== null){
          /* if(pricing && pricing.print && pricing.print[poId]){
            this.$store.dispatch('orderedProduct/set', {
              id:op.id,
              printOptionsSettings,
              pricing
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))        
          }
          else {
            this.$store.dispatch('orderedProduct/set', {
              id:op.id,
              printOptionsSettings
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))        
          } */
          if(printNumber === 1){
            this.saveToOp({
              id:op.id,
              printOptionsSettings
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id:op.id,
              printOptionsSettings
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))         */
          }
          else if (printNumber === 2){
            console.log("PRINT NUMBER 2")
            this.saveToOp({
              id:op.id,
              printOptionsSettings2:printOptionsSettings
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id:op.id,
              printOptionsSettings2:printOptionsSettings
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))        */
          }
          if(setting === 'renewal' || setting === 'colors' || setting.includes('ec_')){
            await this.timer(3000);
            this.refetchOrderedProductPrices(op.id)
          }

        }
      },
      async printOptionSettingUpdateNewProduct(printNumber,setting, op, poId, value){
        var printOptionsSettings = null
        if(printNumber === 1) printOptionsSettings = JSON.parse(JSON.stringify(this.newPrintOptionsSettings))
        else if(printNumber === 2) printOptionsSettings = JSON.parse(JSON.stringify(this.newPrintOptionsSettings2))

        if(setting === 'renewal'){
          if(value === false) {
            if(printOptionsSettings[poId] && printOptionsSettings[poId].renewal) {
              console.log("IN RENEWAL")
              printOptionsSettings[poId].renewal = false
            }
          }
          else {
            if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
            printOptionsSettings[poId].renewal = true
          }
        }
        else if(setting === 'colors'){
          if(value === 'add'){
            console.log("IN COLOR")
            if(printOptionsSettings[poId] !== undefined && printOptionsSettings[poId].colors !== undefined) {
              printOptionsSettings[poId].colors += 1
            }
            else {
              if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
              printOptionsSettings[poId].colors = 1
            }
          }
          else if (value === 'subtract'){
            if(printOptionsSettings[poId] !== undefined && printOptionsSettings[poId].colors !== undefined) {
              printOptionsSettings[poId].colors -= 1
            }
            else {
              if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
              printOptionsSettings[poId].colors = 1
            }
          }
          else if (value === 'remove'){
            if(printOptionsSettings[poId] !== undefined && printOptionsSettings[poId].colors !== undefined) delete printOptionsSettings[poId].colors
          }
        }
        else if(setting.includes('ec_')){
          if(value === false) {
            if(printOptionsSettings[poId] && printOptionsSettings[poId][setting]) printOptionsSettings[poId][setting] = 0
          }
          else {
            if(!printOptionsSettings[poId]) printOptionsSettings[poId] = {}
            printOptionsSettings[poId][setting] = 1
          }
        }

        if(printOptionsSettings !== null){
          if(printNumber === 1){
            this.newPrintOptionsSettings = printOptionsSettings
          }
          else if (printNumber === 2){
            this.newPrintOptionsSettings2 = printOptionsSettings
          }
        }
      },
      fetchPricingData(oId){
        try{
          var ops = []
          Object.keys(this.orderedProducts).forEach(opId => {
            var op = this.orderedProducts[opId]
            if(op.orderId === oId) ops.push(op)
          })
          
          ops.forEach(op => {
            this.refetchOrderedProductPrices(op.id)
          })
        }
        catch(e){
          console.log(e)
          return {}
        }
      },
      inlineSaveOrderedProduct(opId,field,v){
        if(this.searchOrderedProducts[opId]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        if(field === 'secondPrint'){
          var op = this.orderedProducts[opId]
          if(v === true && !op.printOptions2){
            this.saveToOp({
              id:opId,
              printOptions2:[],
              printOptionsSettings2:{},
              [field]:v
            })
           /*this.$store.dispatch('orderedProduct/set', {
              id:opId,
              printOptions2:[],
              printOptionsSettings2:{},
              [field]:v
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
          }
          else {
            this.saveToOp({
              id:opId,
              [field]:v
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id:opId,
              [field]:v
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
          }
        }
        else {
          this.saveToOp({
            id:opId,
            [field]:v
          })
          /* this.$store.dispatch('orderedProduct/set', {
            id:opId, 
            [field]:v
          })
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }
      },
      getRemainingDelivery(op){
        var pds = op.partialDeliveries
        if(!pds || Object.keys(pds).length === 0) return ''
        var total = 0
        Object.keys(pds).forEach(pdId => {
          var pd = pds[pdId]
          if(!isNaN(Number(pd.deliveredAmount))) total += Number(pd.deliveredAmount)
        })
        return op.quantity - total
      },
      getPartialDeliveriesColor(op){
        var pds = op.partialDeliveries
        if(!pds || Object.keys(pds).length === 0) return '#777'
        var total = 0
        Object.keys(pds).forEach(pdId => {
          var pd = pds[pdId]
          if(!isNaN(Number(pd.deliveredAmount))) total += Number(pd.deliveredAmount)
        })
        if(total >= op.quantity){
          return "green"  
        }
        else {
          return 'orange'
        }
        
      },
      
      printFormatsForProduct(product){
        var formats = []
        if(this.products[product.productId] && this.products[product.productId].printFormats && Array.isArray(this.products[product.productId].printFormats)){
          this.products[product.productId].printFormats.forEach(format => {
            if(this.settings.printFormatsObject[format]) formats.push(this.settings.printFormatsObject[format])
          })
        }
        return formats
      },
      updateBatchStatusForAllItems(value){
        var batchStatusUpdateItems = JSON.parse(JSON.stringify(this.batchStatusUpdateItems))
        this.getOrderedProducts.forEach(pv =>{
          var id = pv.id
          if(value) batchStatusUpdateItems[id] = true
          else if (batchStatusUpdateItems[id])delete batchStatusUpdateItems[id]
        })
        this.batchStatusAllItems = value
        this.batchStatusUpdateItems = batchStatusUpdateItems
      },
      resetDate(item,field){
        if(field === 'whenToInvoice'){
          this.saveToOp({
            id:item.id,
            whenToInvoiceSetManually:false,
            [field]:''
          })
          /* this.$store.dispatch('orderedProduct/set', {id:item.id, whenToInvoiceSetManually:false, [field]:''})
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }
        else {
          this.saveToOp({
            id:item.id,
            [field]:''
          })
          /* this.$store.dispatch('orderedProduct/set', {id:item.id, [field]:''})
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }
      },
      toggleArchive(item) {
        var m = ''
        var archived = item.archived ? true : false
        
        if(archived) {m = 'Haluatko varmasti poistaa tuotetilauksen arkistointi tilan?'}
        else {m = 'Haluatko varmasti arkistoida tämän tuotetilauksen?'}
        if (confirm(m)) {
          archived = !archived
          this.saveToOp({
            id:item.id,
            archived
          })
          /* this.$store.dispatch('orderedProduct/set', {id:item.id, archived})
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }
      },
      expandOption(isExpanded,expand,option){
        if(isExpanded && this.selectedExpandOption !== option) this.selectedExpandOption = option
        else if(isExpanded && this.selectedExpandOption === option) expand(false)
        else if (!isExpanded) {
          this.selectedExpandOption = option
          expand(true)
        }
        this.newProductVariationId = ''
        this.newPrintOptions = []
        this.newPrintOptions2 = []
        this.newPrintOptionsSettings = {}
        this.newPrintOptionsSettings2 = {}
      },
      formBatchStatuses(){
        var isThereAnonPrintProduct = null
        Object.keys(this.batchStatusUpdateItems).forEach(opId => {
          if(this.batchStatusUpdateItems[opId]){
            !this.orderedProducts[opId].print ? isThereAnonPrintProduct = true : ''
          }
        })
        var statuses = []
        //console.log({isTopFilterAnonPrintProduct})
        if(Object.keys(this.batchStatusUpdateItems).length > 0) {
          this.settings.orderedProductStatusArray.map(status => {
            if(isThereAnonPrintProduct){
              status.step === "all" ? statuses.push(status) : ''
            }
            else{
              statuses.push(status)
            }
            return status
          })
        }
        
        this.batchStatuses = statuses
      },
      updateBatchStatusForItem(id){
        var batchStatusUpdateItems = JSON.parse(JSON.stringify(this.batchStatusUpdateItems))
        if(batchStatusUpdateItems[id]) delete batchStatusUpdateItems[id]
        else batchStatusUpdateItems[id] = true
        this.batchStatusUpdateItems = batchStatusUpdateItems
      },
      async batchOrderUpdate(field){//
        var keys = Object.keys(this.batchStatusUpdateItems)
        /* keys.forEach(id=>{
          console.log(id)
        }) */
        if(field == 'orderInvoiceStatus'){
          for (let i = 0; i < keys.length; i++){
            var id = keys[i]
            if(this.batchStatusUpdateItems[id]){
              var op = this.orderedProducts[id]
              this.inlineSaveStatus(op, field, this.batchOrderInvoiceStatus)
              await this.timer(2000);
            }
          }
        }
        else if (field === 'orderStatus'){
          for (let i = 0; i < keys.length; i++){
            var id = keys[i]
            if(this.batchStatusUpdateItems[id]){
              var op = this.orderedProducts[id]
              this.inlineSaveStatus(op, 'orderStatus', this.batchOrderStatus)
              await this.timer(2000);
            }
          }
        }
        else if (field === 'shippedDate'){
          keys.forEach(id=>{
            var op = this.orderedProducts[id]
            this.inlineSaveDate(id, 'shippedDate', this.batchShippedDate)
          })
        }
        else if (field === 'whenToInvoice'){
          keys.forEach(id=>{
            if(this.batchStatusUpdateItems[id]){
              var op = this.orderedProducts[id]
              this.inlineSaveDate(id, 'whenToInvoice', this.batchInvoiceDate)
            }
          })
        }
      },

      // v-input avecor-select v-input--hide-details v-input--dense theme--light v-text-field v-text-field--is-booted v-select v-autocomplete
      // v-input avecor-select v-input--hide-details v-input--dense theme--light v-text-field v-text-field--is-booted v-select v-select--is-menu-active v-autocomplete primary--text
      async copyEmailText(lang, delivery, item,psId){
        try{
          var items = []
          if(Object.keys(this.batchStatusUpdateItems).length > 0){
            items = Object.keys(this.batchStatusUpdateItems)
          }
          else items = [item.id]

          var company = this.companies[this.selectedOrder.companyId]
          var contact = this.contacts[this.selectedOrder.contactId]
          //var p = this.products[item.productId]
          var ps = this.printShops[psId] ? this.printShops[psId] : null
          if(delivery === 'printShop' && !ps) {
            alert("Valitulle tuotteelle ei ole määritelty merkkaamoa.")
            return
          }

          var addressText = ''
          if(delivery === 'customer') addressText = company.companyName +'\n'+company.deliveryAddress + '\n' + company.deliveryPostalCode + ' ' + company.deliveryCity + '\n' + contact.firstName + ' ' + contact.lastName +'\n' + contact.phone
          else if(delivery === 'printShop') addressText = ps.name +'\n'+ps.address + '\n\n' + ps.contacts
          else addressText = "Avecor Oy\nTeerisuonkuja 4\n00700 Helsinki" //+"\nMoona Sinisilta\np. 010 419 0160"

          var netvisorId = this.selectedOrder.netvisorId

          var latestToCustomer = null
          items.forEach(opId =>{
            var op = this.orderedProducts[opId]
            if(op.latestToCustomer) latestToCustomer = op.latestToCustomer
          })

          var isDeliveryWeekWithin2Weeks = false
          var deliveryWeek = this.selectedOrder.deliveryWeek
          if(deliveryWeek){
            var s = deliveryWeek.split('/')
            var dWeek = Number(s[0])
            var dYear = Number(s[1].substring(0,4))
            var cWeek = this.getWeek(new Date())
            var cYear = new Date().getFullYear()
            
            //console.log({dWeek,dYear,cWeek,cYear})
            if(dYear === cYear && (dWeek - cWeek < 2)){
              isDeliveryWeekWithin2Weeks = true
            }
          }


          if(lang === 'fi'){
            
            //var productVariationId = item.productVariationId
            var message = "Heips,\n\n"
            console.log(latestToCustomer)
            if(!latestToCustomer && !isDeliveryWeekWithin2Weeks) {
              if(delivery === 'printShop') message += `Uusi tilaus ${netvisorId}, suoraan merkkaamoon.\n\n`
              else message += `Uusi tilaus ${netvisorId}.\n\n`
            }
            else if(latestToCustomer) {
              var s = latestToCustomer.split('-')
              if(s.length == 3){
                var date = this.dateFormatForEmailText(latestToCustomer)//s[2]+'.'+
                if(delivery === 'printShop') message += `Uusi tilaus ${netvisorId}, suoraan merkkaamoon. Tilauksella deadline ${date}, ehtiihän deadlineen?\n\n`
                else message += `Uusi tilaus ${netvisorId}. Tilauksella deadline ${date}, ehtiihän deadlineen?\n\n`
              }
              else {
                message += `Uusi tilaus ${netvisorId}`
                if(delivery === 'printShop') message += `Uusi tilaus ${netvisorId}, suoraan merkkaamoon.\n\n`
                else message += `Uusi tilaus ${netvisorId}.\n\n`
              }
            }
            else if(isDeliveryWeekWithin2Weeks) {
              if(delivery === 'printShop') message += `Uusi tilaus ${netvisorId}, suoraan merkkaamoon. Tilauksella deadline viikolle ${deliveryWeek}, ehtiihän deadlineen?\n\n`
              else message += `Uusi tilaus ${netvisorId}. Tilauksella deadline viikolle ${deliveryWeek}, ehtiihän deadlineen?\n\n`
            }
            for(var i = 0; i < items.length; i++){
              var opId = items[i]
              console.log({opId})
              var op = this.orderedProducts[opId]
              var p = this.products[op.productId]
              message += "Tuote\n"
              var productVariationId = op.productVariationId
              var avecorSku = this.products[this.productVariations[productVariationId].productId].avecorSku
              var wholesaleSku = this.productVariations[productVariationId].wholesaleSku
              if(wholesaleSku) message += wholesaleSku
              else message += avecorSku
              var name = this.products[this.productVariations[productVariationId].productId].name.wholesale ? this.products[this.productVariations[productVariationId].productId].name.wholesale : ''
              if(!name) name = this.products[this.productVariations[productVariationId].productId].name.fi
              message += " - " + name

              var colorCode = this.productVariations[productVariationId].colorCode
              var color = ""
              if(this.settings.colors[colorCode]) color = this.settings.colors[colorCode].fi
              
              if(this.productVariations[productVariationId].size) message += " - " + this.productVariations[productVariationId].size
              
              var wholesaleColor = this.productVariations[productVariationId].color
              if (wholesaleColor) message += " - " + wholesaleColor
              else if(color) message += " - " + color
              if(this.productVariations[productVariationId].other) message += " - " + this.productVariations[productVariationId].other

              message += "\nMäärä\n"
              message += op.quantity + ' kpl'
              if(op.numberOfSamples) message += ' + ' + op.numberOfSamples + ' mallien toimitus meille?'
              message += '\n\n'  
              //message += op.quantity + ' kpl\n\n'  
              var printFormatVersion = "old"
              var printFormatVersion2 = "old"
              var pfText = ""
              if(op.printFormats){
                op.printFormats.forEach(pfId => {
                  if(this.settings.printFormatsObject[pfId]) {
                      var pf = this.settings.printFormatsObject[pfId]
                      if(pfText) pfText += ', ' + pf.fi
                      else pfText += pf.fi
                  }
                })
              }
              var pfText2 = ""
              if(op.printFormats2){
                op.printFormats2.forEach(pfId => {
                  if(this.settings.printFormatsObject[pfId]) {
                      var pf = this.settings.printFormatsObject[pfId]
                      if(pfText2) pfText2 += ', ' + pf.fi
                      else pfText2 += pf.fi
                  }
                })
              }

              var pos = []
              if(op.printOptions && op.printOptions.length > 0){
                printFormatVersion = "new"
                for (let poId of op.printOptions) {
                  var poTexts = this.getOptionDetailsById(p,poId,'fi')
                  if(op.printOptionsSettings[poId] && op.printOptionsSettings[poId].colors) poTexts.others.push('Värien määrä: ' + op.printOptionsSettings[poId].colors)
                  if(op.printOptionsSettings[poId] && op.printOptionsSettings[poId].renewal) poTexts.others.push('Uusinta-aloitus: ' + op.printOptionsSettings[poId].renewal)
                  pos.push(poTexts)
                }
              }
              var pos2 = []
              if(op.printOptions2 && op.printOptions2.length > 0){
                printFormatVersion2 = "new"
                for (let poId of op.printOptions2) {
                  var poTexts = this.getOptionDetailsById(p,poId,'fi')
                  if(op.printOptionsSettings2[poId] && op.printOptionsSettings2[poId].colors) poTexts.others.push('Värien määrä: ' + op.printOptionsSettings2[poId].colors)
                  if(op.printOptionsSettings2[poId] && op.printOptionsSettings2[poId].renewal) poTexts.others.push('Uusinta-aloitus: ' + op.printOptionsSettings2[poId].renewal)
                  pos2.push(poTexts)
                }
              }
              if(delivery !== 'printShop'){
                if(op.print){
                  if(printFormatVersion === 'old' && op.numberOfPrintColors) message += "Värien määrä: "+op.numberOfPrintColors+"\n"
                  if(printFormatVersion === 'old') {
                    if(op.printFormatsText && !pfText){
                      message += "Merkkausmenetelmä: "+op.printFormatsText+"\n"
                    }
                    else if (pfText){
                      message += "Merkkausmenetelmä: "+pfText+"\n"
                    }
                  }
                  if(printFormatVersion === 'new'){
                    pos.forEach(po => {
                      if(po.pf) message += "Merkkausmenetelmä: "+po.pf+"\n"
                      po.others.forEach(otherItem => {
                        message += otherItem + "\n"
                      })
                    })
                  }
                  if(op.printColor.trim() !== '') message += "Merkkauksen väri: "+op.printColor+"\n"
                  if(op.printLocation.trim() !== '') message += "Merkkauskohta: "+op.printLocation+"\n"
                  if(op.printContent.trim() !== '') message += "Mitä merkataan: "+op.printContent+"\n"
                  if(op.printComments.trim() !== '') message += "Merkkauksen lisätiedot: "+op.printComments+"\n"
                }
                
                if(op.secondPrint){
                  if(pfText2 || pos2.length > 0) message += '\nToinen merkkaus \n'
                  if(printFormatVersion2 === 'old' && op.numberOfPrintColors2) message += "Värien määrä: "+op.numberOfPrintColors2+"\n"
                  if(printFormatVersion2 === 'old'){
                    if(op.printFormatsText2 && !pfText2){
                      message += "Merkkausmenetelmä: "+op.printFormatsText2+"\n"
                    }
                    else if (pfText2){
                      message += "Merkkausmenetelmä: "+pfText2+"\n"
                    }
                  }
                  if(printFormatVersion2 === 'new'){
                    pos2.forEach(po => {
                      if(po.pf) message += "Merkkausmenetelmä: "+po.pf+"\n"
                      po.others.forEach(otherItem => {
                        message += otherItem + "\n"
                      })
                    })
                  }
                  
                  if(op.printColor2 && op.printColor2.trim() !== '') message += "Merkkauksen väri: "+op.printColor2+"\n"
                  if(op.printLocation2 && op.printLocation2.trim() !== '') message += "Merkkauskohta: "+op.printLocation2+"\n"
                  if(op.printContent2 && op.printContent2.trim() !== '') message += "Mitä merkataan: "+op.printContent2+"\n"
                  if(op.printComments2 && op.printComments2.trim() !== '') message += "Merkkauksen lisätiedot: "+op.printComments2+"\n"
                  message += '\n'
                }
              }
              message += '\n'
            }
            //message += "\nMerkkaus\n\n\n"
            
            

            //message += "Liitteenä materiaalia.\n\n"
            if(delivery !== 'printShop') message += "\nSaammehan vedokset?\n\n"
            message += "Toimitus\n"
            //if(delivery === 'avecor') message += "Avecor Oy\n"
            message += addressText+"\n\n"
            message += "Kiitos!\n\n"
            /* message += "Ystävällisin terveisin / Best regards\n\n" */

            this.copy(message)
          }
          else if(lang === 'en'){
            var productVariationId = item.productVariationId
            var message = "Hi,\n\n"
            if(!latestToCustomer && !isDeliveryWeekWithin2Weeks){
              if(delivery === 'printShop') message += `New order ${netvisorId}, delivery directly to the print shop.\n\n`
              else message += `New order ${netvisorId}\n\n`
            } 
            else if(latestToCustomer) {
              var s = latestToCustomer.split('-')
              if(s.length == 3){
                var date = this.dateFormatForEmailText(latestToCustomer)//s[2]+'.'+
                if(delivery === 'printShop') message += `New order ${netvisorId}, delivery directly to the print shop. This order has a deadline date of ${date}. Can you ensure the order is delivered by then?\n\n`
                else message += `New order ${netvisorId}. This order has a deadline date of ${date}. Can you ensure the order is delivered by then?\n\n`
                
              }
              else {
                if(delivery === 'printShop') message += `New order ${netvisorId}, delivery directly to the print shop.\n\n`
                else message += `New order ${netvisorId}\n\n`
              }
            }
            else if(isDeliveryWeekWithin2Weeks) {
              if(delivery === 'printShop') message += `New order ${netvisorId}, delivery directly to the print shop. This order has a deadline for week: ${deliveryWeek}. Can you ensure it is delivered by then?\n\n`
              else message += `New order ${netvisorId}. This order has a deadline for week: ${deliveryWeek}. Can you ensure it is delivered by then?\n\n`
            }

            for(var i = 0; i < items.length; i++){
              var opId = items[i]
              var op = this.orderedProducts[opId]
              var p = this.products[op.productId]
              console.log({opId})
              message += "Product\n"
              var productVariationId = op.productVariationId
              var avecorSku = this.products[this.productVariations[productVariationId].productId].avecorSku
              var wholesaleSku = this.productVariations[productVariationId].wholesaleSku
              if(wholesaleSku) message += wholesaleSku
              else message += avecorSku
              var name = this.products[this.productVariations[productVariationId].productId].name.wholesale ? this.products[this.productVariations[productVariationId].productId].name.wholesale : ''
              //if(!name) name = this.products[this.productVariations[productVariationId].productId].name.en ? this.products[this.productVariations[productVariationId].productId].name.en : ''
              if(!name) name = this.products[this.productVariations[productVariationId].productId].name.fi
              message += " - " + name
              var colorCode = this.productVariations[productVariationId].colorCode
              var color = ""
              if(this.settings.colors[colorCode]) color = this.settings.colors[colorCode].en
              

              if(this.productVariations[productVariationId].size) message += " - " + this.productVariations[productVariationId].size

              var wholesaleColor = this.productVariations[productVariationId].color
              if (wholesaleColor) message += " - " + wholesaleColor
              else if(color) message += " - " + color
              if(this.productVariations[productVariationId].other) message += " - " + this.productVariations[productVariationId].other

              message += "\n\Amount\n"
              message += op.quantity
              if(op.numberOfSamples) message += ' + ' + op.numberOfSamples + ' sample delivery to us?'
              message += '\n\n'  
              /* Object.keys(this.settings.printFormatsObject).forEach(pfId => {
                console.log(this.settings.printFormatsObject[pfId].fi)
              }) */
              var printFormatVersion = "old"
              var printFormatVersion2 = "old"
              var pfText = ""
              if(op.printFormats){
                op.printFormats.forEach(pfId => {
                  if(this.settings.printFormatsObject[pfId]) {
                      var pf = this.settings.printFormatsObject[pfId]
                      if(pfText && pf.en) pfText += ', ' + pf.en
                      else if(pf.en) pfText += pf.en
                  }
                })
              }
              var pfText2 = ""
              if(op.printFormats2){
                op.printFormats2.forEach(pfId => {
                  if(this.settings.printFormatsObject[pfId]) {
                      var pf = this.settings.printFormatsObject[pfId]
                      if(pfText2) pfText2 += ', ' + pf.en
                      else pfText2 += pf.en
                  }
                })
              }

              var pos = []
              if(op.printOptions && op.printOptions.length > 0){
                printFormatVersion = "new"
                for (let poId of op.printOptions) {
                  var poTexts = this.getOptionDetailsById(p,poId,'en')
                  if(op.printOptionsSettings[poId] && op.printOptionsSettings[poId].colors) poTexts.others.push('Värien määrä: ' + op.printOptionsSettings[poId].colors)
                  if(op.printOptionsSettings[poId] && op.printOptionsSettings[poId].renewal) poTexts.others.push('Uusinta-aloitus: ' + op.printOptionsSettings[poId].renewal)
                  pos.push(poTexts)
                }
              }

              var pos2 = []
              if(op.printOptions2 && op.printOptions2.length > 0){
                printFormatVersion2 = "new"
                for (let poId of op.printOptions2) {
                  var poTexts = this.getOptionDetailsById(p,poId,'en')
                  if(op.printOptionsSettings2[poId] && op.printOptionsSettings2[poId].colors) poTexts.others.push('Värien määrä: ' + op.printOptionsSettings2[poId].colors)
                  if(op.printOptionsSettings2[poId] && op.printOptionsSettings2[poId].renewal) poTexts.others.push('Uusinta-aloitus: ' + op.printOptionsSettings2[poId].renewal)
                  pos2.push(poTexts)
                }
              }

              
              let res = await axios.post(
                'https://us-central1-logogear-erp.cloudfunctions.net/translate',
                //`http://0.0.0.0:5000/logogear-erp/us-central1/translate`,
                { q: [op.printColor,op.printLocation,op.printContent,op.printComments], target: "en" },
              );
              let res2 = await axios.post(
                'https://us-central1-logogear-erp.cloudfunctions.net/translate',
                //`http://0.0.0.0:5000/logogear-erp/us-central1/translate`,
                { q: [op.printColor2 ? op.printColor2 : '',op.printLocation2 ? op.printLocation2 : '',op.printContent2 ? op.printContent2 : '',op.printComments2 ? op.printComments2 : ''], target: "en" },
              );
              if(delivery !== 'printShop'){
                if(res.data.ok && res2.data.ok){
                  if(op.print){
                    if(printFormatVersion === 'old' && op.numberOfPrintColors) message += "Number of colors: "+op.numberOfPrintColors+"\n"
                    if(printFormatVersion === 'old') {
                      if(op.printFormatsText && !pfText){
                        let res2 = await axios.post(
                          'https://us-central1-logogear-erp.cloudfunctions.net/translate',
                          { q:[op.printFormatsText], target: "en" },
                        );
                        var t2 = res2.data.translations
                        console.log(t2)
                        message +=  "Print format: "+t2[0]+ "\n"
                      }
                      else if(pfText) {
                        message += "Print format: "+pfText+"\n"
                      }
                    }
                    if(printFormatVersion === 'new'){
                      for(var l = 0; l < pos.length; l ++){
                        var po = pos[l]
                        if(po.pf) message += "Print format: "+po.pf+"\n"
                        if(po.others && po.others.length > 0){
                          let res2 = await axios.post(
                            'https://us-central1-logogear-erp.cloudfunctions.net/translate',
                            { q: po.others, target: "en" },
                            
                          );
                          var t2 = res2.data.translations
                          t2.forEach(otherItem => {
                            message += otherItem + "\n"
                          })
                        }
                      }
                    }
                    var t = res.data.translations
                    if(op.printColor.trim() !== '') message += "Print color: "+t[0]+"\n"
                    if(op.printLocation.trim() !== '') message += "Print location: "+t[1]+"\n"
                    if(op.printContent.trim() !== '')message += "What content: "+t[2]+"\n"
                    if(op.printComments.trim() !== '')message += "Print comments: "+t[3]+"\n"
                  }

                  if(op.secondPrint){
                    if(pfText2 || pos2.length > 0) message += '\nSecond print \n'
                    if(printFormatVersion2 === 'old' && op.numberOfPrintColors2) message += "Number of colors: "+op.numberOfPrintColors+"\n"
                    if(printFormatVersion2 === 'old') {
                      if(op.printFormatsText2 && !pfText2){
                        let res2 = await axios.post(
                          'https://us-central1-logogear-erp.cloudfunctions.net/translate',
                          { q:[op.printFormatsText2], target: "en" },
                        );
                        var t2 = res2.data.translations
                        message +=  "Print format: "+t2[0]+ "\n"
                      }
                      else if(pfText2) {
                        message += "Print format: "+pfText2+"\n"
                      }
                    }
                    if (printFormatVersion2 === 'new'){
                      for(var k = 0; k < pos2.length; k++){
                        var po = pos2[k]
                        if(po.pf) message += "Print format: "+po.pf+"\n"
                        if(po.others && po.others.length > 0){
                          let res2 = await axios.post(
                            'https://us-central1-logogear-erp.cloudfunctions.net/translate',
                            { q: po.others, target: "en" },
                            
                          );
                          var t2 = res2.data.translations
                          console.log(t2)
                          t2.forEach(otherItem => {
                            message += otherItem + "\n"
                          })
                        }
                      }
                    }
                    var t = res2.data.translations
                    if(op.printColor2 && op.printColor2.trim() !== '') message += "Print color: "+t[0]+"\n"
                    if(op.printLocation2 && op.printLocation2.trim() !== '') message += "Print location: "+t[1]+"\n"
                    if(op.printContent2 && op.printContent2.trim() !== '')message += "What content: "+t[2]+"\n"
                    if(op.printComments2 && op.printComments2.trim() !== '')message += "Print comments: "+t[3]+"\n"
                    message += '\n'
                  }
                }
                else{
                  if(op.numberOfPrintColors) message += "Number of colors: "+op.numberOfPrintColors+"\n"
                  if(pfText) message += "Print format: "+pfText+"\n"
                  if(op.printColor.trim() !== '') message += "Print color: "+op.printColor+"\n"
                  if(op.printLocation.trim() !== '') message += "Print location: "+op.printLocation+"\n"
                  if(op.printContent.trim() !== '')message += "What content: "+op.printContent+"\n"
                  if(op.printComments.trim() !== '')message += "Print comments: "+op.printComments+"\n"
                  message += '\n'
                }
                message += "\n-------- SUOMEKSI TIEDOT: POISTA NÄMÄ KUN OLET TARKASTANUT YLLÄ OLEVAT KÄÄNNÖKSET -------------\n\n"
                if(op.print){
                  if(op.printFormatsText && !pfText) message += "Merkkaustapa: "+op.printFormatsText+"\n"
                  if(op.printColor.trim()) message += "Merkkauksen väri: "+op.printColor+"\n"
                  if(op.printLocation.trim()) message += "Merkkauskohta: "+op.printLocation+"\n"
                  if(op.printContent.trim())message += "Mitä merkataan: "+op.printContent+"\n"
                  if(op.printComments.trim())message += "Merkkauksen lisätiedot: "+op.printComments+"\n"
                  //message += '\n'
                }
                
                if(op.secondPrint){
                  message += 'Toinen merkkaus\n'
                  if(op.printFormatsText2 && !pfText2) message += "Merkkaustapa: "+op.printFormatsText2+"\n"
                  if(op.printColor2 && op.printColor2.trim()) message += "Merkkauksen väri: "+op.printColor2+"\n"
                  if(op.printLocation2 && op.printLocation2.trim()) message += "Merkkauskohta: "+op.printLocation2+"\n"
                  if(op.printContent2 && op.printContent2.trim())message += "Mitä merkataan: "+op.printContent2+"\n"
                  if(op.printComments2 && op.printComments2.trim())message += "Merkkauksen lisätiedot: "+op.printComments2+"\n"
                }
                message += '\n'
                message += "----------------------------------------------------------------------------------------------------------"
                message += '\n\n'
              }
            }
            
            if(delivery !== 'printShop') message += "\nCan we have a layout?\n\n"
            message += "Delivery to\n"
            message += addressText+"\n\n"
            message += "Thank you!\n\n"
            

            this.copy(message)
          }
        }
        catch (e){
          console.log(e)
        }
      },
      /* createVariationAvecorSku(pvId){
        var pv = this.productVariations[pvId]
        var avecorSku = this.products[pv.productId] && this.products[pv.productId].avecorSku ? this.products[pv.productId].avecorSku : ''
        return pv.colorCode ? avecorSku + '-' + pv.colorCode : avecorSku
      }, */
      productsTotalOut(item){
        var unitPrice = item.unitPrice != null && !isNaN(Number(item.unitPrice)) ? Number(item.unitPrice) : 0
        var unitPrintPrice = item.unitPrintPrice != null && !isNaN(Number(item.unitPrintPrice)) ? Number(item.unitPrintPrice) : 0
        var quantity = item.quantity != null && !isNaN(Number(item.quantity)) ? Number(item.quantity) : 0
        var total = (unitPrice + unitPrintPrice) * quantity
        total = total.toFixed(2)
        return total
      },
      productsTotalIn(item){
        var quantity = item.quantity != null && !isNaN(Number(item.quantity)) ? Number(item.quantity) : 0
        var unitPurchasePriceInclPrint = item.unitPurchasePriceInclPrint != null && !isNaN(Number(item.unitPurchasePriceInclPrint)) ? Number(item.unitPurchasePriceInclPrint) : 0
        //console.log({quantity,unitPurchasePriceInclPrint})
        var total = unitPurchasePriceInclPrint * quantity
        total = total.toFixed(2)
        return total
      },
      marginProductsInclPrint(item){
        var margin =  this.productsTotalOut(item) - this.productsTotalIn(item)
        margin = margin.toFixed(2)
        return margin
      },
      
      getTotalProductsMargin(){
        var m = 0
        this.getOrderedProducts.forEach(op => {
          if(op.orderStatus !== 'cancelled') m += op.confirmedMargin !== undefined && !isNaN(Number(op.confirmedMargin)) ? Number(op.confirmedMargin) : 0
        })
        return m
      },
      getOrderTotalMargin(){
        var m = this.getTotalProductsMargin() 
        m += this.selectedOrder.marginDeliveryCharge !== undefined && !isNaN(Number(this.selectedOrder.marginDeliveryCharge)) ? Number(this.selectedOrder.marginDeliveryCharge) : 0
        return m
      },
      async addOrderedProduct(orderId) {
        this.newOrderedProductModalVisible = true
        this.newOrderedProductModalOrderId = orderId
      },
      async selectFileForMediaViewer(fileId){
        var docRef = db.collection("files").doc(fileId);
        var doc = await docRef.get()
        this.selectedFileForMediaViewer = doc.data()
      },
      inlineSaveOrderSalesperson(salesperson){
          if(!this.orders[this.selectedOrderId]){
            alert("Tätä tilausta ei voi muokata.")
            return
          }
          console.log(salesperson)
          this.saveToOrder({
            id:this.selectedOrderId,
            salesperson
          })
          /* this.$store.dispatch('order/set', {
            id:this.selectedOrderId,
            salesperson
          }) */
          var ops = this.getOrderedProducts
          //console.log(ops)
          ops.forEach(op => {
            this.saveToOp({
              id:op.id,
              salesperson
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id:op.id,
              salesperson
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
          })
      },
      inlineSaveOrderDetails(field,event){
        //console.log(field, event)
        if(!this.orders[this.selectedOrderId] && !this.offerOrders[this.selectedOrderId]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        if(field === 'contactId' && event === ''){
          alert("Valittu kontakti ei voi olla tyhjä.")
          return
        }
        if(field === 'companyId' && event === ''){
          alert("Valittu yritys ei voi olla tyhjä.")
          return
        }
        
        if (field === "salespersonMargin" || field === "officeMargin" || field === 'marginDeliveryCharge') {
          event = event.replace(",", ".")
        }
        var oId = this.selectedOrderId
        var env = this.settings.env
        //env = "production"
        if(field === 'netvisorId'){
          this.saveToOrder({
            id:oId,
            netvisorId:event,
          })
          /* this.$store.dispatch('order/set', {
            id:oId,
            netvisorId:event,
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }
        else if(field === "created_at"){
          var dt1   = parseInt(event.substring(8,10));
          var mon1  = parseInt(event.substring(5,7));
          var yr1   = parseInt(event.substring(0,4));
          var date = new Date(yr1, mon1-1, dt1)
          var firebaseDate = firebase.firestore.Timestamp.fromDate(new Date(yr1, mon1-1, dt1));
          
          this.saveToOrder({
            id:oId,
            created_at:firebaseDate,
          })
          /* this.$store.dispatch('order/set', {
            id:oId,
            created_at:firebaseDate,
          }) */

          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          /* if(this.location === 'orders' && this.selectedOrderId && this.selectedOrder && (env === 'development' && this.selectedOrder.netvisorId_test_env) || (env === 'production' && this.selectedOrder.netvisorId)){
            this.syncOrderToNetvisor(this.selectedOrderId,env)
          }
          else {
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          } */
        }
        else if (field === "salespersonMargin") {
          if(this.orders[this.selectedOrderId].officeMargin){
            this.$store.dispatch('order/set', {
              id:oId,
              salespersonMargin:event
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))  
          }
          else {
            this.$store.dispatch('order/set', {
              id:oId,
              salespersonMargin:event,
              officeMargin:event
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        else if (field === "isAmendmentOrder" || field === 'deliveryBySalesperson') {
          this.saveToOrder({
            id:oId,
            [field]:event,
          })
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          /* this.$store.dispatch('order/set', {
            id:oId,
            [field]:event,
          }) */
          /* .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }
        else {
          this.saveToOrder({
            id:oId,
            [field]:event,
          })
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          /* this.$store.dispatch('order/set', {
            id:oId,
            [field]:event,
          }) */
          
          /* if(this.location === 'orders' && this.selectedOrderId && this.selectedOrder && ((env === 'development' && this.selectedOrder.netvisorId_test_env) || (env === 'production' && this.selectedOrder.netvisorId))
            && (field === 'salesperson' || field === 'billingReferenceDetails' || field === 'deliveryCharge')){
            this.syncOrderToNetvisor(this.selectedOrderId,env)
          }
          else {
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          } */
        }
      },
      inlineSaveContactDetails(field,event){
        var contactId = this.selectedOrder.contactId
        var env = this.settings.env
        if (field === 'clientPrintDetailsEmail'){
          var companyId = this.selectedOrder.companyId
          console.log(companyId)
          this.$store.dispatch('company/set', {
            id:companyId,
            clientPrintDetailsEmail:'',
          })  
        }

        this.$store.dispatch('contact/set', {
          id:contactId,
          [field]:event,
        })
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        /* if(this.location === 'orders' &&  this.selectedOrderId && this.selectedOrder && (env === 'development' && this.selectedOrder.netvisorId_test_env) || (env === 'production' && this.selectedOrder.netvisorId)){
          this.syncOrderToNetvisor(this.selectedOrderId,env)
        }
        else {
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        } */
      },
      inlineSaveSample(opId,field,value){
        if(!this.orderedProducts[opId]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }

        if (confirm(value ? 'Muutetaanko mallitilaukseski?':'Muutetaanko normaali tilaukseksi?')) {
          console.log({opId,field,value})
          this.saveToOp({
            id:opId,
            [field]:value
          })
          /* this.$store.dispatch('orderedProduct/set', {
            id:opId,
            [field]:value
          })
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }
      },
      inlineSaveCompanyDetails(field, event){
        var companyId = this.selectedOrder.companyId
        var env = this.settings.env
        if(field === "differentBillingAddress" || field === "differentBillingEmail")  {
          if(!event.target.checked) event = false
          else event = event.target.checked
        }
        this.$store.dispatch('company/set', {
          id:companyId,
          [field]:event,
        })
        console.log({field,event,order:this.selectedOrder})
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        /* if(this.location === 'orders' && this.selectedOrderId && this.selectedOrder && (env === 'development' && this.selectedOrder.netvisorId_test_env) || (env === 'production' && this.selectedOrder.netvisorId)){
          this.syncOrderToNetvisor(this.selectedOrderId,env)
        }
        else {
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        } */
      },
      getStatuses(item,includeInvoiced) {
        var isPrint = item.print
        var isSample = this.selectedOrder.sample !== undefined ? this.selectedOrder.sample : false
        var statuses = []
        
        var isWarehoused = this.productVariations[item.productVariationId] && this.productVariations[item.productVariationId].warehoused ? true : false

        if(isSample){
          this.settings.orderedProductSampleStatusArray.map(status => {
            isWarehoused && status.step === 'warehouseProducts' ? statuses.push(status) : ''
            status.step === "all" ? statuses.push(status) : ''
            return status
          })
        }
        else {
          this.settings.orderedProductStatusArray.map(status => {
            isWarehoused && status.step === 'warehouseProducts' ? statuses.push(status) : ''
            isPrint && status.step === "print" ? statuses.push(status) : ''
            status.step === "all" ? statuses.push(status) : ''
            return status
          })
          if(includeInvoiced){
            statuses.push({text:"Laskutettu", id: "invoiced"})
          }
        }
        return statuses
      },
      customFormatter(date,full) {
        if(!date) return ''
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          if(full) return dateFormat(myDate, "yyyy-mm-dd HH:MM")
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          if(full) return dateFormat(date, "yyyy-mm-dd HH:MM")
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      dateFormatForEmailText(date) {
          return dateFormat(date, "d.m.yyyy")
      },
      copy (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      getPrintShops(productId){
        var printShops = this.printShops
        var shops = ""
        this.products[productId] !== undefined && this.products[productId].printShops !== undefined && Array.isArray(this.products[productId].printShops) ? this.products[productId].printShops.forEach(shop => {
            printShops[shop] !== undefined ? shops += printShops[shop].name +", " : ""
            //console.log(productsData[pv.productId].printShops)
          }) : ""
        return shops
      },
      getWholesaleCompany(productId){
        if(this.products[productId] && this.products[productId].wholesaleCompany && this.wholesaleCompanies[this.products[productId].wholesaleCompany]) return this.wholesaleCompanies[this.products[productId].wholesaleCompany].name
        return ""
      },
      calculateTotal(item,whichTotal,whichFnToUse){
        var formatToThreeDecimals = null

        if(!whichFnToUse) formatToThreeDecimals = this.formatToThreeDecimals
        else formatToThreeDecimals = module.exports.formatToThreeDecimals
        var totalProductOut = formatToThreeDecimals(item.quantity) * formatToThreeDecimals(item.unitPrice)
        var totalProductIn = formatToThreeDecimals(item.quantity) * formatToThreeDecimals(item.p_houseUnitPrice)
        var totalPrintOut = 0
        var totalPrintIn = 0
        var totalPositioningsOut = 0
        var totalPositioningsIn = 0
        var totalExtraCostsIn = item.p_houseUnitAllOtherCosts ? item.p_houseUnitAllOtherCosts * formatToThreeDecimals(item.quantity) : 0

        if(item.print){
          var printQuantity = item.print && item.printQuantity ? formatToThreeDecimals(item.printQuantity) : 0
          totalPrintOut = printQuantity * formatToThreeDecimals(item.unitPrintPrice)
          totalPrintIn = printQuantity * formatToThreeDecimals(item.p_houseUnitPrintPrice)

          var numberOfPositionings = formatToThreeDecimals(item.numberOfPositionings)
          totalPositioningsOut = numberOfPositionings * formatToThreeDecimals(item.pricePerPositioning)
          totalPositioningsIn = formatToThreeDecimals(numberOfPositionings) * formatToThreeDecimals(item.p_houseUnitStartCosts)
        }
        
        if(whichTotal === 'product_total_out'){return formatToThreeDecimals(totalProductOut)}
        if(whichTotal === 'product_total_in'){return formatToThreeDecimals(totalProductIn)}
        if(whichTotal === 'product_margin'){return formatToThreeDecimals(totalProductOut - totalProductIn)}
        if(whichTotal === 'print_total_out'){return formatToThreeDecimals(totalPrintOut)}
        if(whichTotal === 'print_total_in'){return formatToThreeDecimals(totalPrintIn)}
        if(whichTotal === 'print_margin'){return formatToThreeDecimals(totalPrintOut - totalPrintIn)}
        if(whichTotal === 'positionings_total_out'){return formatToThreeDecimals(totalPositioningsOut)}
        if(whichTotal === 'positionings_total_in'){return formatToThreeDecimals(totalPositioningsIn)}
        if(whichTotal === 'positionings_margin'){return formatToThreeDecimals(totalPositioningsOut - totalPositioningsIn)}
        if(whichTotal === 'allOtherCosts_total_in'){return formatToThreeDecimals(totalExtraCostsIn)}
        if(whichTotal === 'allOtherCosts_margin'){return formatToThreeDecimals(0-totalExtraCostsIn)}
        
        if(whichTotal === 'all_total_out'){return formatToThreeDecimals(totalProductOut + totalPrintOut + totalPositioningsOut)}
        if(whichTotal === 'all_total_in'){return formatToThreeDecimals(totalProductIn + totalPrintIn + totalPositioningsIn +totalExtraCostsIn)}
        if(whichTotal === 'all_total_margin'){return formatToThreeDecimals((totalProductOut - totalProductIn) + (totalPrintOut - totalPrintIn) + (totalPositioningsOut - totalPositioningsIn) + (0-totalExtraCostsIn))}
        
      },
      /* formatToThreeDecimals(number){
        if(isNaN(Number(number))) return 0
        else {
          var val = Number(number)
          val = val.toFixed(2)
          val = Number(val)
          return val
        }
      }, */
      getTotal(item) {
        return Number((item.unitPrice * item.quantity) + (item.unitPrintPrice * item.printQuantity) + (item.pricePerPositioning * item.numberOfPositionings)).toFixed(2)
      },
      
      getPositioningIn(item){
        return item.purchasePricePerPositioning && item.numberOfPositionings ? Number(item.purchasePricePerPositioning * item.numberOfPositionings).toFixed(2) : 0
      },
      getProductsIn(item){
        return item.purchaseUnitPrice && item.quantity ? (item.purchaseUnitPrice * item.quantity).toFixed(2) : 0
      },
      getPrintIn(item){
        return item.purchaseUnitPrintPrice && item.printQuantity ? (item.purchaseUnitPrintPrice * item.printQuantity).toFixed(2) : 0
      },
      getTotalMargin(item) {
        var productIn = this.getProductsIn(item)
        var printIn = this.getPrintIn(item)
        var productsIn = this.productsTotalIn(item)
        var positioningIn = this.getPositioningIn(item)
        var totalIn = parseFloat(productIn) + parseFloat(printIn) + parseFloat(positioningIn)
        return (this.getTotal(item)-(parseFloat(productsIn) + parseFloat(positioningIn)) ).toFixed(2)
      },
      editItem (item) {
        this.editedIndex = this.products.indexOf(item)
        this.newItem = Object.assign({}, item)
        this.dialog = true
      },
      async deleteItem (item) {
        if(this.searchOrderedProducts[item.id]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        if (confirm('Haluatko varmasti poistaa tuotteen tältä tilaukselta?')) {
          if(item.isOffer){
            console.log("OFFER "+item.id)
            await db.collection('orderedProducts').doc(item.id).delete()
          }
          else{
            this.$store.dispatch('orderedProduct/delete', item.id)
          }
        }
      },
      inlineSaveQuantity (id,field,value) {
        if(!this.orderedProducts[id] && !this.offerOrderedProducts[id]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        var env = this.settings.env
        this.saveToOp({
          id,
          [field]:value
        })
        /* this.$store.dispatch('orderedProduct/set', {
          id,
          [field]:value
        }) */
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        /* if(this.location === 'orders' && this.selectedOrderId && this.selectedOrder && (env === 'development' && this.selectedOrder.netvisorId_test_env) || (env === 'production' && this.selectedOrder.netvisorId)){
          this.syncOrderToNetvisor(this.selectedOrderId,env)
        }
        else {
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        } */
      },
      inlineSavePrice(id,field,value){
        console.log("HERE 1")
        if(!this.orderedProducts[id] && !this.offerOrderedProducts[id]){
          console.log("HERE 2")
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        value = value.replace(",", ".")
        console.log(value)
        if(isNaN(Number(value))){
          alert("Invalidi arvo syötetty.")
          return
        }
        value = Number(value)
        this.saveToOp({
          id,
          [field]:value
        })
        /* this.$store.dispatch('orderedProduct/set', {
          id,
          [field]:value
        }) */
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})

        /* var env = this.settings.env
        if(this.location === 'orders' && this.selectedOrderId && this.selectedOrder && (env === 'development' && this.selectedOrder.netvisorId_test_env) || (env === 'production' && this.selectedOrder.netvisorId)){
          this.syncOrderToNetvisor(this.selectedOrderId,env)
        }
        else {
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})  
        } */
      },
      inlineSavePriceNoSyncToNetvisor(id,field,value){
        value = value.replace(",", ".")
        if(isNaN(Number(value))){
          alert("Invalidi arvo syötetty.")
          return
        }
        if(value !== ''){
          value = Number(value)
        }
        if(field === 'salespersonMargin'){
          this.saveToOp({
            id,
            [field]:value,
            salespersonMarginSetManually:true
          })
          /* this.$store.dispatch('orderedProduct/set', {
            id,
            [field]:value,
            salespersonMarginSetManually:true  
          })
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})   */
        }
        else {
          this.saveToOp({
            id,
            [field]:value
          })
          /* this.$store.dispatch('orderedProduct/set', {
            id,
            [field]:value
          }) 
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          */
        }
        
      },
      inlineSave(item) {
        var {id, ...y} = item;
        this.saveToOp({
          id,
          ...y
        })
      },
      
      
      inlineSaveDate (id,field,value) {
        if(!this.orderedProducts[id]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        var fieldUser = field.replace('Date','User')
        if(field === 'whenToInvoice') fieldUser = 'whenToInvoiceUser'
        //console.log(fieldUser)
        if(value){
          var dt1   = parseInt(value.substring(8,10));
          var mon1  = parseInt(value.substring(5,7));
          var yr1   = parseInt(value.substring(0,4));
          var firebaseDate = firebase.firestore.Timestamp.fromDate(new Date(yr1, mon1-1, dt1));
          var uid = this.user.uid
          if(field === 'whenToInvoice'){
            this.saveToOp({
              id,
              [field]:firebaseDate,
              [fieldUser]:uid,
              whenToInvoiceSetManually:true
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id,
              [field]:firebaseDate,
              [fieldUser]:uid,
              whenToInvoiceSetManually:true
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))  */
          }
          else{
            this.saveToOp({
              id,
              [field]:firebaseDate,
              [fieldUser]:uid
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id,
              [field]:firebaseDate,
              [fieldUser]:uid
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
          }

          // Update also in history
          if(field === 'shippedDate'){
            var op = this.orderedProducts[id]
            if(this.orders[op.orderId] && this.orders[op.orderId].activityLog){
              var alCopy = JSON.parse(JSON.stringify(this.orders[op.orderId].activityLog))
              var firstFound = false
              alCopy.forEach(a => {
                if(a.opId === id && a.whichStatus === 'orderStatus' && a.newStatus === 'productsShipped' && !firstFound){
                  firstFound = true
                  a.date = firebaseDate
                }
              })
              if(firstFound){
                this.saveToOrder({
                  id:op.orderId,
                  activityLog:alCopy
                })
                /* this.$store.dispatch('order/set', {
                  id:op.orderId,
                  activityLog:alCopy
                }) */
              }
            }
          }
        }
        else {
          this.saveToOp({
            id,
            [field]:'',
            [fieldUser]:''
          })
          /* this.$store.dispatch('orderedProduct/set', {
            id,
            [field]:'',
            [fieldUser]:''
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }
      },
      getPartialDeliveries(partialDeliveries){
        var sortedPartialDeliveries = []
        Object.keys(partialDeliveries).forEach(pdId =>{
          var pd = partialDeliveries[pdId]
          sortedPartialDeliveries.push({...pd, id:pdId})
        })
        sortedPartialDeliveries.sort(function(a,b){
          return new Date(b.date) - new Date(a.date)
        });
        return sortedPartialDeliveries
      },
      inlineSaveBackOrderAmount(id,v){
        if(!this.orderedProducts[id]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        var op = this.orderedProducts[id]
        var quantity = Number(op.quantity)
        
        if(v === '') {
          this.saveToOp({
            id,
            backOrderAmount:v,
          })
          /* this.$store.dispatch('orderedProduct/set', {
            id,
            backOrderAmount:v,
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))  */
          return
        }

        var oldBackOrderAmount = !isNaN(Number(op.backOrderAmount)) ? Number(op.backOrderAmount) : 0
        var newBackOrderAmount = Number(v)
        
        var diff = 0
        if(oldBackOrderAmount !== 0){
          diff = oldBackOrderAmount - newBackOrderAmount
        }
        else {
          diff = quantity - newBackOrderAmount
        }
        if(diff === 0){
          this.saveToOp({
            id,
            backOrderAmount:v,
          })
          /* this.$store.dispatch('orderedProduct/set', {
            id,
            backOrderAmount:v,
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))  */
          return
        }
        /* var partialDeliveries = []
        if(op.partialDeliveries) partialDeliveries = op.partialDeliveries */

        var partialDeliveryId1 = Math.random().toString(36).substr(2, 9);
        var partialDeliveryId2 = Math.random().toString(36).substr(2, 9);
        var partialDeliveryId = partialDeliveryId1+partialDeliveryId2
        var uid = this.user.uid
        var firebaseDate = firebase.firestore.Timestamp.fromDate(new Date());
        var newPartialDelivery = {
          date:firebaseDate,
          deliveredAmount:diff,
          user:uid
        }
        var partialDeliveries = {}
        if(op.partialDeliveries){
          partialDeliveries = JSON.parse(JSON.stringify(op.partialDeliveries))
        } 
        partialDeliveries[partialDeliveryId] = newPartialDelivery
        this.saveToOp({
          id,
          backOrderAmount:v,
          partialDeliveries
        })
        /* this.$store.dispatch('orderedProduct/set', {
          id,
          backOrderAmount:v,
          partialDeliveries
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
      },
      async deletePartialDelivery(opId,partialDeliveryId){
        var op = this.orderedProducts[opId]
        if (confirm('Haluatko poistaa?')) {
          this.$store.dispatch('orderedProduct/delete', `${opId}.partialDeliveries.${partialDeliveryId}`)
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      addPartialDelivery(id){
        var partialDeliveryId1 = Math.random().toString(36).substr(2, 9);
        var partialDeliveryId2 = Math.random().toString(36).substr(2, 9);
        var partialDeliveryId = partialDeliveryId1+partialDeliveryId2
        var uid = this.user.uid
        var firebaseDate = firebase.firestore.Timestamp.fromDate(new Date());
        var newPartialDelivery = {
          date:firebaseDate,
          deliveredAmount:0,
          user:uid,
          invoiceStatus:'invoice',
          invoiceDate:''
        }
        
        var partialDeliveries = {}
        var op = this.orderedProducts[id]
        if(op.partialDeliveries){
          partialDeliveries = JSON.parse(JSON.stringify(op.partialDeliveries))
        } 
        partialDeliveries[partialDeliveryId] = newPartialDelivery
        this.saveToOp({
          id,
          partialDeliveries,
          orderInvoiceStatus:'invoice'
        })
        /* this.$store.dispatch('orderedProduct/set', {
          id,
          partialDeliveries,
          orderInvoiceStatus:'invoice'
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
      },
      inlineSavePartialDelivery(opId,pdId,field,value){
        if(!this.orderedProducts[opId]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        var op = this.orderedProducts[opId]
        var partialDeliveries = JSON.parse(JSON.stringify(op.partialDeliveries))
        var pd = partialDeliveries[pdId]
        
        if(field === 'date'){
          var firebaseDate = firebase.firestore.Timestamp.fromDate(new Date(value));
          partialDeliveries[pdId].date = firebaseDate
        }
        else if (field === 'invoiceStatus'){
          value = value.target.value
          partialDeliveries[pdId].invoiceStatus = value
        }
        else{
          var val = Number(value.trim())
          var total = 0
          if(Object.keys(partialDeliveries).forEach(pdIdLoop => {
            var pd = partialDeliveries[pdIdLoop]
            if(!isNaN(Number(pd.deliveredAmount)) && pdId !== pdIdLoop ) total += Number(pd.deliveredAmount)

          }))
          total = total + val
          
          if((total+val) > Number(op.quantity)){
            alert(`Osatoimituksien yhteenlaskettu määrä ei voi olla enemmän kuin tilattu määrä (${op.quantity})`)
            this.partialDeliveriesExpandKey += 1
            return
          }
          partialDeliveries[pdId][field] = value
          firebaseDate = firebase.firestore.Timestamp.fromDate(new Date());
          partialDeliveries[pdId].date = firebaseDate
        }
        partialDeliveries[pdId]['user'] = this.user.uid
        console.log(partialDeliveries)
        this.saveToOp({
          id:opId,
          partialDeliveries
        })
        /* this.$store.dispatch('orderedProduct/set', {
          id:opId,
          partialDeliveries
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
      },
      async inlineSaveStatus (item, whichStatus,newStatus) {
        var {id, orderStatus,orderInvoiceStatus, shippedDate, whenToInvoice, ...y} = item;
        if(!this.orderedProducts[id]){
          alert("Tätä tilausta ei voi muokata.")
          return
        }
        //console.log({orderStatus,newStatus})
        
        var newStatusUser = this.user.uid
        // ORDER STATUS
        
        var op = item
        var pv = this.productVariations[op.productVariationId]
        var p = this.products[op.productId]
        if(whichStatus === "orderStatus"){
          var newShippedDate = ""
          var newOrderInvoiceSatus = ""
          var newStatusDate = null
          
          if (newStatus === "productsShipped")  {//
            newShippedDate = firebase.firestore.Timestamp.fromDate(new Date());
            if(orderInvoiceStatus !== 'invoiced') newOrderInvoiceSatus = "invoice"
            else newOrderInvoiceSatus = orderInvoiceStatus
          }
          else  {
            newOrderInvoiceSatus = orderInvoiceStatus
            //if(orderInvoiceStatus === 'invoice' || orderInvoiceStatus === 'invoiced') {}
            //else newOrderInvoiceSatus = "invoiced"
            newStatusDate = firebase.firestore.Timestamp.fromDate(new Date());
          }

          // MOVED TO PRODUCT SHIPPED
          //console.log({newStatus,orderStatus})
          
          if (newStatus === "productsShipped" && orderStatus !== 'productsShipped')  {
            console.log("MOVED TO PRODUCT SHIPPED")
            var newStockAmount = 0
            if(pv.warehoused){ 
              var avecorStock = pv.avecorStock === undefined ? 0 : pv.avecorStock
              avecorStock = Number(avecorStock)
              var m = p.orderUnitToStockUnitMultiplier && !isNaN(Number(p.orderUnitToStockUnitMultiplier)) ? p.orderUnitToStockUnitMultiplier : 1
              var quantity = 0
              var numberOfSamples = 0
              console.log((Number(op.quantity)*m))
              !isNaN(Number(op.quantity)) ? quantity += (Number(op.quantity)*m) : ''
              !isNaN(Number(op.numberOfSamples)) ? numberOfSamples += (Number(op.numberOfSamples)*m) : ''
              var newStockAmount = avecorStock - quantity - numberOfSamples
              
              console.log({newStockAmount,avecorStock,quantity,numberOfSamples})
              this.$store.dispatch('productVariation/set', {
                id:op.productVariationId,
                avecorStock:newStockAmount,
              })
              console.log(op.productVariationId,newStockAmount)
              
              this.logStockUpdateProductChange(pv.productId,pv.id,op.orderId,op.id,newStatusUser,Number(avecorStock),newStockAmount,0-(Number(op.quantity)*m),"movedToProductShippedStatus")
            }
          }
          // MOVED BACK FROM PRODUCT SHIPPED
          else if (newStatus !== "productsShipped" && orderStatus === 'productsShipped')  { 
            console.log("MOVED OUT OF PRODUCT SHIPPED")
            var newStockAmount = 0
            if(pv.warehoused){ 
              var avecorStock = pv.avecorStock === undefined ? 0 : pv.avecorStock
              avecorStock = Number(avecorStock)
              var m = p.orderUnitToStockUnitMultiplier && !isNaN(Number(p.orderUnitToStockUnitMultiplier)) ? p.orderUnitToStockUnitMultiplier : 1
              var quantity = 0
              var numberOfSamples = 0
              console.log((Number(op.quantity)*m))
              !isNaN(Number(op.quantity)) ? quantity += (Number(op.quantity)*m) : ''
              !isNaN(Number(op.numberOfSamples)) ? numberOfSamples += (Number(op.numberOfSamples)*m) : ''
              var newStockAmount = avecorStock + quantity + numberOfSamples
              
              console.log({newStockAmount,avecorStock,quantity,numberOfSamples})
              this.$store.dispatch('productVariation/set', {
                id:op.productVariationId,
                avecorStock:newStockAmount,
              })
              console.log(op.productVariationId,newStockAmount)
              
              this.logStockUpdateProductChange(pv.productId,pv.id,op.orderId,op.id,newStatusUser,Number(avecorStock),newStockAmount,(Number(op.quantity)*m),"movedOutOfProductShippedStatus")
            }
          }


          if(newStatusDate){
            this.saveToOp({
              id,
              orderStatus:newStatus,
              [newStatus+"Date"]:newStatusDate,
              [newStatus+"User"]:newStatusUser,
              orderInvoiceStatus:newOrderInvoiceSatus,
              shippedUser:'',
              shippedDate:'',
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id,
              orderStatus:newStatus,
              [newStatus+"Date"]:newStatusDate,
              [newStatus+"User"]:newStatusUser,
              orderInvoiceStatus:newOrderInvoiceSatus,
              shippedUser:'',
              shippedDate:'',
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
          }
          else {
            this.saveToOp({
              id,
              orderStatus:newStatus,
              shippedDate:newShippedDate,
              shippedUser:newStatusUser,
              orderInvoiceStatus:newOrderInvoiceSatus
            })
            /* this.$store.dispatch('orderedProduct/set', {
              id,
              orderStatus:newStatus,
              shippedDate:newShippedDate,
              shippedUser:newStatusUser,
              orderInvoiceStatus:newOrderInvoiceSatus
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
          }
          
        }
        // INVOICE STATUS
        else if(whichStatus === 'orderInvoiceStatus'){
          var newInvoiceDate = ""
          if (newStatus === "invoiced")  {
            //newInvoiceDate = new Date().toISOString().substr(0, 10)
            newInvoiceDate = firebase.firestore.Timestamp.fromDate(new Date());
          }
          else  {
            newInvoiceDate = ""
            newStatusUser = ""
          }
          this.saveToOp({
            id,
            whenToInvoice:newInvoiceDate,
            whenToInvoiceUser:newStatusUser,
            orderInvoiceStatus:newStatus,
          })  
          /* this.$store.dispatch('orderedProduct/set', {
            id,
            whenToInvoice:newInvoiceDate,
            whenToInvoiceUser:newStatusUser,
            orderInvoiceStatus:newStatus,
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }

        var name = p.name.fi + " - " + this.createVariationName(pv)
        var oId = op.orderId
        var opId = op.id
        var copyOfLogs = []
        if(this.ordersAll[oId].activityLog){
          copyOfLogs = JSON.parse(JSON.stringify(this.ordersAll[oId].activityLog))
        }
        await this.timer(1100);
        console.log({orderStatus,newStatus})
        if(whichStatus === 'orderStatus') this.logToOrderHistory(this.user,copyOfLogs,oId,opId,name,whichStatus,orderStatus,newStatus)
        else if(whichStatus === 'orderInvoiceStatus') this.logToOrderHistory(this.user,copyOfLogs,oId,opId,name,whichStatus,orderInvoiceStatus,newStatus)
      },
      /* productVariationUpdate (opId,field,value) {
        if(field === 'productVariationId'){
          var newProductId = this.productVariations[value].productId
          console.log({opId,productVariationId:value,newProductId})
          if(this.offerOrders[this.selectedOrderId]){
            console.log("HERE IN OFFER ORDERS")
            var db = firebase.firestore();
            const created_at = firebase.firestore.Timestamp.now(); 
            const opRef = db.collection('orderedProducts').doc(opId).set({
              productId:newProductId,
              productVariationId:value
            }, { merge: true })
            
            console.log(`Ordered product ${opId} added to offer order ${this.newOrderedProductModalOrderId}`)
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          }
          else {
            console.log("HERE IN NORMAL ORDERS")
            this.$store.dispatch('orderedProduct/set', {
              id:opId,
              productId:newProductId,
              productVariationId:value
            })
            var env = this.settings.env
            if(this.location === 'orders' && this.selectedOrderId && this.selectedOrder && (env === 'development' && this.selectedOrder.netvisorId_test_env) || (env === 'production' && this.selectedOrder.netvisorId)){
              this.syncOrderToNetvisor(this.selectedOrderId,env)
            }
            else {
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }
          }
        }
      } */
    },
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/OrderExpand.vue